/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Api
 * OpenAPI spec version: 0.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';
import { customAxios } from './custom-axios';
import type { ErrorType } from './custom-axios';
export interface ApiResponseDto {
  data: Object;
  meta?: Object;
}
export interface DefaultResponseDto {
  result: string;
}
export interface ApiErrorResponseDto {
  message: string;
  statusCode: number;
  error: ErrorDto;
}
export interface ApiError {
  [key: string]: unknown;
}
export interface PreSignedFieldsResponseDto {
  bucket: string;
  key: string;
  'X-Amz-Algorithm': string;
  'X-Amz-Credential': string;
  'X-Amz-Date': string;
  Policy: string;
  'X-Amz-Signature': string;
  'X-Amz-Security-Token'?: string;
}
export interface UploadDto {
  id: string;
  bucket: string;
  mediaType?: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  size?: number;
  fields: PreSignedFieldsResponseDto;
}
export interface CreatePresignedUrlResponseDto {
  upload: UploadDto;
  url: string;
}
export interface CreatePresignedUrlApiResponseDto {
  data: CreatePresignedUrlResponseDto;
}
export interface TokenExpiredError {
  [key: string]: unknown;
}
export interface JsonWebTokenError {
  [key: string]: unknown;
}
export type CreatePreSignedUrlDtoNamespace =
  (typeof CreatePreSignedUrlDtoNamespace)[keyof typeof CreatePreSignedUrlDtoNamespace];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePreSignedUrlDtoNamespace = {
  ADMIN: 'ADMIN',
  NEEDS: 'NEEDS',
  RAFFLES: 'RAFFLES'
} as const;
export interface CreatePreSignedUrlDto {
  fileName: string;
  mimeType: string;
  namespace: CreatePreSignedUrlDtoNamespace;
}
export interface AuthTokens {
  accessToken: string;
  refreshToken?: string;
  idToken?: string;
}
export interface AuthTokensResponseDto {
  tokens: AuthTokens;
}
export interface OTPSendResponseDto {
  tokens: AuthTokens;
}
export interface AuthSignupAbortedError {
  [key: string]: unknown;
}
export interface AuthSignupError {
  [key: string]: unknown;
}
export interface AuthSignupInitialRequestAbortedError {
  [key: string]: unknown;
}
export interface OTPFailedToSendVerificationCodeError {
  [key: string]: unknown;
}
export interface IdentityConfirmationCodeExpired {
  [key: string]: unknown;
}
export interface ProfileDto {
  firstName: string;
  lastName: string;
}
export interface AuthSignupDto {
  profile: ProfileDto;
  identifier: unknown;
}
export interface AuthSignupConfirmationError {
  [key: string]: unknown;
}
export interface IdentityConfirmationCodeNotFound {
  [key: string]: unknown;
}
export interface IdentityConfirmationSignatureInvalid {
  [key: string]: unknown;
}
export interface AuthSignupConfirmationDto {
  phone: string;
  code: string;
  signature?: string;
}
export interface OTPSendRequestDto {
  phone: string;
}
export interface OTPVerifyResponseDto {
  tokens: AuthTokens;
}
export interface OTPFailedToVerifyCodeError {
  [key: string]: unknown;
}
export interface OTPVerifyRequestDto {
  /**
   * @minLength 1
   * @maxLength 6
   * @pattern ^[-+]?[0-9]+$
   */
  code: string;
}
export interface DefaultDto {
  result: boolean;
}
export interface GrantAdminRoleDto {
  phone: string;
}
export interface EntityNotFoundError {
  [key: string]: unknown;
}
export type PointsResetRequestDtoObjectType =
  (typeof PointsResetRequestDtoObjectType)[keyof typeof PointsResetRequestDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsResetRequestDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface PointsResetRequestDto {
  phone: string;
  objectType?: PointsResetRequestDtoObjectType;
  completedChallenges: boolean;
  points: boolean;
  activity: boolean;
  todayOnly?: boolean;
}
export interface AlterPointsRequestDto {
  phone: string;
  amount: number;
}
export type PointsBreakdownChallengeDtoObjectType =
  (typeof PointsBreakdownChallengeDtoObjectType)[keyof typeof PointsBreakdownChallengeDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsBreakdownChallengeDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export type PointsBreakdownChallengeDtoStructure =
  (typeof PointsBreakdownChallengeDtoStructure)[keyof typeof PointsBreakdownChallengeDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsBreakdownChallengeDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface PointsBreakdownChallengeDto {
  id: string;
  amount: number;
  points: number;
  level: number;
  tagline: string;
  objectType: PointsBreakdownChallengeDtoObjectType;
  structure?: PointsBreakdownChallengeDtoStructure;
  progress: number;
}
export type PointsBreakdownChallengeInfoDtoObjectType =
  (typeof PointsBreakdownChallengeInfoDtoObjectType)[keyof typeof PointsBreakdownChallengeInfoDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsBreakdownChallengeInfoDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export type PointsBreakdownChallengeInfoDtoStructure =
  (typeof PointsBreakdownChallengeInfoDtoStructure)[keyof typeof PointsBreakdownChallengeInfoDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsBreakdownChallengeInfoDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface PointsBreakdownChallengeInfoDto {
  next?: PointsBreakdownChallengeDto;
  id: string;
  amount: number;
  points: number;
  level: number;
  tagline: string;
  objectType: PointsBreakdownChallengeInfoDtoObjectType;
  structure?: PointsBreakdownChallengeInfoDtoStructure;
  progress: number;
}
export type PointsBreakdownDtoObjectType =
  (typeof PointsBreakdownDtoObjectType)[keyof typeof PointsBreakdownDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsBreakdownDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface PointsBreakdownDto {
  points: number;
  objectType: PointsBreakdownDtoObjectType;
  objectId?: string;
  challenge?: PointsBreakdownChallengeInfoDto;
}
export interface ChallengesStreakDataDto {
  currentStreak: number;
  streakDeadline: string;
}
export type CompletedPointsDetailsDtoStructuresItem =
  (typeof CompletedPointsDetailsDtoStructuresItem)[keyof typeof CompletedPointsDetailsDtoStructuresItem];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompletedPointsDetailsDtoStructuresItem = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface CompletedPointsDetailsDto {
  totalPoints: number;
  structures?: CompletedPointsDetailsDtoStructuresItem[];
  breakdown: PointsBreakdownDto[];
  challenges?: PointsBreakdownChallengeInfoDto[];
  challengesInProgress?: PointsBreakdownChallengeInfoDto[];
  streak: ChallengesStreakDataDto;
  id?: string;
  eventId?: string;
}
export interface PointsAwardedResponseDto {
  points: CompletedPointsDetailsDto;
}
export interface PointsAwardNeedRequestDto {
  amount: number;
  id?: string;
  phone: string;
}
export interface PointsAwardRequestDto {
  id?: string;
  phone: string;
}
export interface PointsAwardStreakDto {
  phone: string;
  activityAmount?: number;
  anchorDate?: string;
  backFillOnly?: boolean;
}
export type MeDtoRolesItem =
  (typeof MeDtoRolesItem)[keyof typeof MeDtoRolesItem];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeDtoRolesItem = {
  SUPERADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN',
  USER: 'USER',
  PARTNER: 'PARTNER'
} as const;
export interface MeDto {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  zipCode?: string;
  /** @pattern \d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d.\d+Z? */
  birthDate?: string;
  phone: string;
  roles: MeDtoRolesItem[];
  totalPoints?: number;
  streakData: ChallengesStreakDataDto;
  createdAt: Date;
}
export interface UpdateMeResponseDto {
  user: MeDto;
  points: CompletedPointsDetailsDto;
}
export interface UpdateMeDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  zipCode?: string;
  /** @pattern \d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d.\d+Z? */
  birthDate?: string;
  fcmToken?: string;
}
export type ShareContentRequestDtoObjectType =
  (typeof ShareContentRequestDtoObjectType)[keyof typeof ShareContentRequestDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareContentRequestDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface ShareContentRequestDto {
  objectType: ShareContentRequestDtoObjectType;
  objectId: string;
}
export interface DonationHistoryNeedDto {
  id: string;
  title: string;
  description: string;
}
export interface DonationHistoryDto {
  id: string;
  price: string;
  createdAt: string;
  need: DonationHistoryNeedDto;
}
export interface GetDonationHistoryDataDto {
  donations: DonationHistoryDto[];
}
export interface GetDonationHistoryQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface OffsetPaginationResponseDto {
  currentPage: number;
  previousPage?: number;
  nextPage?: number;
  lastPage: number;
  perPage: number;
  total: number;
}
export interface FilterPaginationDto {
  query?: string;
}
export type SortingPaginationDtoField =
  (typeof SortingPaginationDtoField)[keyof typeof SortingPaginationDtoField];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortingPaginationDtoField = {
  createdAt: 'createdAt',
  shippingFirstName: 'shippingFirstName'
} as const;
export type SortingPaginationDtoDirection =
  (typeof SortingPaginationDtoDirection)[keyof typeof SortingPaginationDtoDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortingPaginationDtoDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export interface SortingPaginationDto {
  field?: SortingPaginationDtoField;
  direction?: SortingPaginationDtoDirection;
}
export interface GetDonationHistoryMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface UserListItemDto {
  id: string;
  phone: string;
  firstName: string;
  lastName: string;
  email: string;
  currentGoodPoints: number;
  streak: ChallengesStreakDataDto;
}
export interface GetUsersDataDto {
  users: UserListItemDto[];
}
export interface GetUsersQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetUsersMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface DateDisplayDto {
  months: string;
  dates: string;
  days: string;
  times: string;
  isOngoing: boolean;
}
export interface EventDateDto {
  doorsAt: string;
  startsAt: string;
  endsAt: string;
}
export interface EventDto {
  id: string;
  objectId: string;
  title: string;
  subtitle: string;
  eventNumber: number;
  locationName: string;
  dateInfo: string;
  isActive?: boolean;
  isPublished?: boolean;
  clientName: string;
  categoryName: string;
  urlKey: string;
  clientKey?: string;
  culture?: string;
  dateInfoList?: string[];
  soldOut?: boolean;
  isSticky?: boolean;
  isAssigned?: boolean;
  sessionCount?: number;
  dateDisplay?: DateDisplayDto;
  latitude?: number;
  longitude?: number;
  mapUrl?: string;
  promoImageUrl?: string;
  categoryId?: number;
  spotsRemaining?: number;
  spotsTaken?: number;
  showRemaining?: boolean;
  remainingText?: string;
  verbiage?: string;
  dates?: EventDateDto[];
  alternateTitle?: string;
  timeZoneId?: string;
  areaName?: string;
  areaKey?: string;
  paymentProfileId?: string;
  acctCode?: string;
  isHidden?: boolean;
  isFlexPass?: boolean;
  clientIsDemo?: boolean;
  useMap?: boolean;
  street?: string;
  city?: string;
  region?: string;
  country?: string;
  postalCode?: string;
  locationDetails?: string;
  mapAddress?: string;
  address?: string;
  location?: string;
  showSoldOut?: boolean;
  currency?: string;
  facebookUrl?: string;
  titleInfo?: string;
  overallCapacity?: number;
  isSoldOut?: boolean;
  startsAt?: string;
  doorsAt?: string;
  endsAt?: string;
  hasParent?: boolean;
  venueImage?: string;
  eventInfoTop?: string;
  eventInfoBottom?: string;
  stickyInfo?: string;
  eventCode?: string;
  contactPhone?: string;
  contactEmail?: string;
  website?: string;
  createdAt?: string;
  seasonRunAt?: string;
  isSeasonMaster?: boolean;
  isSeasonChild?: boolean;
  isSeasonRunImmediate?: boolean;
  appImageUrl?: string;
  streamUrl?: string;
  showStage?: boolean;
  attendeeChanges?: string;
  isTimeSlot?: boolean;
  addonTitle?: string;
  registered?: boolean;
  bookmarked?: boolean;
}
export interface GetEventsDataDto {
  events: EventDto[];
}
export type GetEventsQueryDtoLocation =
  (typeof GetEventsQueryDtoLocation)[keyof typeof GetEventsQueryDtoLocation];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsQueryDtoLocation = {
  houston: 'houston',
  miami: 'miami',
  los_angeles: 'los_angeles',
  '': ''
} as const;
export type GetEventsQueryDtoSortBy =
  (typeof GetEventsQueryDtoSortBy)[keyof typeof GetEventsQueryDtoSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsQueryDtoSortBy = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const;
export type GetEventsQueryDtoSortDirection =
  (typeof GetEventsQueryDtoSortDirection)[keyof typeof GetEventsQueryDtoSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsQueryDtoSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export interface GetEventsQueryDto {
  location?: GetEventsQueryDtoLocation;
  /** @minimum 1 */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  perPage?: number;
  q?: string;
  sortBy?: GetEventsQueryDtoSortBy;
  sortDirection?: GetEventsQueryDtoSortDirection;
}
export interface EventsFilterDto {
  query?: string;
  location?: string;
}
export interface GetEventsMetaDto {
  filter?: EventsFilterDto;
  pagination: OffsetPaginationResponseDto;
  sort: SortingPaginationDto;
}
export interface GetEventResponseDto {
  event: EventDto;
}
export interface RegisterForEventResponseDto {
  id: string;
  points: CompletedPointsDetailsDto;
}
export interface AttendEventResponseDto {
  id: string;
  points: CompletedPointsDetailsDto;
}
export interface LocationCountDto {
  key: string;
  displayName: string;
  eventCount: number;
}
export interface GetLocationsDataDto {
  locations: LocationCountDto[];
}
export interface BrushfireAttendeeDataDto {
  /** @minLength 1 */
  'Phone Number': string;
  'Event Number': number;
  'Checked in @ Main Event Check-in'?: string;
  'Event Info'?: string;
  'Event Acct Code'?: string;
  'Event Title'?: string;
  'Event Location Name'?: string;
  'Event Location Address'?: string;
  'Event Date Info'?: string;
  'Event Client Key'?: string;
  'Event URL Key'?: string;
  'Event Organizer Phone'?: string;
  'Event Organizer Email'?: string;
  'Attendee Id'?: string;
  'Attendee Number'?: number;
  'Attendee Code'?: string;
  'Attendee Status'?: string;
  Completed?: boolean;
  'Pre-Registered'?: boolean;
  Gift?: boolean;
  'Gift Recipient Email'?: string;
  'Gift Date'?: string;
  Printed?: boolean;
  'Type Name'?: string;
  'Type Acct Code'?: string;
  'Type Amount'?: string;
  'Attendee Amount'?: string;
  'Addons Amount'?: string;
  'Discount Amount'?: string;
  'Fee Amount'?: string;
  'Tax Amount'?: string;
  'Delivery Amount'?: string;
  'Attendee Total'?: string;
  'Outstanding Balance'?: string;
  'Promotions Applied'?: string;
  'Promotion Amount'?: string;
  'Order Number'?: string;
  'Order Id'?: string;
  'Order Date'?: string;
  'Order Attendee Count'?: number;
  'Order Name (Combined)'?: string;
  'Order Name (First)'?: string;
  'Order Name (Last)'?: string;
  'Order Organization'?: string;
  'Order Address (Combined)'?: string;
  'Order Address (Street1)'?: string;
  'Order Address (Street2)'?: string;
  'Order Address (City)'?: string;
  'Order Address (Region)'?: string;
  'Order Address (RegionName)'?: string;
  'Order Address (PostalCode)'?: string;
  'Order Address (Country)'?: string;
  'Order Address (CountryName)'?: string;
  'Order Phone'?: string;
  'Order Email'?: string;
  'Order Delivery Method'?: string;
  'Order Payment Method'?: string;
  'Order Notes'?: string;
  'Order Via Kiosk'?: boolean;
  'Order Via API'?: boolean;
  'Order Placed By'?: string;
  'Order User Name'?: string;
  'Last Modified'?: string;
  'Type Custom 1'?: string;
  'Type Custom 2'?: string;
  'Type Custom 3'?: string;
  GeneratesTicket?: boolean;
  ExternalId?: string;
  'External Description'?: string;
  'Order Paid In Full'?: boolean;
  'Order Total'?: string;
  'Name (First)'?: string;
  'Name (Combined)'?: string;
  'Name (Last)'?: string;
  Email?: string;
  'Address (Street1)'?: string;
  'Address (Combined)'?: string;
  'Address (Street2)'?: string;
  'Address (City)'?: string;
  'Address (Region)'?: string;
  'Address (RegionName)'?: string;
  'Address (PostalCode)'?: string;
  'Address (Country)'?: string;
  'Address (CountryName)'?: string;
  'Do you need a copy of the book?'?: string;
  'Phone Number Field Label'?: string;
  'Name Field Label (First)'?: string;
  'Name Field Label (Combined)'?: string;
  'Name Field Label (Last)'?: string;
  'Email Field Label'?: string;
}
export interface BrushfireWebhookDto {
  /** @minLength 1 */
  Id: string;
  /** @minLength 1 */
  Type: string;
  /** @minLength 1 */
  SentAt: string;
  Data: BrushfireAttendeeDataDto;
}
export interface EventCreatedDataDto {
  EventNumber: number;
  /** @minLength 1 */
  Id: string;
  /** @minLength 1 */
  Title: string;
  Subtitle?: string;
  /** @minLength 1 */
  LocationName: string;
  /** @minLength 1 */
  ClientName: string;
  /** @minLength 1 */
  ClientKey: string;
  /** @minLength 1 */
  CategoryName: string;
  /** @minLength 1 */
  UrlKey: string;
  IsPublished: boolean;
  IsDeleted: boolean;
  IsHidden: boolean;
  CreatedAt?: string;
  ContactEmail?: string;
  ContactPhone?: string;
  EventCode?: string;
  OverallCapacity?: number;
  Street?: string;
  City?: string;
  Region?: string;
  Country?: string;
  PostalCode?: string;
  TimeZoneId?: string;
  Culture?: string;
  AttendeeTypes?: string[];
  Fields?: string[];
  PaymentGatewayName?: string;
  IsSticky?: boolean;
  IsAssigned?: boolean;
  CategoryId?: number;
  LocationDetails?: string;
  MapAddress?: string;
  Coordinates?: string;
  MapUrl?: string;
  PromoImageUrl?: string;
  PaymentProfileId?: string;
  AcctCode?: string;
  Address?: string;
  Location?: string;
  TitleInfo?: string;
  SoldOut?: boolean;
  IsDraft?: boolean;
  IsFlexPass?: boolean;
  IsTimeSlot?: boolean;
  IsCapacityManaged?: boolean;
  AttendeeChanges?: string;
}
export interface EventCreatedWebhookDto {
  /** @minLength 1 */
  Id: string;
  /** @minLength 1 */
  Type: string;
  /** @minLength 1 */
  SentAt: string;
  Data: EventCreatedDataDto;
}
export interface RemoveUserDto {
  /**
   * @minLength 1
   * @pattern ^\+?[1-9]\d{1,14}$
   */
  phone: string;
}
export interface SendEventAttendeeRequestDto {
  phone: string;
  eventId: string;
}
export type PaymentsMobileConfirmPaymentIntentResponseDtoStatus =
  (typeof PaymentsMobileConfirmPaymentIntentResponseDtoStatus)[keyof typeof PaymentsMobileConfirmPaymentIntentResponseDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsMobileConfirmPaymentIntentResponseDtoStatus = {
  REQUIRES_PAYMENT_METHOD: 'REQUIRES_PAYMENT_METHOD',
  REQUIRES_CONFIRMATION: 'REQUIRES_CONFIRMATION',
  REQUIRES_ACTION: 'REQUIRES_ACTION',
  PROCESSING: 'PROCESSING',
  REQUIRES_CAPTURE: 'REQUIRES_CAPTURE',
  CANCELED: 'CANCELED',
  SUCCEEDED: 'SUCCEEDED'
} as const;
export interface PaymentsMobileConfirmPaymentIntentResponseDto {
  status: PaymentsMobileConfirmPaymentIntentResponseDtoStatus;
  points?: CompletedPointsDetailsDto;
}
export type StripeConfirmPaymentIntentErrorKind =
  (typeof StripeConfirmPaymentIntentErrorKind)[keyof typeof StripeConfirmPaymentIntentErrorKind];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeConfirmPaymentIntentErrorKind = {
  invalid_payment_intent: 'invalid_payment_intent',
  already_confirmed: 'already_confirmed',
  invalid_product_selection: 'invalid_product_selection'
} as const;
export interface StripeConfirmPaymentIntentError {
  kind: StripeConfirmPaymentIntentErrorKind;
}
export interface PaymentsMobileConfirmPaymentIntentRequest {
  paymentIntentId: string;
}
export interface PaymentsMobilePaymentSheetResponseDto {
  paymentIntent: string;
  ephemeralKey: string;
  customerId: string;
  publishableKey: string;
}
export interface PaymentSheetItemDto {
  productId: string;
  quantity: number;
}
export interface PaymentsMobilePaymentSheetRequestDto {
  items: PaymentSheetItemDto[];
}
export interface OrganizationDto {
  id: string;
  name: string;
}
export interface GetOrganizationsDataDto {
  organizations: OrganizationDto[];
}
export interface GetOrganizationsMetaDto {
  pagination: OffsetPaginationResponseDto;
  sort: SortingPaginationDto;
}
export interface GetOrganizationsResponseDto {
  data: GetOrganizationsDataDto;
  meta?: GetOrganizationsMetaDto;
}
export interface GetOrganizationsQueryDto {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetOrganizationResponseDto {
  data: OrganizationDto;
}
export interface CreateOrganizationDto {
  /** @minLength 1 */
  name: string;
}
export interface UpdateOrganizationDto {
  /** @minLength 1 */
  name?: string;
}
export interface PresignedUrlResponseDto {
  url: string;
}
export interface NeedDetailsDto {
  id: string;
  organization: OrganizationDto;
  amountBought: number;
  productId: string;
  thumbnailId: string;
  videoId?: string;
  thumbnailUrl: PresignedUrlResponseDto;
  videoUrl?: PresignedUrlResponseDto;
  bookmarked: boolean;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  points: number;
  amountRequested: number;
  price: string;
  partner?: string;
  testimonial?: string;
  testimonialAuthor?: string;
  startDate?: string;
  endDate?: string;
}
export interface GetNeedsDataDto {
  needs: NeedDetailsDto[];
}
export interface GetNeedsQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetNeedsMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetNeedResponseDto {
  need: NeedDetailsDto;
}
export interface CreateNeedDto {
  thumbnailId: string;
  videoId?: string;
  organizationId: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  points: number;
  amountRequested: number;
  price: string;
  partner?: string;
  testimonial?: string;
  testimonialAuthor?: string;
  startDate?: string;
  endDate?: string;
}
export interface UpdateNeedDto {
  thumbnailId?: string;
  videoId?: string;
  organizationId?: string;
  /** @minLength 1 */
  title?: string;
  /** @minLength 1 */
  description?: string;
  points?: number;
  amountRequested?: number;
  price?: string;
  partner?: string;
  testimonial?: string;
  testimonialAuthor?: string;
  startDate?: string;
  endDate?: string;
}
export interface GoodVibeDetailsDto {
  id: string;
  /** @minLength 1 */
  author: string;
  /** @minLength 1 */
  quote: string;
  viewableOn?: string;
}
export interface GetGoodVibesDataDto {
  goodVibes: GoodVibeDetailsDto[];
}
export interface GetGoodVibesQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetGoodVibesMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetGoodVibeResponseDto {
  goodVibe: GoodVibeDetailsDto;
}
export interface CreateGoodVibeDto {
  viewableOn?: string;
  /** @minLength 1 */
  author: string;
  /** @minLength 1 */
  quote: string;
}
export interface UpdateGoodVibeDto {
  viewableOn?: string;
  /** @minLength 1 */
  author?: string;
  /** @minLength 1 */
  quote?: string;
}
export interface GetCurrentGoodVibeResponseDto {
  goodVibe: GoodVibeDetailsDto;
}
export interface SetNextDayGoodVibeResponseDto {
  goodVibe: GoodVibeDetailsDto;
}
export interface SetNextDateGoodVibeRequestDto {
  date: string;
}
export interface CompletedGoodVibeResponseDto {
  id: string;
  points: CompletedPointsDetailsDto;
}
export interface ResetCurrentGoodVibeResponseDto {
  [key: string]: unknown;
}
export interface CompletedDailyGoodResponseDto {
  id: string;
  points: CompletedPointsDetailsDto;
}
export interface DailyGoodDetailsDto {
  id: string;
  createdAt: string;
  updatedAt?: string;
  /**
   * @minimum 1
   * @maximum 5
   */
  difficulty?: number;
  points?: number;
  viewableOn?: string;
  /** @minLength 1 */
  description: string;
}
export interface GetDailyGoodsDataDto {
  dailyGoods: DailyGoodDetailsDto[];
}
export interface GetDailyGoodsQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetDailyGoodsMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetDailyGoodResponseDto {
  dailyGood: DailyGoodDetailsDto;
}
export interface CreateDailyGoodDto {
  description: string;
  points?: number;
  difficulty?: number;
  viewableOn?: string;
}
export interface UpdateDailyGoodDto {
  /** @minLength 1 */
  description?: string;
  points?: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  difficulty?: number;
  viewableOn?: string;
}
export interface ResetCurrentDailyGoodResponseDto {
  [key: string]: unknown;
}
export type RaffleDetailsDtoStatus =
  (typeof RaffleDetailsDtoStatus)[keyof typeof RaffleDetailsDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RaffleDetailsDtoStatus = {
  OPENED: 'OPENED',
  CLOSED: 'CLOSED'
} as const;
export interface RaffleDetailsDto {
  id: string;
  thumbnailId: string;
  thumbnailUrl: PresignedUrlResponseDto;
  raffleImagesIds: string[];
  additionalImageUrls: PresignedUrlResponseDto[];
  entered?: boolean;
  bookmarked: boolean;
  status: RaffleDetailsDtoStatus;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  pointsCost: number;
  subtitle: string;
  prizes: string;
  date: string;
}
export interface GetRafflesDataDto {
  raffles: RaffleDetailsDto[];
}
export interface GetRafflesQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetRafflesMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetRaffleResponseDto {
  raffle: RaffleDetailsDto;
}
export interface CreateRaffleDto {
  thumbnailId: string;
  raffleImagesIds?: string[];
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  pointsCost: number;
  subtitle: string;
  prizes: string;
  date: string;
}
export interface UpdateRaffleDto {
  thumbnailId?: string;
  raffleImagesIds?: string[];
  /** @minLength 1 */
  title?: string;
  /** @minLength 1 */
  description?: string;
  pointsCost?: number;
  subtitle?: string;
  prizes?: string;
  date?: string;
}
export interface ProfileDetailsDto {
  firstName: string;
  lastName: string;
  email?: string;
  userId: string;
}
export interface UserDetailsDto {
  id: string;
  phone: string;
  profile?: ProfileDetailsDto;
}
export interface RaffleEntryDetailsDto {
  id: string;
  raffleId: string;
  userId: string;
  pointsSpent: number;
  createdAt: string;
  raffle: RaffleDetailsDto;
  user: UserDetailsDto;
  winner?: boolean;
}
export interface EnterRaffleResponseDto {
  entry: RaffleEntryDetailsDto;
}
export interface InsufficientPointsError {
  [key: string]: unknown;
}
export interface GetMyRafflesDataDto {
  raffleEntries: RaffleEntryDetailsDto[];
}
export interface GetMyRafflesQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetMyRafflesMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetRaffleParticipantsDataDto {
  participants: RaffleEntryDetailsDto[];
}
export interface GetRaffleParticipantsQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetRaffleParticipantsMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface CloseRaffleAndPickWinnerResponseDto {
  winners: ProfileDetailsDto[];
}
export interface InvalidOperationError {
  [key: string]: unknown;
}
export interface CloseRaffleAndPickWinnerRequestDto {
  amount?: number;
}
export interface MerchandiseDetailsDto {
  id: string;
  thumbnailId: string;
  thumbnailUrl: PresignedUrlResponseDto;
  additionalImageUrls: PresignedUrlResponseDto[];
  merchandiseImagesIds: string[];
  bookmarked: boolean;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  subtitle: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  productDetails: string;
  sizes?: string;
  quantity?: number;
  pointsCost: number;
}
export interface GetMerchandisesDataDto {
  merchandises: MerchandiseDetailsDto[];
}
export interface GetMerchandisesQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetMerchandisesMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetMerchandiseResponseDto {
  merchandise: MerchandiseDetailsDto;
}
export interface CreateMerchandiseDto {
  thumbnailId: string;
  merchandiseImagesIds?: string[];
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  subtitle: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  productDetails: string;
  sizes?: string;
  quantity?: number;
  pointsCost: number;
}
export interface UpdateMerchandiseDto {
  thumbnailId?: string;
  merchandiseImagesIds?: string[];
  /** @minLength 1 */
  title?: string;
  /** @minLength 1 */
  subtitle?: string;
  /** @minLength 1 */
  description?: string;
  /** @minLength 1 */
  productDetails?: string;
  sizes?: string;
  quantity?: number;
  pointsCost?: number;
}
export type OrderDetailsDtoStatus =
  (typeof OrderDetailsDtoStatus)[keyof typeof OrderDetailsDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDetailsDtoStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED'
} as const;
export type OrderDetailsDtoUpdatedAt = string | string;
export type OrderDetailsDtoProcessedAt = string | string;
export type OrderDetailsDtoShippedAt = string | string;
export type OrderDetailsDtoDeliveredAt = string | string;
export interface OrderDetailsDto {
  user: UserDetailsDto;
  merchandise: MerchandiseDetailsDto;
  id: string;
  orderNumber: string;
  userId: string;
  merchandiseId: string;
  pointsCost: number;
  size?: string;
  quantity: number;
  status: OrderDetailsDtoStatus;
  shippingFirstName: string;
  shippingLastName: string;
  shippingEmail: string;
  shippingPhone: string;
  shippingStreet: string;
  shippingUnit?: string;
  shippingCity: string;
  shippingState: string;
  shippingZipCode: string;
  customerNotes?: string;
  adminNotes?: string;
  trackingNumber?: string;
  pointsTransactionId?: string;
  createdAt: string;
  updatedAt?: OrderDetailsDtoUpdatedAt;
  processedAt?: OrderDetailsDtoProcessedAt;
  shippedAt?: OrderDetailsDtoShippedAt;
  deliveredAt?: OrderDetailsDtoDeliveredAt;
}
export interface GetOrdersDataDto {
  orders: OrderDetailsDto[];
}
export interface GetOrdersQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetOrdersMetaDto {
  status?: string;
  userId?: string;
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetOrderResponseDto {
  order: OrderDetailsDto;
}
export interface CompleteOrderDto {
  merchandiseId: string;
  size?: string;
  quantity: number;
  shippingFirstName: string;
  shippingLastName: string;
  shippingEmail: string;
  shippingPhone: string;
  shippingStreet: string;
  shippingUnit?: string;
  shippingCity: string;
  shippingState: string;
  shippingZipCode: string;
  customerNotes?: string;
}
/**
 * @minLength 1
 */
export type UpdateOrderStatusDtoStatus =
  (typeof UpdateOrderStatusDtoStatus)[keyof typeof UpdateOrderStatusDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderStatusDtoStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED'
} as const;
export interface UpdateOrderStatusDto {
  /** @minLength 1 */
  status: UpdateOrderStatusDtoStatus;
  adminNotes?: string;
  trackingNumber?: string;
}
export type ChallengeDetailDtoObjectType =
  (typeof ChallengeDetailDtoObjectType)[keyof typeof ChallengeDetailDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeDetailDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export type ChallengeDetailDtoStructure =
  (typeof ChallengeDetailDtoStructure)[keyof typeof ChallengeDetailDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeDetailDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface ChallengeDetailDto {
  thumbnailUrl?: PresignedUrlResponseDto;
  id: string;
  tagline: string;
  groupId: string;
  level: number;
  points: number;
  amount: number;
  objectType: ChallengeDetailDtoObjectType;
  structure?: ChallengeDetailDtoStructure;
  progress?: number;
  isCompleted?: boolean;
  completedAt?: string;
  title?: string;
  description?: string;
}
export type ChallengesByObjectTypeDtoObjectType =
  (typeof ChallengesByObjectTypeDtoObjectType)[keyof typeof ChallengesByObjectTypeDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengesByObjectTypeDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface ChallengesByObjectTypeDto {
  objectType: ChallengesByObjectTypeDtoObjectType;
  currentChallenge: ChallengeDetailDto;
}
export interface GetChallengesDataDto {
  challenges: ChallengesByObjectTypeDto[];
  challengesInProgress?: ChallengesByObjectTypeDto[];
  totalPoints: number;
  streak: ChallengesStreakDataDto;
}
export type GetChallengesQueryDtoStatus =
  (typeof GetChallengesQueryDtoStatus)[keyof typeof GetChallengesQueryDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallengesQueryDtoStatus = {
  'in-progress': 'in-progress',
  completed: 'completed'
} as const;
export interface GetChallengesQueryDto {
  status?: GetChallengesQueryDtoStatus;
}
export type ChallengeDtoObjectType =
  (typeof ChallengeDtoObjectType)[keyof typeof ChallengeDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export type ChallengeDtoStructure =
  (typeof ChallengeDtoStructure)[keyof typeof ChallengeDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface ChallengeDto {
  id: string;
  tagline: string;
  groupId: string;
  level: number;
  points: number;
  amount: number;
  objectType: ChallengeDtoObjectType;
  structure?: ChallengeDtoStructure;
  progress?: number;
  isCompleted?: boolean;
  completedAt?: string;
  title?: string;
  description?: string;
}
export type NeighborhoodStructureDtoStructure =
  (typeof NeighborhoodStructureDtoStructure)[keyof typeof NeighborhoodStructureDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NeighborhoodStructureDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export interface NeighborhoodStructureDto {
  structure: NeighborhoodStructureDtoStructure;
  challenge?: ChallengeDto;
  completed: boolean;
}
export interface GetNeighborhoodDataDto {
  structures: NeighborhoodStructureDto[];
}
export type AdminChallengeDtoStructure =
  (typeof AdminChallengeDtoStructure)[keyof typeof AdminChallengeDtoStructure];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChallengeDtoStructure = {
  SCHOOL: 'SCHOOL',
  HOUSE_A: 'HOUSE_A',
  HOUSE_B: 'HOUSE_B',
  HOUSE_C: 'HOUSE_C',
  APARTMENTS: 'APARTMENTS',
  STORE: 'STORE',
  STATUE: 'STATUE',
  FOUNTAIN: 'FOUNTAIN',
  BRIDGE: 'BRIDGE',
  LIGHTHOUSE: 'LIGHTHOUSE',
  POND: 'POND',
  STADIUM: 'STADIUM'
} as const;
export type AdminChallengeDtoObjectType =
  (typeof AdminChallengeDtoObjectType)[keyof typeof AdminChallengeDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChallengeDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface AdminChallengeDto {
  id: string;
  title?: string;
  tagline: string;
  description?: string;
  groupId: string;
  structure?: AdminChallengeDtoStructure;
  thumbnailId?: string;
  amount: number;
  level: number;
  points: number;
  objectType: AdminChallengeDtoObjectType;
  thumbnailUrl?: PresignedUrlResponseDto;
  createdAt: string;
  updatedAt: string;
}
export interface GetAdminChallengesDataDto {
  challenges: AdminChallengeDto[];
}
export interface GetAdminChallengesQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface GetAdminChallengesMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetAdminChallengeResponseDto {
  challenge: AdminChallengeDto;
}
export interface UpdateAdminChallengeDto {
  title?: string;
  tagline?: string;
  description?: string;
  points?: number;
  thumbnailId?: string;
}
export interface GetChallengeResponseDto {
  challenge: ChallengeDetailDto;
}
export type PointsConfigurationDtoObjectType =
  (typeof PointsConfigurationDtoObjectType)[keyof typeof PointsConfigurationDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsConfigurationDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export type PointsConfigurationDtoVerb =
  (typeof PointsConfigurationDtoVerb)[keyof typeof PointsConfigurationDtoVerb];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsConfigurationDtoVerb = {
  NONE: 'NONE',
  SENT: 'SENT',
  UPDATED: 'UPDATED',
  DONATION_MADE: 'DONATION_MADE',
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  SHARED: 'SHARED',
  STREAK: 'STREAK',
  ENTERED: 'ENTERED',
  STARTED: 'STARTED',
  ATTENDED: 'ATTENDED',
  WON: 'WON',
  RECEIVED: 'RECEIVED',
  ADJUSTMENT: 'ADJUSTMENT'
} as const;
export interface PointsConfigurationDto {
  objectType: PointsConfigurationDtoObjectType;
  /** @minLength 1 */
  label: string;
  value: number;
  verb: PointsConfigurationDtoVerb;
}
export interface GetPointsConfigurationsDataDto {
  configurations: PointsConfigurationDto[];
}
export interface UpdatePointsConfigurationDto {
  value: number;
}
export interface BookmarkDetailsDto {
  id: string;
  objectType: string;
  objectId: string;
  createdAt: string;
  updatedAt: string;
}
export interface CreateBookmarkResponseDto {
  bookmark: BookmarkDetailsDto;
}
export interface DeleteBookmarkResponseDto {
  bookmark: BookmarkDetailsDto;
}
export interface GetBookmarksDataDto {
  bookmarks: BookmarkDetailsDto[];
}
export interface GetBookmarksMetaDto {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface GetBookmarksResponseDto {
  data: GetBookmarksDataDto;
  meta?: GetBookmarksMetaDto;
}
export interface GetBookmarksQueryDto {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
}
export interface SendNominationResponseDto {
  /** @minLength 1 */
  url: string;
}
export interface NominationDailyLimitError {
  [key: string]: unknown;
}
export interface SentNominationHashResponseDto {
  points?: CompletedPointsDetailsDto;
}
export interface ClaimNominationResponseDto {
  id: string;
  points: CompletedPointsDetailsDto;
}
export interface NominationAlreadyClaimedError {
  [key: string]: unknown;
}
export interface SelfNominationError {
  [key: string]: unknown;
}
export interface ClaimNominationRequestDto {
  /**
   * @minLength 1
   * @maxLength 8
   */
  nominationHash: string;
}
export interface Object {
  [key: string]: unknown;
}
export interface ApiMetaDto {
  meta?: Object;
}
export interface ApiRequestDto {
  data: Object;
  meta?: Object;
}
export interface ErrorDto {
  message: string;
  code: string;
  status: number;
  context?: unknown;
  issues: Issue[];
}

export interface Issue {
  message: string;
  path: (string | number)[];
  code: string;
}

export interface OffsetPaginationQueryDto {
  /** @minimum 1 */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  perPage?: number;
}
export interface CursorPaginationQueryDto {
  /**
   * @minimum 1
   * @maximum 100
   */
  perPage?: number;
}
export interface CursorPaginationResponseDto {
  perPage: number;
}
export interface AuthForgotCredentialDto {
  email: string;
}
export interface ChangeCredentialDto {
  /** @minLength 1 */
  credential: string;
  /** @minLength 1 */
  newCredential: string;
  /** @minLength 1 */
  confirmNewCredential: string;
}
export interface ResetCredentialDto {
  /**
   * @minLength 1
   * @maxLength 6
   * @pattern ^[-+]?[0-9]+$
   */
  code: string;
  signature?: string;
  /** @minLength 1 */
  credential: string;
  /** @minLength 1 */
  confirmCredential: string;
}
export interface UploadSignatureResponseDto {
  signature: string;
  timestamp: number;
}
export interface UploadSignaturePresetRequestDto {
  transformations?: string[];
  uploadPreset: string;
}
export interface PreSignedUrlRequestDto {
  fileName: string;
  mimeType: string;
  maxFileSize?: unknown;
}
export interface PreSignedFieldsResponse {
  bucket: string;
  key: string;
  'X-Amz-Algorithm': string;
  'X-Amz-Credential': string;
  'X-Amz-Date': string;
  Policy: string;
  'X-Amz-Signature': string;
  'X-Amz-Security-Token'?: string;
  'Content-Type': string;
}
export interface QueryRequestDto {
  q?: string;
}
export type CreateBookmarkDtoObjectType =
  (typeof CreateBookmarkDtoObjectType)[keyof typeof CreateBookmarkDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBookmarkDtoObjectType = {
  EVENT: 'EVENT',
  NEED: 'NEED',
  MERCHANDISE: 'MERCHANDISE',
  RAFFLE: 'RAFFLE'
} as const;
export interface CreateBookmarkDto {
  objectType: CreateBookmarkDtoObjectType;
  objectId: string;
}
export type DeleteBookmarkDtoObjectType =
  (typeof DeleteBookmarkDtoObjectType)[keyof typeof DeleteBookmarkDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBookmarkDtoObjectType = {
  EVENT: 'EVENT',
  NEED: 'NEED',
  MERCHANDISE: 'MERCHANDISE',
  RAFFLE: 'RAFFLE'
} as const;
export interface DeleteBookmarkDto {
  objectType: DeleteBookmarkDtoObjectType;
  objectId: string;
}
export type CreateBookmarkParamsDtoObjectType =
  (typeof CreateBookmarkParamsDtoObjectType)[keyof typeof CreateBookmarkParamsDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBookmarkParamsDtoObjectType = {
  EVENT: 'EVENT',
  NEED: 'NEED',
  MERCHANDISE: 'MERCHANDISE',
  RAFFLE: 'RAFFLE'
} as const;
export interface CreateBookmarkParamsDto {
  objectType: CreateBookmarkParamsDtoObjectType;
  objectId: string;
}
export type DeleteBookmarkParamsDtoObjectType =
  (typeof DeleteBookmarkParamsDtoObjectType)[keyof typeof DeleteBookmarkParamsDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBookmarkParamsDtoObjectType = {
  EVENT: 'EVENT',
  NEED: 'NEED',
  MERCHANDISE: 'MERCHANDISE',
  RAFFLE: 'RAFFLE'
} as const;
export interface DeleteBookmarkParamsDto {
  objectType: DeleteBookmarkParamsDtoObjectType;
  objectId: string;
}
export type AbstractPaginationRequestSortBy =
  (typeof AbstractPaginationRequestSortBy)[keyof typeof AbstractPaginationRequestSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbstractPaginationRequestSortBy = {
  createdAt: 'createdAt'
} as const;
export type AbstractPaginationRequestSortDirection =
  (typeof AbstractPaginationRequestSortDirection)[keyof typeof AbstractPaginationRequestSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbstractPaginationRequestSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export interface AbstractPaginationRequest {
  q?: string;
  sortBy?: AbstractPaginationRequestSortBy;
  sortDirection?: AbstractPaginationRequestSortDirection;
  /** @minimum 1 */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  perPage?: number;
}
export type BookmarkDtoObjectType =
  (typeof BookmarkDtoObjectType)[keyof typeof BookmarkDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookmarkDtoObjectType = {
  EVENT: 'EVENT',
  NEED: 'NEED',
  MERCHANDISE: 'MERCHANDISE',
  RAFFLE: 'RAFFLE'
} as const;
export type BookmarkDtoCreatedAt = string | string;
export type BookmarkDtoUpdatedAt = string | string;
export interface BookmarkDto {
  id: string;
  objectType: BookmarkDtoObjectType;
  objectId: string;
  createdAt: BookmarkDtoCreatedAt;
  updatedAt: BookmarkDtoUpdatedAt;
}
export interface AbstractPaginationResponse {
  pagination: OffsetPaginationResponseDto;
  filter: FilterPaginationDto;
  sort: SortingPaginationDto;
}
export interface AbstractAuthSignupRequest {
  identifier: unknown;
}
export interface AuthLoginDto {
  profile: ProfileDto;
}
export interface GetChallengesResponseDto {
  data: GetChallengesDataDto;
}
export interface GetAdminChallengesResponseDto {
  data: GetAdminChallengesDataDto;
  meta?: GetAdminChallengesMetaDto;
}
export interface GetAdminChallengeParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface PointDetailsDto {
  points: number;
  breakdown: PointsBreakdownDto[];
}
export interface CompleteDailyGoodParamsDto {
  /** @minLength 1 */
  id: string;
}
export type DailyGoodDtoViewableOn = string | string;
export interface DailyGoodDto {
  /** @minLength 1 */
  description: string;
  points?: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  difficulty?: number;
  viewableOn?: DailyGoodDtoViewableOn;
}
export interface GetDailyGoodsResponseDto {
  data: GetDailyGoodsDataDto;
  meta?: GetDailyGoodsMetaDto;
}
export interface GetDailyGoodParamsDto {
  /** @minLength 1 */
  id: string;
}
export type PartialTypeClassViewableOn = string | string;
export type PartialTypeClassDate = string | string;
export type PartialTypeClassStartDate = string | string;
export type PartialTypeClassEndDate = string | string;
export interface PartialTypeClass {
  /** @minLength 1 */
  description?: string;
  points?: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  difficulty?: number;
  viewableOn?: PartialTypeClassViewableOn;
  /** @minLength 1 */
  author?: string;
  /** @minLength 1 */
  quote?: string;
  thumbnailId?: string;
  merchandiseImagesIds?: string[];
  /** @minLength 1 */
  title?: string;
  /** @minLength 1 */
  subtitle?: string;
  /** @minLength 1 */
  productDetails?: string;
  sizes?: string;
  quantity?: number;
  pointsCost?: number;
  raffleImagesIds?: string[];
  prizes?: string;
  date?: PartialTypeClassDate;
  videoId?: string;
  organizationId?: string;
  amountRequested?: number;
  price?: string;
  partner?: string;
  testimonial?: string;
  testimonialAuthor?: string;
  startDate?: PartialTypeClassStartDate;
  endDate?: PartialTypeClassEndDate;
}
export type GoodVibeDtoViewableOn = string | string;
export interface GoodVibeDto {
  /** @minLength 1 */
  author: string;
  /** @minLength 1 */
  quote: string;
  viewableOn?: GoodVibeDtoViewableOn;
}
export interface GetGoodVibesResponseDto {
  data: GetGoodVibesDataDto;
  meta?: GetGoodVibesMetaDto;
}
export interface GetGoodVibeParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface MerchandiseDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  subtitle: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  productDetails: string;
  sizes?: string;
  quantity?: number;
  pointsCost: number;
}
export interface GetMerchandisesResponseDto {
  data: GetMerchandisesDataDto;
  meta?: GetMerchandisesMetaDto;
}
export interface GetMerchandiseParamsDto {
  /** @minLength 1 */
  id: string;
}
export type RaffleDtoDate = string | string;
export interface RaffleDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  pointsCost: number;
  subtitle: string;
  prizes: string;
  date: RaffleDtoDate;
}
export interface GetRafflesResponseDto {
  data: GetRafflesDataDto;
  meta?: GetRafflesMetaDto;
}
export interface GetRaffleParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface EnterRaffleParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface GetMyRafflesResponseDto {
  data: GetMyRafflesDataDto;
  meta?: GetMyRafflesMetaDto;
}
export interface GetRaffleParticipantsParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface GetRaffleParticipantsResponseDto {
  data: GetRaffleParticipantsDataDto;
  meta?: GetRaffleParticipantsMetaDto;
}
export interface CreateOrderDto {
  /** @minLength 1 */
  merchandiseId: string;
  size?: string;
  /** @minLength 1 */
  quantity: number;
  /** @minLength 1 */
  shippingFirstName: string;
  /** @minLength 1 */
  shippingLastName: string;
  /** @minLength 1 */
  shippingEmail: string;
  /** @minLength 1 */
  shippingPhone: string;
  /** @minLength 1 */
  shippingStreet: string;
  shippingUnit?: string;
  /** @minLength 1 */
  shippingCity: string;
  /** @minLength 1 */
  shippingState: string;
  /** @minLength 1 */
  shippingZipCode: string;
  customerNotes?: string;
}
export type OrderDtoStatus =
  (typeof OrderDtoStatus)[keyof typeof OrderDtoStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDtoStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED'
} as const;
export type OrderDtoCreatedAt = string | string;
export type OrderDtoUpdatedAt = string | string;
export type OrderDtoProcessedAt = string | string;
export type OrderDtoShippedAt = string | string;
export type OrderDtoDeliveredAt = string | string;
export interface OrderDto {
  id: string;
  orderNumber: string;
  userId: string;
  merchandiseId: string;
  pointsCost: number;
  size?: string;
  quantity: number;
  status: OrderDtoStatus;
  shippingFirstName: string;
  shippingLastName: string;
  shippingEmail: string;
  shippingPhone: string;
  shippingStreet: string;
  shippingUnit?: string;
  shippingCity: string;
  shippingState: string;
  shippingZipCode: string;
  customerNotes?: string;
  adminNotes?: string;
  trackingNumber?: string;
  pointsTransactionId?: string;
  createdAt: OrderDtoCreatedAt;
  updatedAt?: OrderDtoUpdatedAt;
  processedAt?: OrderDtoProcessedAt;
  shippedAt?: OrderDtoShippedAt;
  deliveredAt?: OrderDtoDeliveredAt;
}
export interface GetOrdersResponseDto {
  data: OrderDetailsDto[];
  meta: GetOrdersMetaDto;
}
export interface GetOrderParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface GetUsersResponseDto {
  data: GetUsersDataDto;
  meta?: GetUsersMetaDto;
}
export interface GetEventsResponseDto {
  data: GetEventsDataDto;
  meta?: GetEventsMetaDto;
}
export interface GetEventParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface RegisterForEventParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface GetOrganizationParamsDto {
  /** @minLength 1 */
  id: string;
}
export type NeedDtoStartDate = string | string;
export type NeedDtoEndDate = string | string;
export interface NeedDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  points: number;
  amountRequested: number;
  price: string;
  partner?: string;
  testimonial?: string;
  testimonialAuthor?: string;
  startDate?: NeedDtoStartDate;
  endDate?: NeedDtoEndDate;
}
export interface GetNeedsResponseDto {
  data: GetNeedsDataDto;
  meta?: GetNeedsMetaDto;
}
export interface GetNeedParamsDto {
  /** @minLength 1 */
  id: string;
}
export interface TestingDto {
  needId: string;
  phone: string;
  amount: number;
}
export interface PaymentManagementResponse {
  url: string;
}
export type PaymentReconcileResponseStatus =
  (typeof PaymentReconcileResponseStatus)[keyof typeof PaymentReconcileResponseStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentReconcileResponseStatus = {} as const;
export interface PaymentReconcileResponse {
  status: PaymentReconcileResponseStatus;
}
export interface PaymentsCreateCheckoutSessionResponseDto {
  secret: string;
}
export type StripePaymentSheetErrorKind =
  (typeof StripePaymentSheetErrorKind)[keyof typeof StripePaymentSheetErrorKind];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePaymentSheetErrorKind = {
  invalid_product_count: 'invalid_product_count',
  unable_to_grant_permission: 'unable_to_grant_permission',
  unable_to_create_session: 'unable_to_create_session',
  invalid_product_selection: 'invalid_product_selection'
} as const;
export interface StripePaymentSheetError {
  kind: StripePaymentSheetErrorKind;
}
export interface GetPointsConfigurationsResponseDto {
  data: GetPointsConfigurationsDataDto;
  meta?: Object;
}
export type GetPointsConfigurationParamsDtoVerb =
  (typeof GetPointsConfigurationParamsDtoVerb)[keyof typeof GetPointsConfigurationParamsDtoVerb];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPointsConfigurationParamsDtoVerb = {
  NONE: 'NONE',
  SENT: 'SENT',
  UPDATED: 'UPDATED',
  DONATION_MADE: 'DONATION_MADE',
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  SHARED: 'SHARED',
  STREAK: 'STREAK',
  ENTERED: 'ENTERED',
  STARTED: 'STARTED',
  ATTENDED: 'ATTENDED',
  WON: 'WON',
  RECEIVED: 'RECEIVED',
  ADJUSTMENT: 'ADJUSTMENT'
} as const;
export type GetPointsConfigurationParamsDtoObjectType =
  (typeof GetPointsConfigurationParamsDtoObjectType)[keyof typeof GetPointsConfigurationParamsDtoObjectType];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPointsConfigurationParamsDtoObjectType = {
  NOMINATION: 'NOMINATION',
  PROFILE: 'PROFILE',
  NEED: 'NEED',
  EVENT: 'EVENT',
  DAILY_GOOD: 'DAILY_GOOD',
  GOOD_VIBE: 'GOOD_VIBE',
  CHALLENGE: 'CHALLENGE',
  RAFFLE: 'RAFFLE',
  CHALLENGE_GROUP: 'CHALLENGE_GROUP',
  STREAK: 'STREAK',
  STRUCTURE: 'STRUCTURE',
  SHARE: 'SHARE',
  MERCHANDISE: 'MERCHANDISE',
  NONE: 'NONE'
} as const;
export interface GetPointsConfigurationParamsDto {
  verb: GetPointsConfigurationParamsDtoVerb;
  objectType: GetPointsConfigurationParamsDtoObjectType;
}
export interface GetPointsConfigurationResponseDto {
  data: PointsConfigurationDto;
}
export interface UpdatePointsConfigurationResponseDto {
  data: PointsConfigurationDto;
}
export interface GetDonationHistoryResponseDto {
  data: GetDonationHistoryDataDto;
  meta?: GetDonationHistoryMetaDto;
}
export type GetData200 = {
  data: DefaultResponseDto;
};
export type GetData500AllOf = {
  error: ApiError;
};
export type GetData500AllOfTwoErrorCode =
  (typeof GetData500AllOfTwoErrorCode)[keyof typeof GetData500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetData500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetData500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetData500AllOfTwoErrorCode;
};
export type GetData500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetData500AllOfTwoError;
};
export type GetData500 = ApiErrorResponseDto &
  GetData500AllOf &
  GetData500AllOfTwo;
export type GetApi200 = {
  data: DefaultResponseDto;
};
export type GetApi500AllOf = {
  error: ApiError;
};
export type GetApi500AllOfTwoErrorCode =
  (typeof GetApi500AllOfTwoErrorCode)[keyof typeof GetApi500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApi500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetApi500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetApi500AllOfTwoErrorCode;
};
export type GetApi500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetApi500AllOfTwoError;
};
export type GetApi500 = ApiErrorResponseDto &
  GetApi500AllOf &
  GetApi500AllOfTwo;
export type CreatePreSignedUrl200 = {
  data: CreatePresignedUrlApiResponseDto;
};
export type CreatePreSignedUrl401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type CreatePreSignedUrl401AllOf = {
  error: CreatePreSignedUrl401AllOfError;
};
export type CreatePreSignedUrl401AllOfThreeErrorCode =
  (typeof CreatePreSignedUrl401AllOfThreeErrorCode)[keyof typeof CreatePreSignedUrl401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePreSignedUrl401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CreatePreSignedUrl401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreatePreSignedUrl401AllOfThreeErrorCode;
};
export type CreatePreSignedUrl401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreatePreSignedUrl401AllOfThreeError;
};
export type CreatePreSignedUrl401 = ApiErrorResponseDto &
  CreatePreSignedUrl401AllOf &
  CreatePreSignedUrl401AllOfThree;
export type CreatePreSignedUrl500AllOf = {
  error: ApiError;
};
export type CreatePreSignedUrl500AllOfTwoErrorCode =
  (typeof CreatePreSignedUrl500AllOfTwoErrorCode)[keyof typeof CreatePreSignedUrl500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePreSignedUrl500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreatePreSignedUrl500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreatePreSignedUrl500AllOfTwoErrorCode;
};
export type CreatePreSignedUrl500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreatePreSignedUrl500AllOfTwoError;
};
export type CreatePreSignedUrl500 = ApiErrorResponseDto &
  CreatePreSignedUrl500AllOf &
  CreatePreSignedUrl500AllOfTwo;
export type RefreshToken200 = {
  data: AuthTokensResponseDto;
};
export type RefreshToken401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type RefreshToken401AllOf = {
  error: RefreshToken401AllOfError;
};
export type RefreshToken401AllOfThreeErrorCode =
  (typeof RefreshToken401AllOfThreeErrorCode)[keyof typeof RefreshToken401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefreshToken401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type RefreshToken401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: RefreshToken401AllOfThreeErrorCode;
};
export type RefreshToken401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: RefreshToken401AllOfThreeError;
};
export type RefreshToken401 = ApiErrorResponseDto &
  RefreshToken401AllOf &
  RefreshToken401AllOfThree;
export type RefreshToken500AllOf = {
  error: ApiError;
};
export type RefreshToken500AllOfTwoErrorCode =
  (typeof RefreshToken500AllOfTwoErrorCode)[keyof typeof RefreshToken500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefreshToken500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type RefreshToken500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: RefreshToken500AllOfTwoErrorCode;
};
export type RefreshToken500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: RefreshToken500AllOfTwoError;
};
export type RefreshToken500 = ApiErrorResponseDto &
  RefreshToken500AllOf &
  RefreshToken500AllOfTwo;
export type SignUp200 = {
  data: OTPSendResponseDto;
};
export type SignUp400AllOfError =
  | AuthSignupAbortedError
  | AuthSignupError
  | AuthSignupInitialRequestAbortedError;
export type SignUp400AllOf = {
  error: SignUp400AllOfError;
};
export type SignUp400AllOfThreeErrorCode =
  (typeof SignUp400AllOfThreeErrorCode)[keyof typeof SignUp400AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUp400AllOfThreeErrorCode = {
  AuthSignupAbortedError: 'AuthSignupAbortedError',
  AuthSignupError: 'AuthSignupError',
  AuthSignupInitialRequestAbortedError: 'AuthSignupInitialRequestAbortedError'
} as const;
export type SignUp400AllOfThreeError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: SignUp400AllOfThreeErrorCode;
};
export type SignUp400AllOfThree = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: SignUp400AllOfThreeError;
};
export type SignUp400 = ApiErrorResponseDto &
  SignUp400AllOf &
  SignUp400AllOfThree;
export type SignUp410AllOf = {
  error: IdentityConfirmationCodeExpired;
};
export type SignUp410AllOfTwoErrorCode =
  (typeof SignUp410AllOfTwoErrorCode)[keyof typeof SignUp410AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUp410AllOfTwoErrorCode = {
  IdentityConfirmationCodeExpired: 'IdentityConfirmationCodeExpired'
} as const;
export type SignUp410AllOfTwoError = {
  /**
   * @minimum 410
   * @maximum 410
   */
  status: number;
  code: SignUp410AllOfTwoErrorCode;
};
export type SignUp410AllOfTwo = {
  /**
   * @minimum 410
   * @maximum 410
   */
  statusCode: number;
  error: SignUp410AllOfTwoError;
};
export type SignUp410 = ApiErrorResponseDto &
  SignUp410AllOf &
  SignUp410AllOfTwo;
export type SignUp500AllOfError =
  | OTPFailedToSendVerificationCodeError
  | ApiError;
export type SignUp500AllOf = {
  error: SignUp500AllOfError;
};
export type SignUp500AllOfThreeErrorCode =
  (typeof SignUp500AllOfThreeErrorCode)[keyof typeof SignUp500AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUp500AllOfThreeErrorCode = {
  OTPFailedToSendVerificationCodeError: 'OTPFailedToSendVerificationCodeError',
  UnexpectedError: 'UnexpectedError'
} as const;
export type SignUp500AllOfThreeError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SignUp500AllOfThreeErrorCode;
};
export type SignUp500AllOfThree = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SignUp500AllOfThreeError;
};
export type SignUp500 = ApiErrorResponseDto &
  SignUp500AllOf &
  SignUp500AllOfThree;
export type ConfirmSignUp200 = {
  data: AuthTokensResponseDto;
};
export type ConfirmSignUp400AllOfError =
  | AuthSignupConfirmationError
  | IdentityConfirmationSignatureInvalid
  | AuthSignupError;
export type ConfirmSignUp400AllOf = {
  error: ConfirmSignUp400AllOfError;
};
export type ConfirmSignUp400AllOfThreeErrorCode =
  (typeof ConfirmSignUp400AllOfThreeErrorCode)[keyof typeof ConfirmSignUp400AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmSignUp400AllOfThreeErrorCode = {
  AuthSignupConfirmationError: 'AuthSignupConfirmationError',
  IdentityConfirmationSignatureInvalid: 'IdentityConfirmationSignatureInvalid',
  AuthSignupError: 'AuthSignupError'
} as const;
export type ConfirmSignUp400AllOfThreeError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: ConfirmSignUp400AllOfThreeErrorCode;
};
export type ConfirmSignUp400AllOfThree = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: ConfirmSignUp400AllOfThreeError;
};
export type ConfirmSignUp400 = ApiErrorResponseDto &
  ConfirmSignUp400AllOf &
  ConfirmSignUp400AllOfThree;
export type ConfirmSignUp410AllOfError =
  | IdentityConfirmationCodeNotFound
  | IdentityConfirmationCodeExpired;
export type ConfirmSignUp410AllOf = {
  error: ConfirmSignUp410AllOfError;
};
export type ConfirmSignUp410AllOfThreeErrorCode =
  (typeof ConfirmSignUp410AllOfThreeErrorCode)[keyof typeof ConfirmSignUp410AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmSignUp410AllOfThreeErrorCode = {
  IdentityConfirmationCodeNotFound: 'IdentityConfirmationCodeNotFound',
  IdentityConfirmationCodeExpired: 'IdentityConfirmationCodeExpired'
} as const;
export type ConfirmSignUp410AllOfThreeError = {
  /**
   * @minimum 410
   * @maximum 410
   */
  status: number;
  code: ConfirmSignUp410AllOfThreeErrorCode;
};
export type ConfirmSignUp410AllOfThree = {
  /**
   * @minimum 410
   * @maximum 410
   */
  statusCode: number;
  error: ConfirmSignUp410AllOfThreeError;
};
export type ConfirmSignUp410 = ApiErrorResponseDto &
  ConfirmSignUp410AllOf &
  ConfirmSignUp410AllOfThree;
export type ConfirmSignUp500AllOf = {
  error: ApiError;
};
export type ConfirmSignUp500AllOfTwoErrorCode =
  (typeof ConfirmSignUp500AllOfTwoErrorCode)[keyof typeof ConfirmSignUp500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmSignUp500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ConfirmSignUp500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ConfirmSignUp500AllOfTwoErrorCode;
};
export type ConfirmSignUp500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ConfirmSignUp500AllOfTwoError;
};
export type ConfirmSignUp500 = ApiErrorResponseDto &
  ConfirmSignUp500AllOf &
  ConfirmSignUp500AllOfTwo;
export type SendOTP200 = {
  data: OTPSendResponseDto;
};
export type SendOTP500AllOfError =
  | OTPFailedToSendVerificationCodeError
  | ApiError;
export type SendOTP500AllOf = {
  error: SendOTP500AllOfError;
};
export type SendOTP500AllOfThreeErrorCode =
  (typeof SendOTP500AllOfThreeErrorCode)[keyof typeof SendOTP500AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendOTP500AllOfThreeErrorCode = {
  OTPFailedToSendVerificationCodeError: 'OTPFailedToSendVerificationCodeError',
  UnexpectedError: 'UnexpectedError'
} as const;
export type SendOTP500AllOfThreeError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SendOTP500AllOfThreeErrorCode;
};
export type SendOTP500AllOfThree = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SendOTP500AllOfThreeError;
};
export type SendOTP500 = ApiErrorResponseDto &
  SendOTP500AllOf &
  SendOTP500AllOfThree;
export type AdminOTP200 = {
  data: OTPSendResponseDto;
};
export type AdminOTP500AllOfError =
  | OTPFailedToSendVerificationCodeError
  | ApiError;
export type AdminOTP500AllOf = {
  error: AdminOTP500AllOfError;
};
export type AdminOTP500AllOfThreeErrorCode =
  (typeof AdminOTP500AllOfThreeErrorCode)[keyof typeof AdminOTP500AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminOTP500AllOfThreeErrorCode = {
  OTPFailedToSendVerificationCodeError: 'OTPFailedToSendVerificationCodeError',
  UnexpectedError: 'UnexpectedError'
} as const;
export type AdminOTP500AllOfThreeError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AdminOTP500AllOfThreeErrorCode;
};
export type AdminOTP500AllOfThree = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AdminOTP500AllOfThreeError;
};
export type AdminOTP500 = ApiErrorResponseDto &
  AdminOTP500AllOf &
  AdminOTP500AllOfThree;
export type VerifyOTP200 = {
  data: OTPVerifyResponseDto;
};
export type VerifyOTP500AllOfError = OTPFailedToVerifyCodeError | ApiError;
export type VerifyOTP500AllOf = {
  error: VerifyOTP500AllOfError;
};
export type VerifyOTP500AllOfThreeErrorCode =
  (typeof VerifyOTP500AllOfThreeErrorCode)[keyof typeof VerifyOTP500AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifyOTP500AllOfThreeErrorCode = {
  OTPFailedToVerifyCodeError: 'OTPFailedToVerifyCodeError',
  UnexpectedError: 'UnexpectedError'
} as const;
export type VerifyOTP500AllOfThreeError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: VerifyOTP500AllOfThreeErrorCode;
};
export type VerifyOTP500AllOfThree = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: VerifyOTP500AllOfThreeError;
};
export type VerifyOTP500 = ApiErrorResponseDto &
  VerifyOTP500AllOf &
  VerifyOTP500AllOfThree;
export type GrantAdmin200 = {
  data: DefaultDto;
};
export type GrantAdmin401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GrantAdmin401AllOf = {
  error: GrantAdmin401AllOfError;
};
export type GrantAdmin401AllOfThreeErrorCode =
  (typeof GrantAdmin401AllOfThreeErrorCode)[keyof typeof GrantAdmin401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GrantAdmin401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GrantAdmin401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GrantAdmin401AllOfThreeErrorCode;
};
export type GrantAdmin401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GrantAdmin401AllOfThreeError;
};
export type GrantAdmin401 = ApiErrorResponseDto &
  GrantAdmin401AllOf &
  GrantAdmin401AllOfThree;
export type GrantAdmin500AllOf = {
  error: ApiError;
};
export type GrantAdmin500AllOfTwoErrorCode =
  (typeof GrantAdmin500AllOfTwoErrorCode)[keyof typeof GrantAdmin500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GrantAdmin500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GrantAdmin500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GrantAdmin500AllOfTwoErrorCode;
};
export type GrantAdmin500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GrantAdmin500AllOfTwoError;
};
export type GrantAdmin500 = ApiErrorResponseDto &
  GrantAdmin500AllOf &
  GrantAdmin500AllOfTwo;
export type ForAnyone200 = {
  data: DefaultDto;
};
export type ForAnyone401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type ForAnyone401AllOf = {
  error: ForAnyone401AllOfError;
};
export type ForAnyone401AllOfThreeErrorCode =
  (typeof ForAnyone401AllOfThreeErrorCode)[keyof typeof ForAnyone401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForAnyone401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ForAnyone401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ForAnyone401AllOfThreeErrorCode;
};
export type ForAnyone401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ForAnyone401AllOfThreeError;
};
export type ForAnyone401 = ApiErrorResponseDto &
  ForAnyone401AllOf &
  ForAnyone401AllOfThree;
export type ForAnyone500AllOf = {
  error: ApiError;
};
export type ForAnyone500AllOfTwoErrorCode =
  (typeof ForAnyone500AllOfTwoErrorCode)[keyof typeof ForAnyone500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForAnyone500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ForAnyone500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ForAnyone500AllOfTwoErrorCode;
};
export type ForAnyone500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ForAnyone500AllOfTwoError;
};
export type ForAnyone500 = ApiErrorResponseDto &
  ForAnyone500AllOf &
  ForAnyone500AllOfTwo;
export type ForUser200 = {
  data: DefaultDto;
};
export type ForUser401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type ForUser401AllOf = {
  error: ForUser401AllOfError;
};
export type ForUser401AllOfThreeErrorCode =
  (typeof ForUser401AllOfThreeErrorCode)[keyof typeof ForUser401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForUser401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ForUser401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ForUser401AllOfThreeErrorCode;
};
export type ForUser401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ForUser401AllOfThreeError;
};
export type ForUser401 = ApiErrorResponseDto &
  ForUser401AllOf &
  ForUser401AllOfThree;
export type ForUser500AllOf = {
  error: ApiError;
};
export type ForUser500AllOfTwoErrorCode =
  (typeof ForUser500AllOfTwoErrorCode)[keyof typeof ForUser500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForUser500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ForUser500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ForUser500AllOfTwoErrorCode;
};
export type ForUser500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ForUser500AllOfTwoError;
};
export type ForUser500 = ApiErrorResponseDto &
  ForUser500AllOf &
  ForUser500AllOfTwo;
export type ForAdmin200 = {
  data: DefaultDto;
};
export type ForAdmin401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type ForAdmin401AllOf = {
  error: ForAdmin401AllOfError;
};
export type ForAdmin401AllOfThreeErrorCode =
  (typeof ForAdmin401AllOfThreeErrorCode)[keyof typeof ForAdmin401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForAdmin401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ForAdmin401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ForAdmin401AllOfThreeErrorCode;
};
export type ForAdmin401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ForAdmin401AllOfThreeError;
};
export type ForAdmin401 = ApiErrorResponseDto &
  ForAdmin401AllOf &
  ForAdmin401AllOfThree;
export type ForAdmin500AllOf = {
  error: ApiError;
};
export type ForAdmin500AllOfTwoErrorCode =
  (typeof ForAdmin500AllOfTwoErrorCode)[keyof typeof ForAdmin500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForAdmin500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ForAdmin500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ForAdmin500AllOfTwoErrorCode;
};
export type ForAdmin500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ForAdmin500AllOfTwoError;
};
export type ForAdmin500 = ApiErrorResponseDto &
  ForAdmin500AllOf &
  ForAdmin500AllOfTwo;
export type ForSuperAdmin200 = {
  data: DefaultDto;
};
export type ForSuperAdmin401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type ForSuperAdmin401AllOf = {
  error: ForSuperAdmin401AllOfError;
};
export type ForSuperAdmin401AllOfThreeErrorCode =
  (typeof ForSuperAdmin401AllOfThreeErrorCode)[keyof typeof ForSuperAdmin401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForSuperAdmin401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ForSuperAdmin401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ForSuperAdmin401AllOfThreeErrorCode;
};
export type ForSuperAdmin401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ForSuperAdmin401AllOfThreeError;
};
export type ForSuperAdmin401 = ApiErrorResponseDto &
  ForSuperAdmin401AllOf &
  ForSuperAdmin401AllOfThree;
export type ForSuperAdmin500AllOf = {
  error: ApiError;
};
export type ForSuperAdmin500AllOfTwoErrorCode =
  (typeof ForSuperAdmin500AllOfTwoErrorCode)[keyof typeof ForSuperAdmin500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForSuperAdmin500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ForSuperAdmin500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ForSuperAdmin500AllOfTwoErrorCode;
};
export type ForSuperAdmin500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ForSuperAdmin500AllOfTwoError;
};
export type ForSuperAdmin500 = ApiErrorResponseDto &
  ForSuperAdmin500AllOf &
  ForSuperAdmin500AllOfTwo;
export type ResetPointsParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type ResetPoints200 = {
  data: DefaultResponseDto;
};
export type ResetPoints401AllOfError = JsonWebTokenError | TokenExpiredError;
export type ResetPoints401AllOf = {
  error: ResetPoints401AllOfError;
};
export type ResetPoints401AllOfThreeErrorCode =
  (typeof ResetPoints401AllOfThreeErrorCode)[keyof typeof ResetPoints401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetPoints401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type ResetPoints401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ResetPoints401AllOfThreeErrorCode;
};
export type ResetPoints401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ResetPoints401AllOfThreeError;
};
export type ResetPoints401 = ApiErrorResponseDto &
  ResetPoints401AllOf &
  ResetPoints401AllOfThree;
export type ResetPoints404AllOf = {
  error: EntityNotFoundError;
};
export type ResetPoints404AllOfTwoErrorCode =
  (typeof ResetPoints404AllOfTwoErrorCode)[keyof typeof ResetPoints404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetPoints404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type ResetPoints404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: ResetPoints404AllOfTwoErrorCode;
};
export type ResetPoints404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: ResetPoints404AllOfTwoError;
};
export type ResetPoints404 = ApiErrorResponseDto &
  ResetPoints404AllOf &
  ResetPoints404AllOfTwo;
export type ResetPoints500AllOf = {
  error: ApiError;
};
export type ResetPoints500AllOfTwoErrorCode =
  (typeof ResetPoints500AllOfTwoErrorCode)[keyof typeof ResetPoints500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetPoints500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ResetPoints500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ResetPoints500AllOfTwoErrorCode;
};
export type ResetPoints500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ResetPoints500AllOfTwoError;
};
export type ResetPoints500 = ApiErrorResponseDto &
  ResetPoints500AllOf &
  ResetPoints500AllOfTwo;
export type AlterPoints200 = {
  data: DefaultResponseDto;
};
export type AlterPoints401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type AlterPoints401AllOf = {
  error: AlterPoints401AllOfError;
};
export type AlterPoints401AllOfThreeErrorCode =
  (typeof AlterPoints401AllOfThreeErrorCode)[keyof typeof AlterPoints401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlterPoints401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AlterPoints401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AlterPoints401AllOfThreeErrorCode;
};
export type AlterPoints401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AlterPoints401AllOfThreeError;
};
export type AlterPoints401 = ApiErrorResponseDto &
  AlterPoints401AllOf &
  AlterPoints401AllOfThree;
export type AlterPoints404AllOf = {
  error: EntityNotFoundError;
};
export type AlterPoints404AllOfTwoErrorCode =
  (typeof AlterPoints404AllOfTwoErrorCode)[keyof typeof AlterPoints404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlterPoints404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AlterPoints404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AlterPoints404AllOfTwoErrorCode;
};
export type AlterPoints404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AlterPoints404AllOfTwoError;
};
export type AlterPoints404 = ApiErrorResponseDto &
  AlterPoints404AllOf &
  AlterPoints404AllOfTwo;
export type AlterPoints500AllOf = {
  error: ApiError;
};
export type AlterPoints500AllOfTwoErrorCode =
  (typeof AlterPoints500AllOfTwoErrorCode)[keyof typeof AlterPoints500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlterPoints500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AlterPoints500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AlterPoints500AllOfTwoErrorCode;
};
export type AlterPoints500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AlterPoints500AllOfTwoError;
};
export type AlterPoints500 = ApiErrorResponseDto &
  AlterPoints500AllOf &
  AlterPoints500AllOfTwo;
export type AwardNeedPointsParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardNeedPoints200 = {
  data: PointsAwardedResponseDto;
};
export type AwardNeedPoints401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardNeedPoints401AllOf = {
  error: AwardNeedPoints401AllOfError;
};
export type AwardNeedPoints401AllOfThreeErrorCode =
  (typeof AwardNeedPoints401AllOfThreeErrorCode)[keyof typeof AwardNeedPoints401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNeedPoints401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardNeedPoints401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardNeedPoints401AllOfThreeErrorCode;
};
export type AwardNeedPoints401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardNeedPoints401AllOfThreeError;
};
export type AwardNeedPoints401 = ApiErrorResponseDto &
  AwardNeedPoints401AllOf &
  AwardNeedPoints401AllOfThree;
export type AwardNeedPoints404AllOf = {
  error: EntityNotFoundError;
};
export type AwardNeedPoints404AllOfTwoErrorCode =
  (typeof AwardNeedPoints404AllOfTwoErrorCode)[keyof typeof AwardNeedPoints404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNeedPoints404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardNeedPoints404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardNeedPoints404AllOfTwoErrorCode;
};
export type AwardNeedPoints404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardNeedPoints404AllOfTwoError;
};
export type AwardNeedPoints404 = ApiErrorResponseDto &
  AwardNeedPoints404AllOf &
  AwardNeedPoints404AllOfTwo;
export type AwardNeedPoints500AllOf = {
  error: ApiError;
};
export type AwardNeedPoints500AllOfTwoErrorCode =
  (typeof AwardNeedPoints500AllOfTwoErrorCode)[keyof typeof AwardNeedPoints500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNeedPoints500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardNeedPoints500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardNeedPoints500AllOfTwoErrorCode;
};
export type AwardNeedPoints500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardNeedPoints500AllOfTwoError;
};
export type AwardNeedPoints500 = ApiErrorResponseDto &
  AwardNeedPoints500AllOf &
  AwardNeedPoints500AllOfTwo;
export type AwardGoodVibePointsParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardGoodVibePoints200 = {
  data: PointsAwardedResponseDto;
};
export type AwardGoodVibePoints401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardGoodVibePoints401AllOf = {
  error: AwardGoodVibePoints401AllOfError;
};
export type AwardGoodVibePoints401AllOfThreeErrorCode =
  (typeof AwardGoodVibePoints401AllOfThreeErrorCode)[keyof typeof AwardGoodVibePoints401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardGoodVibePoints401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardGoodVibePoints401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardGoodVibePoints401AllOfThreeErrorCode;
};
export type AwardGoodVibePoints401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardGoodVibePoints401AllOfThreeError;
};
export type AwardGoodVibePoints401 = ApiErrorResponseDto &
  AwardGoodVibePoints401AllOf &
  AwardGoodVibePoints401AllOfThree;
export type AwardGoodVibePoints404AllOf = {
  error: EntityNotFoundError;
};
export type AwardGoodVibePoints404AllOfTwoErrorCode =
  (typeof AwardGoodVibePoints404AllOfTwoErrorCode)[keyof typeof AwardGoodVibePoints404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardGoodVibePoints404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardGoodVibePoints404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardGoodVibePoints404AllOfTwoErrorCode;
};
export type AwardGoodVibePoints404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardGoodVibePoints404AllOfTwoError;
};
export type AwardGoodVibePoints404 = ApiErrorResponseDto &
  AwardGoodVibePoints404AllOf &
  AwardGoodVibePoints404AllOfTwo;
export type AwardGoodVibePoints500AllOf = {
  error: ApiError;
};
export type AwardGoodVibePoints500AllOfTwoErrorCode =
  (typeof AwardGoodVibePoints500AllOfTwoErrorCode)[keyof typeof AwardGoodVibePoints500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardGoodVibePoints500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardGoodVibePoints500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardGoodVibePoints500AllOfTwoErrorCode;
};
export type AwardGoodVibePoints500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardGoodVibePoints500AllOfTwoError;
};
export type AwardGoodVibePoints500 = ApiErrorResponseDto &
  AwardGoodVibePoints500AllOf &
  AwardGoodVibePoints500AllOfTwo;
export type AwardNominationSentParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardNominationSent200 = {
  data: PointsAwardedResponseDto;
};
export type AwardNominationSent401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardNominationSent401AllOf = {
  error: AwardNominationSent401AllOfError;
};
export type AwardNominationSent401AllOfThreeErrorCode =
  (typeof AwardNominationSent401AllOfThreeErrorCode)[keyof typeof AwardNominationSent401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNominationSent401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardNominationSent401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardNominationSent401AllOfThreeErrorCode;
};
export type AwardNominationSent401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardNominationSent401AllOfThreeError;
};
export type AwardNominationSent401 = ApiErrorResponseDto &
  AwardNominationSent401AllOf &
  AwardNominationSent401AllOfThree;
export type AwardNominationSent404AllOf = {
  error: EntityNotFoundError;
};
export type AwardNominationSent404AllOfTwoErrorCode =
  (typeof AwardNominationSent404AllOfTwoErrorCode)[keyof typeof AwardNominationSent404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNominationSent404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardNominationSent404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardNominationSent404AllOfTwoErrorCode;
};
export type AwardNominationSent404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardNominationSent404AllOfTwoError;
};
export type AwardNominationSent404 = ApiErrorResponseDto &
  AwardNominationSent404AllOf &
  AwardNominationSent404AllOfTwo;
export type AwardNominationSent500AllOf = {
  error: ApiError;
};
export type AwardNominationSent500AllOfTwoErrorCode =
  (typeof AwardNominationSent500AllOfTwoErrorCode)[keyof typeof AwardNominationSent500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardNominationSent500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardNominationSent500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardNominationSent500AllOfTwoErrorCode;
};
export type AwardNominationSent500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardNominationSent500AllOfTwoError;
};
export type AwardNominationSent500 = ApiErrorResponseDto &
  AwardNominationSent500AllOf &
  AwardNominationSent500AllOfTwo;
export type AwardEventRegistrationParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardEventRegistration200 = {
  data: PointsAwardedResponseDto;
};
export type AwardEventRegistration401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardEventRegistration401AllOf = {
  error: AwardEventRegistration401AllOfError;
};
export type AwardEventRegistration401AllOfThreeErrorCode =
  (typeof AwardEventRegistration401AllOfThreeErrorCode)[keyof typeof AwardEventRegistration401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventRegistration401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardEventRegistration401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardEventRegistration401AllOfThreeErrorCode;
};
export type AwardEventRegistration401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardEventRegistration401AllOfThreeError;
};
export type AwardEventRegistration401 = ApiErrorResponseDto &
  AwardEventRegistration401AllOf &
  AwardEventRegistration401AllOfThree;
export type AwardEventRegistration404AllOf = {
  error: EntityNotFoundError;
};
export type AwardEventRegistration404AllOfTwoErrorCode =
  (typeof AwardEventRegistration404AllOfTwoErrorCode)[keyof typeof AwardEventRegistration404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventRegistration404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardEventRegistration404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardEventRegistration404AllOfTwoErrorCode;
};
export type AwardEventRegistration404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardEventRegistration404AllOfTwoError;
};
export type AwardEventRegistration404 = ApiErrorResponseDto &
  AwardEventRegistration404AllOf &
  AwardEventRegistration404AllOfTwo;
export type AwardEventRegistration500AllOf = {
  error: ApiError;
};
export type AwardEventRegistration500AllOfTwoErrorCode =
  (typeof AwardEventRegistration500AllOfTwoErrorCode)[keyof typeof AwardEventRegistration500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventRegistration500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardEventRegistration500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardEventRegistration500AllOfTwoErrorCode;
};
export type AwardEventRegistration500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardEventRegistration500AllOfTwoError;
};
export type AwardEventRegistration500 = ApiErrorResponseDto &
  AwardEventRegistration500AllOf &
  AwardEventRegistration500AllOfTwo;
export type AwardEventAttendanceParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardEventAttendance200 = {
  data: PointsAwardedResponseDto;
};
export type AwardEventAttendance401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardEventAttendance401AllOf = {
  error: AwardEventAttendance401AllOfError;
};
export type AwardEventAttendance401AllOfThreeErrorCode =
  (typeof AwardEventAttendance401AllOfThreeErrorCode)[keyof typeof AwardEventAttendance401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventAttendance401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardEventAttendance401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardEventAttendance401AllOfThreeErrorCode;
};
export type AwardEventAttendance401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardEventAttendance401AllOfThreeError;
};
export type AwardEventAttendance401 = ApiErrorResponseDto &
  AwardEventAttendance401AllOf &
  AwardEventAttendance401AllOfThree;
export type AwardEventAttendance404AllOf = {
  error: EntityNotFoundError;
};
export type AwardEventAttendance404AllOfTwoErrorCode =
  (typeof AwardEventAttendance404AllOfTwoErrorCode)[keyof typeof AwardEventAttendance404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventAttendance404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardEventAttendance404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardEventAttendance404AllOfTwoErrorCode;
};
export type AwardEventAttendance404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardEventAttendance404AllOfTwoError;
};
export type AwardEventAttendance404 = ApiErrorResponseDto &
  AwardEventAttendance404AllOf &
  AwardEventAttendance404AllOfTwo;
export type AwardEventAttendance500AllOf = {
  error: ApiError;
};
export type AwardEventAttendance500AllOfTwoErrorCode =
  (typeof AwardEventAttendance500AllOfTwoErrorCode)[keyof typeof AwardEventAttendance500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardEventAttendance500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardEventAttendance500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardEventAttendance500AllOfTwoErrorCode;
};
export type AwardEventAttendance500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardEventAttendance500AllOfTwoError;
};
export type AwardEventAttendance500 = ApiErrorResponseDto &
  AwardEventAttendance500AllOf &
  AwardEventAttendance500AllOfTwo;
export type AwardStreakPointsParams = {
  /**
   * Api Key
   */
  'x-api-key'?: unknown;
};
export type AwardStreakPoints200 = {
  data: PointsAwardedResponseDto;
};
export type AwardStreakPoints401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type AwardStreakPoints401AllOf = {
  error: AwardStreakPoints401AllOfError;
};
export type AwardStreakPoints401AllOfThreeErrorCode =
  (typeof AwardStreakPoints401AllOfThreeErrorCode)[keyof typeof AwardStreakPoints401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardStreakPoints401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type AwardStreakPoints401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AwardStreakPoints401AllOfThreeErrorCode;
};
export type AwardStreakPoints401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AwardStreakPoints401AllOfThreeError;
};
export type AwardStreakPoints401 = ApiErrorResponseDto &
  AwardStreakPoints401AllOf &
  AwardStreakPoints401AllOfThree;
export type AwardStreakPoints404AllOf = {
  error: EntityNotFoundError;
};
export type AwardStreakPoints404AllOfTwoErrorCode =
  (typeof AwardStreakPoints404AllOfTwoErrorCode)[keyof typeof AwardStreakPoints404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardStreakPoints404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type AwardStreakPoints404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: AwardStreakPoints404AllOfTwoErrorCode;
};
export type AwardStreakPoints404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: AwardStreakPoints404AllOfTwoError;
};
export type AwardStreakPoints404 = ApiErrorResponseDto &
  AwardStreakPoints404AllOf &
  AwardStreakPoints404AllOfTwo;
export type AwardStreakPoints500AllOf = {
  error: ApiError;
};
export type AwardStreakPoints500AllOfTwoErrorCode =
  (typeof AwardStreakPoints500AllOfTwoErrorCode)[keyof typeof AwardStreakPoints500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AwardStreakPoints500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AwardStreakPoints500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AwardStreakPoints500AllOfTwoErrorCode;
};
export type AwardStreakPoints500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AwardStreakPoints500AllOfTwoError;
};
export type AwardStreakPoints500 = ApiErrorResponseDto &
  AwardStreakPoints500AllOf &
  AwardStreakPoints500AllOfTwo;
export type Me200 = {
  data: MeDto;
};
export type Me401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type Me401AllOf = {
  error: Me401AllOfError;
};
export type Me401AllOfThreeErrorCode =
  (typeof Me401AllOfThreeErrorCode)[keyof typeof Me401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Me401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type Me401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Me401AllOfThreeErrorCode;
};
export type Me401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Me401AllOfThreeError;
};
export type Me401 = ApiErrorResponseDto & Me401AllOf & Me401AllOfThree;
export type Me500AllOf = {
  error: ApiError;
};
export type Me500AllOfTwoErrorCode =
  (typeof Me500AllOfTwoErrorCode)[keyof typeof Me500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Me500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Me500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Me500AllOfTwoErrorCode;
};
export type Me500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Me500AllOfTwoError;
};
export type Me500 = ApiErrorResponseDto & Me500AllOf & Me500AllOfTwo;
export type UpdateMe200 = {
  data: UpdateMeResponseDto;
};
export type UpdateMe401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateMe401AllOf = {
  error: UpdateMe401AllOfError;
};
export type UpdateMe401AllOfThreeErrorCode =
  (typeof UpdateMe401AllOfThreeErrorCode)[keyof typeof UpdateMe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type UpdateMe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateMe401AllOfThreeErrorCode;
};
export type UpdateMe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateMe401AllOfThreeError;
};
export type UpdateMe401 = ApiErrorResponseDto &
  UpdateMe401AllOf &
  UpdateMe401AllOfThree;
export type UpdateMe500AllOf = {
  error: ApiError;
};
export type UpdateMe500AllOfTwoErrorCode =
  (typeof UpdateMe500AllOfTwoErrorCode)[keyof typeof UpdateMe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateMe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateMe500AllOfTwoErrorCode;
};
export type UpdateMe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateMe500AllOfTwoError;
};
export type UpdateMe500 = ApiErrorResponseDto &
  UpdateMe500AllOf &
  UpdateMe500AllOfTwo;
export type Share200 = {
  data: PointsAwardedResponseDto;
};
export type Share401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type Share401AllOf = {
  error: Share401AllOfError;
};
export type Share401AllOfThreeErrorCode =
  (typeof Share401AllOfThreeErrorCode)[keyof typeof Share401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Share401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type Share401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Share401AllOfThreeErrorCode;
};
export type Share401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Share401AllOfThreeError;
};
export type Share401 = ApiErrorResponseDto & Share401AllOf & Share401AllOfThree;
export type Share500AllOf = {
  error: ApiError;
};
export type Share500AllOfTwoErrorCode =
  (typeof Share500AllOfTwoErrorCode)[keyof typeof Share500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Share500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Share500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Share500AllOfTwoErrorCode;
};
export type Share500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Share500AllOfTwoError;
};
export type Share500 = ApiErrorResponseDto & Share500AllOf & Share500AllOfTwo;
export type DonationsParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: DonationsSortBy;
  sortDirection?: DonationsSortDirection;
};
export type DonationsSortBy =
  (typeof DonationsSortBy)[keyof typeof DonationsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DonationsSortBy = {
  createdAt: 'createdAt'
} as const;
export type DonationsSortDirection =
  (typeof DonationsSortDirection)[keyof typeof DonationsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DonationsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type Donations200 = {
  data: GetDonationHistoryDataDto;
  meta?: GetDonationHistoryMetaDto;
};
export type Donations401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type Donations401AllOf = {
  error: Donations401AllOfError;
};
export type Donations401AllOfThreeErrorCode =
  (typeof Donations401AllOfThreeErrorCode)[keyof typeof Donations401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Donations401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type Donations401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Donations401AllOfThreeErrorCode;
};
export type Donations401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Donations401AllOfThreeError;
};
export type Donations401 = ApiErrorResponseDto &
  Donations401AllOf &
  Donations401AllOfThree;
export type Donations500AllOf = {
  error: ApiError;
};
export type Donations500AllOfTwoErrorCode =
  (typeof Donations500AllOfTwoErrorCode)[keyof typeof Donations500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Donations500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Donations500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Donations500AllOfTwoErrorCode;
};
export type Donations500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Donations500AllOfTwoError;
};
export type Donations500 = ApiErrorResponseDto &
  Donations500AllOf &
  Donations500AllOfTwo;
export type GetUsersParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetUsersSortBy;
  sortDirection?: GetUsersSortDirection;
};
export type GetUsersSortBy =
  (typeof GetUsersSortBy)[keyof typeof GetUsersSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersSortBy = {
  firstName: 'firstName',
  lastName: 'lastName',
  createdAt: 'createdAt'
} as const;
export type GetUsersSortDirection =
  (typeof GetUsersSortDirection)[keyof typeof GetUsersSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetUsers200 = {
  data: GetUsersDataDto;
  meta?: GetUsersMetaDto;
};
export type GetUsers401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetUsers401AllOf = {
  error: GetUsers401AllOfError;
};
export type GetUsers401AllOfThreeErrorCode =
  (typeof GetUsers401AllOfThreeErrorCode)[keyof typeof GetUsers401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsers401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetUsers401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetUsers401AllOfThreeErrorCode;
};
export type GetUsers401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetUsers401AllOfThreeError;
};
export type GetUsers401 = ApiErrorResponseDto &
  GetUsers401AllOf &
  GetUsers401AllOfThree;
export type GetUsers500AllOf = {
  error: ApiError;
};
export type GetUsers500AllOfTwoErrorCode =
  (typeof GetUsers500AllOfTwoErrorCode)[keyof typeof GetUsers500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsers500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetUsers500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetUsers500AllOfTwoErrorCode;
};
export type GetUsers500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetUsers500AllOfTwoError;
};
export type GetUsers500 = ApiErrorResponseDto &
  GetUsers500AllOf &
  GetUsers500AllOfTwo;
export type GetEventsParams = {
  location?: GetEventsLocation;
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetEventsSortBy;
  sortDirection?: GetEventsSortDirection;
};
export type GetEventsLocation =
  (typeof GetEventsLocation)[keyof typeof GetEventsLocation];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsLocation = {
  miami: 'miami',
  houston: 'houston',
  los_angeles: 'los_angeles',
  '': ''
} as const;
export type GetEventsSortBy =
  (typeof GetEventsSortBy)[keyof typeof GetEventsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsSortBy = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const;
export type GetEventsSortDirection =
  (typeof GetEventsSortDirection)[keyof typeof GetEventsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetEvents200 = {
  data: GetEventsDataDto;
  meta?: GetEventsMetaDto;
};
export type GetEvents500AllOf = {
  error: ApiError;
};
export type GetEvents500AllOfTwoErrorCode =
  (typeof GetEvents500AllOfTwoErrorCode)[keyof typeof GetEvents500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEvents500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetEvents500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetEvents500AllOfTwoErrorCode;
};
export type GetEvents500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetEvents500AllOfTwoError;
};
export type GetEvents500 = ApiErrorResponseDto &
  GetEvents500AllOf &
  GetEvents500AllOfTwo;
export type GetEventById200 = {
  data: GetEventResponseDto;
};
export type GetEventById500AllOf = {
  error: ApiError;
};
export type GetEventById500AllOfTwoErrorCode =
  (typeof GetEventById500AllOfTwoErrorCode)[keyof typeof GetEventById500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventById500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetEventById500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetEventById500AllOfTwoErrorCode;
};
export type GetEventById500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetEventById500AllOfTwoError;
};
export type GetEventById500 = ApiErrorResponseDto &
  GetEventById500AllOf &
  GetEventById500AllOfTwo;
export type RegisterEvent200 = {
  data: RegisterForEventResponseDto;
};
export type RegisterEvent401AllOfError = TokenExpiredError | JsonWebTokenError;
export type RegisterEvent401AllOf = {
  error: RegisterEvent401AllOfError;
};
export type RegisterEvent401AllOfThreeErrorCode =
  (typeof RegisterEvent401AllOfThreeErrorCode)[keyof typeof RegisterEvent401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterEvent401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type RegisterEvent401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: RegisterEvent401AllOfThreeErrorCode;
};
export type RegisterEvent401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: RegisterEvent401AllOfThreeError;
};
export type RegisterEvent401 = ApiErrorResponseDto &
  RegisterEvent401AllOf &
  RegisterEvent401AllOfThree;
export type RegisterEvent500AllOf = {
  error: ApiError;
};
export type RegisterEvent500AllOfTwoErrorCode =
  (typeof RegisterEvent500AllOfTwoErrorCode)[keyof typeof RegisterEvent500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterEvent500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type RegisterEvent500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: RegisterEvent500AllOfTwoErrorCode;
};
export type RegisterEvent500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: RegisterEvent500AllOfTwoError;
};
export type RegisterEvent500 = ApiErrorResponseDto &
  RegisterEvent500AllOf &
  RegisterEvent500AllOfTwo;
export type AttendEvent200 = {
  data: AttendEventResponseDto;
};
export type AttendEvent401AllOfError = TokenExpiredError | JsonWebTokenError;
export type AttendEvent401AllOf = {
  error: AttendEvent401AllOfError;
};
export type AttendEvent401AllOfThreeErrorCode =
  (typeof AttendEvent401AllOfThreeErrorCode)[keyof typeof AttendEvent401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendEvent401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type AttendEvent401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: AttendEvent401AllOfThreeErrorCode;
};
export type AttendEvent401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: AttendEvent401AllOfThreeError;
};
export type AttendEvent401 = ApiErrorResponseDto &
  AttendEvent401AllOf &
  AttendEvent401AllOfThree;
export type AttendEvent500AllOf = {
  error: ApiError;
};
export type AttendEvent500AllOfTwoErrorCode =
  (typeof AttendEvent500AllOfTwoErrorCode)[keyof typeof AttendEvent500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendEvent500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type AttendEvent500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: AttendEvent500AllOfTwoErrorCode;
};
export type AttendEvent500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: AttendEvent500AllOfTwoError;
};
export type AttendEvent500 = ApiErrorResponseDto &
  AttendEvent500AllOf &
  AttendEvent500AllOfTwo;
export type GetLocations200 = {
  data: GetLocationsDataDto;
};
export type GetLocations500AllOf = {
  error: ApiError;
};
export type GetLocations500AllOfTwoErrorCode =
  (typeof GetLocations500AllOfTwoErrorCode)[keyof typeof GetLocations500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLocations500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetLocations500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetLocations500AllOfTwoErrorCode;
};
export type GetLocations500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetLocations500AllOfTwoError;
};
export type GetLocations500 = ApiErrorResponseDto &
  GetLocations500AllOf &
  GetLocations500AllOfTwo;
export type BrushfireAttendanceWebhook200 = {
  data: DefaultDto;
};
export type BrushfireAttendanceWebhook500AllOf = {
  error: ApiError;
};
export type BrushfireAttendanceWebhook500AllOfTwoErrorCode =
  (typeof BrushfireAttendanceWebhook500AllOfTwoErrorCode)[keyof typeof BrushfireAttendanceWebhook500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrushfireAttendanceWebhook500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type BrushfireAttendanceWebhook500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: BrushfireAttendanceWebhook500AllOfTwoErrorCode;
};
export type BrushfireAttendanceWebhook500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: BrushfireAttendanceWebhook500AllOfTwoError;
};
export type BrushfireAttendanceWebhook500 = ApiErrorResponseDto &
  BrushfireAttendanceWebhook500AllOf &
  BrushfireAttendanceWebhook500AllOfTwo;
export type BrushfireEventCreatedWebhook200 = {
  data: DefaultDto;
};
export type BrushfireEventCreatedWebhook500AllOf = {
  error: ApiError;
};
export type BrushfireEventCreatedWebhook500AllOfTwoErrorCode =
  (typeof BrushfireEventCreatedWebhook500AllOfTwoErrorCode)[keyof typeof BrushfireEventCreatedWebhook500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrushfireEventCreatedWebhook500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type BrushfireEventCreatedWebhook500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: BrushfireEventCreatedWebhook500AllOfTwoErrorCode;
};
export type BrushfireEventCreatedWebhook500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: BrushfireEventCreatedWebhook500AllOfTwoError;
};
export type BrushfireEventCreatedWebhook500 = ApiErrorResponseDto &
  BrushfireEventCreatedWebhook500AllOf &
  BrushfireEventCreatedWebhook500AllOfTwo;
export type RemoveUser200 = {
  data: DefaultDto;
};
export type RemoveUser404AllOf = {
  error: EntityNotFoundError;
};
export type RemoveUser404AllOfTwoErrorCode =
  (typeof RemoveUser404AllOfTwoErrorCode)[keyof typeof RemoveUser404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveUser404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type RemoveUser404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: RemoveUser404AllOfTwoErrorCode;
};
export type RemoveUser404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: RemoveUser404AllOfTwoError;
};
export type RemoveUser404 = ApiErrorResponseDto &
  RemoveUser404AllOf &
  RemoveUser404AllOfTwo;
export type RemoveUser500AllOf = {
  error: ApiError;
};
export type RemoveUser500AllOfTwoErrorCode =
  (typeof RemoveUser500AllOfTwoErrorCode)[keyof typeof RemoveUser500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveUser500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type RemoveUser500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: RemoveUser500AllOfTwoErrorCode;
};
export type RemoveUser500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: RemoveUser500AllOfTwoError;
};
export type RemoveUser500 = ApiErrorResponseDto &
  RemoveUser500AllOf &
  RemoveUser500AllOfTwo;
export type SendPushMessage200 = {
  data: DefaultDto;
};
export type SendPushMessage500AllOf = {
  error: ApiError;
};
export type SendPushMessage500AllOfTwoErrorCode =
  (typeof SendPushMessage500AllOfTwoErrorCode)[keyof typeof SendPushMessage500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendPushMessage500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type SendPushMessage500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SendPushMessage500AllOfTwoErrorCode;
};
export type SendPushMessage500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SendPushMessage500AllOfTwoError;
};
export type SendPushMessage500 = ApiErrorResponseDto &
  SendPushMessage500AllOf &
  SendPushMessage500AllOfTwo;
export type ConfirmMobilePayment200 = {
  data: PaymentsMobileConfirmPaymentIntentResponseDto;
};
export type ConfirmMobilePayment401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type ConfirmMobilePayment401AllOf = {
  error: ConfirmMobilePayment401AllOfError;
};
export type ConfirmMobilePayment401AllOfThreeErrorCode =
  (typeof ConfirmMobilePayment401AllOfThreeErrorCode)[keyof typeof ConfirmMobilePayment401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmMobilePayment401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ConfirmMobilePayment401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ConfirmMobilePayment401AllOfThreeErrorCode;
};
export type ConfirmMobilePayment401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ConfirmMobilePayment401AllOfThreeError;
};
export type ConfirmMobilePayment401 = ApiErrorResponseDto &
  ConfirmMobilePayment401AllOf &
  ConfirmMobilePayment401AllOfThree;
export type ConfirmMobilePayment500AllOfError =
  | StripeConfirmPaymentIntentError
  | ApiError;
export type ConfirmMobilePayment500AllOf = {
  error: ConfirmMobilePayment500AllOfError;
};
export type ConfirmMobilePayment500AllOfThreeErrorCode =
  (typeof ConfirmMobilePayment500AllOfThreeErrorCode)[keyof typeof ConfirmMobilePayment500AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfirmMobilePayment500AllOfThreeErrorCode = {
  StripeConfirmPaymentIntentError: 'StripeConfirmPaymentIntentError',
  UnexpectedError: 'UnexpectedError'
} as const;
export type ConfirmMobilePayment500AllOfThreeError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ConfirmMobilePayment500AllOfThreeErrorCode;
};
export type ConfirmMobilePayment500AllOfThree = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ConfirmMobilePayment500AllOfThreeError;
};
export type ConfirmMobilePayment500 = ApiErrorResponseDto &
  ConfirmMobilePayment500AllOf &
  ConfirmMobilePayment500AllOfThree;
export type PaymentSheet200 = {
  data: PaymentsMobilePaymentSheetResponseDto;
};
export type PaymentSheet401AllOfError = TokenExpiredError | JsonWebTokenError;
export type PaymentSheet401AllOf = {
  error: PaymentSheet401AllOfError;
};
export type PaymentSheet401AllOfThreeErrorCode =
  (typeof PaymentSheet401AllOfThreeErrorCode)[keyof typeof PaymentSheet401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSheet401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type PaymentSheet401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: PaymentSheet401AllOfThreeErrorCode;
};
export type PaymentSheet401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: PaymentSheet401AllOfThreeError;
};
export type PaymentSheet401 = ApiErrorResponseDto &
  PaymentSheet401AllOf &
  PaymentSheet401AllOfThree;
export type PaymentSheet500AllOf = {
  error: ApiError;
};
export type PaymentSheet500AllOfTwoErrorCode =
  (typeof PaymentSheet500AllOfTwoErrorCode)[keyof typeof PaymentSheet500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentSheet500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type PaymentSheet500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: PaymentSheet500AllOfTwoErrorCode;
};
export type PaymentSheet500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: PaymentSheet500AllOfTwoError;
};
export type PaymentSheet500 = ApiErrorResponseDto &
  PaymentSheet500AllOf &
  PaymentSheet500AllOfTwo;
export type OrganizationsParams = {
  page?: number;
  perPage?: number;
  sortBy?: OrganizationsSortBy;
  sortDirection?: OrganizationsSortDirection;
};
export type OrganizationsSortBy =
  (typeof OrganizationsSortBy)[keyof typeof OrganizationsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationsSortBy = {
  name: 'name',
  createdAt: 'createdAt'
} as const;
export type OrganizationsSortDirection =
  (typeof OrganizationsSortDirection)[keyof typeof OrganizationsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type Organizations200 = {
  data: GetOrganizationsResponseDto;
};
export type Organizations401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type Organizations401AllOf = {
  error: Organizations401AllOfError;
};
export type Organizations401AllOfThreeErrorCode =
  (typeof Organizations401AllOfThreeErrorCode)[keyof typeof Organizations401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Organizations401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type Organizations401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Organizations401AllOfThreeErrorCode;
};
export type Organizations401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Organizations401AllOfThreeError;
};
export type Organizations401 = ApiErrorResponseDto &
  Organizations401AllOf &
  Organizations401AllOfThree;
export type Organizations500AllOf = {
  error: ApiError;
};
export type Organizations500AllOfTwoErrorCode =
  (typeof Organizations500AllOfTwoErrorCode)[keyof typeof Organizations500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Organizations500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Organizations500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Organizations500AllOfTwoErrorCode;
};
export type Organizations500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Organizations500AllOfTwoError;
};
export type Organizations500 = ApiErrorResponseDto &
  Organizations500AllOf &
  Organizations500AllOfTwo;
export type CreateOrganization200 = {
  data: GetOrganizationResponseDto;
};
export type CreateOrganization401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type CreateOrganization401AllOf = {
  error: CreateOrganization401AllOfError;
};
export type CreateOrganization401AllOfThreeErrorCode =
  (typeof CreateOrganization401AllOfThreeErrorCode)[keyof typeof CreateOrganization401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganization401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CreateOrganization401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateOrganization401AllOfThreeErrorCode;
};
export type CreateOrganization401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateOrganization401AllOfThreeError;
};
export type CreateOrganization401 = ApiErrorResponseDto &
  CreateOrganization401AllOf &
  CreateOrganization401AllOfThree;
export type CreateOrganization500AllOf = {
  error: ApiError;
};
export type CreateOrganization500AllOfTwoErrorCode =
  (typeof CreateOrganization500AllOfTwoErrorCode)[keyof typeof CreateOrganization500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganization500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateOrganization500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateOrganization500AllOfTwoErrorCode;
};
export type CreateOrganization500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateOrganization500AllOfTwoError;
};
export type CreateOrganization500 = ApiErrorResponseDto &
  CreateOrganization500AllOf &
  CreateOrganization500AllOfTwo;
export type Organization200 = {
  data: GetOrganizationResponseDto;
};
export type Organization401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type Organization401AllOf = {
  error: Organization401AllOfError;
};
export type Organization401AllOfThreeErrorCode =
  (typeof Organization401AllOfThreeErrorCode)[keyof typeof Organization401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Organization401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type Organization401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Organization401AllOfThreeErrorCode;
};
export type Organization401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Organization401AllOfThreeError;
};
export type Organization401 = ApiErrorResponseDto &
  Organization401AllOf &
  Organization401AllOfThree;
export type Organization500AllOf = {
  error: ApiError;
};
export type Organization500AllOfTwoErrorCode =
  (typeof Organization500AllOfTwoErrorCode)[keyof typeof Organization500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Organization500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Organization500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Organization500AllOfTwoErrorCode;
};
export type Organization500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Organization500AllOfTwoError;
};
export type Organization500 = ApiErrorResponseDto &
  Organization500AllOf &
  Organization500AllOfTwo;
export type UpdateOrganization200 = {
  data: GetOrganizationResponseDto;
};
export type UpdateOrganization401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateOrganization401AllOf = {
  error: UpdateOrganization401AllOfError;
};
export type UpdateOrganization401AllOfThreeErrorCode =
  (typeof UpdateOrganization401AllOfThreeErrorCode)[keyof typeof UpdateOrganization401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrganization401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type UpdateOrganization401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateOrganization401AllOfThreeErrorCode;
};
export type UpdateOrganization401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateOrganization401AllOfThreeError;
};
export type UpdateOrganization401 = ApiErrorResponseDto &
  UpdateOrganization401AllOf &
  UpdateOrganization401AllOfThree;
export type UpdateOrganization500AllOf = {
  error: ApiError;
};
export type UpdateOrganization500AllOfTwoErrorCode =
  (typeof UpdateOrganization500AllOfTwoErrorCode)[keyof typeof UpdateOrganization500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrganization500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateOrganization500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateOrganization500AllOfTwoErrorCode;
};
export type UpdateOrganization500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateOrganization500AllOfTwoError;
};
export type UpdateOrganization500 = ApiErrorResponseDto &
  UpdateOrganization500AllOf &
  UpdateOrganization500AllOfTwo;
export type DeleteOrganization200 = {
  data: GetOrganizationResponseDto;
};
export type DeleteOrganization401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type DeleteOrganization401AllOf = {
  error: DeleteOrganization401AllOfError;
};
export type DeleteOrganization401AllOfThreeErrorCode =
  (typeof DeleteOrganization401AllOfThreeErrorCode)[keyof typeof DeleteOrganization401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteOrganization401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type DeleteOrganization401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteOrganization401AllOfThreeErrorCode;
};
export type DeleteOrganization401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteOrganization401AllOfThreeError;
};
export type DeleteOrganization401 = ApiErrorResponseDto &
  DeleteOrganization401AllOf &
  DeleteOrganization401AllOfThree;
export type DeleteOrganization500AllOf = {
  error: ApiError;
};
export type DeleteOrganization500AllOfTwoErrorCode =
  (typeof DeleteOrganization500AllOfTwoErrorCode)[keyof typeof DeleteOrganization500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteOrganization500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteOrganization500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteOrganization500AllOfTwoErrorCode;
};
export type DeleteOrganization500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteOrganization500AllOfTwoError;
};
export type DeleteOrganization500 = ApiErrorResponseDto &
  DeleteOrganization500AllOf &
  DeleteOrganization500AllOfTwo;
export type NeedsParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: NeedsSortBy;
  sortDirection?: NeedsSortDirection;
};
export type NeedsSortBy = (typeof NeedsSortBy)[keyof typeof NeedsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NeedsSortBy = {
  title: 'title',
  createdAt: 'createdAt'
} as const;
export type NeedsSortDirection =
  (typeof NeedsSortDirection)[keyof typeof NeedsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NeedsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type Needs200 = {
  data: GetNeedsDataDto;
  meta?: GetNeedsMetaDto;
};
export type Needs401AllOfError = JsonWebTokenError | TokenExpiredError;
export type Needs401AllOf = {
  error: Needs401AllOfError;
};
export type Needs401AllOfThreeErrorCode =
  (typeof Needs401AllOfThreeErrorCode)[keyof typeof Needs401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Needs401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type Needs401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Needs401AllOfThreeErrorCode;
};
export type Needs401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Needs401AllOfThreeError;
};
export type Needs401 = ApiErrorResponseDto & Needs401AllOf & Needs401AllOfThree;
export type Needs500AllOf = {
  error: ApiError;
};
export type Needs500AllOfTwoErrorCode =
  (typeof Needs500AllOfTwoErrorCode)[keyof typeof Needs500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Needs500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Needs500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Needs500AllOfTwoErrorCode;
};
export type Needs500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Needs500AllOfTwoError;
};
export type Needs500 = ApiErrorResponseDto & Needs500AllOf & Needs500AllOfTwo;
export type CreateNeed200 = {
  data: GetNeedResponseDto;
};
export type CreateNeed401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type CreateNeed401AllOf = {
  error: CreateNeed401AllOfError;
};
export type CreateNeed401AllOfThreeErrorCode =
  (typeof CreateNeed401AllOfThreeErrorCode)[keyof typeof CreateNeed401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNeed401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type CreateNeed401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateNeed401AllOfThreeErrorCode;
};
export type CreateNeed401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateNeed401AllOfThreeError;
};
export type CreateNeed401 = ApiErrorResponseDto &
  CreateNeed401AllOf &
  CreateNeed401AllOfThree;
export type CreateNeed500AllOf = {
  error: ApiError;
};
export type CreateNeed500AllOfTwoErrorCode =
  (typeof CreateNeed500AllOfTwoErrorCode)[keyof typeof CreateNeed500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNeed500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateNeed500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateNeed500AllOfTwoErrorCode;
};
export type CreateNeed500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateNeed500AllOfTwoError;
};
export type CreateNeed500 = ApiErrorResponseDto &
  CreateNeed500AllOf &
  CreateNeed500AllOfTwo;
export type GetNeed200 = {
  data: GetNeedResponseDto;
};
export type GetNeed401AllOfError = JsonWebTokenError | TokenExpiredError;
export type GetNeed401AllOf = {
  error: GetNeed401AllOfError;
};
export type GetNeed401AllOfThreeErrorCode =
  (typeof GetNeed401AllOfThreeErrorCode)[keyof typeof GetNeed401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNeed401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetNeed401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetNeed401AllOfThreeErrorCode;
};
export type GetNeed401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetNeed401AllOfThreeError;
};
export type GetNeed401 = ApiErrorResponseDto &
  GetNeed401AllOf &
  GetNeed401AllOfThree;
export type GetNeed404AllOf = {
  error: EntityNotFoundError;
};
export type GetNeed404AllOfTwoErrorCode =
  (typeof GetNeed404AllOfTwoErrorCode)[keyof typeof GetNeed404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNeed404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetNeed404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetNeed404AllOfTwoErrorCode;
};
export type GetNeed404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetNeed404AllOfTwoError;
};
export type GetNeed404 = ApiErrorResponseDto &
  GetNeed404AllOf &
  GetNeed404AllOfTwo;
export type GetNeed500AllOf = {
  error: ApiError;
};
export type GetNeed500AllOfTwoErrorCode =
  (typeof GetNeed500AllOfTwoErrorCode)[keyof typeof GetNeed500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNeed500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetNeed500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetNeed500AllOfTwoErrorCode;
};
export type GetNeed500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetNeed500AllOfTwoError;
};
export type GetNeed500 = ApiErrorResponseDto &
  GetNeed500AllOf &
  GetNeed500AllOfTwo;
export type UpdateNeed200 = {
  data: GetNeedResponseDto;
};
export type UpdateNeed401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateNeed401AllOf = {
  error: UpdateNeed401AllOfError;
};
export type UpdateNeed401AllOfThreeErrorCode =
  (typeof UpdateNeed401AllOfThreeErrorCode)[keyof typeof UpdateNeed401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNeed401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdateNeed401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateNeed401AllOfThreeErrorCode;
};
export type UpdateNeed401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateNeed401AllOfThreeError;
};
export type UpdateNeed401 = ApiErrorResponseDto &
  UpdateNeed401AllOf &
  UpdateNeed401AllOfThree;
export type UpdateNeed404AllOf = {
  error: EntityNotFoundError;
};
export type UpdateNeed404AllOfTwoErrorCode =
  (typeof UpdateNeed404AllOfTwoErrorCode)[keyof typeof UpdateNeed404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNeed404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdateNeed404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdateNeed404AllOfTwoErrorCode;
};
export type UpdateNeed404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdateNeed404AllOfTwoError;
};
export type UpdateNeed404 = ApiErrorResponseDto &
  UpdateNeed404AllOf &
  UpdateNeed404AllOfTwo;
export type UpdateNeed500AllOf = {
  error: ApiError;
};
export type UpdateNeed500AllOfTwoErrorCode =
  (typeof UpdateNeed500AllOfTwoErrorCode)[keyof typeof UpdateNeed500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNeed500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateNeed500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateNeed500AllOfTwoErrorCode;
};
export type UpdateNeed500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateNeed500AllOfTwoError;
};
export type UpdateNeed500 = ApiErrorResponseDto &
  UpdateNeed500AllOf &
  UpdateNeed500AllOfTwo;
export type DeleteNeed200 = {
  data: GetNeedResponseDto;
};
export type DeleteNeed401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type DeleteNeed401AllOf = {
  error: DeleteNeed401AllOfError;
};
export type DeleteNeed401AllOfThreeErrorCode =
  (typeof DeleteNeed401AllOfThreeErrorCode)[keyof typeof DeleteNeed401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteNeed401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type DeleteNeed401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteNeed401AllOfThreeErrorCode;
};
export type DeleteNeed401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteNeed401AllOfThreeError;
};
export type DeleteNeed401 = ApiErrorResponseDto &
  DeleteNeed401AllOf &
  DeleteNeed401AllOfThree;
export type DeleteNeed404AllOf = {
  error: EntityNotFoundError;
};
export type DeleteNeed404AllOfTwoErrorCode =
  (typeof DeleteNeed404AllOfTwoErrorCode)[keyof typeof DeleteNeed404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteNeed404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type DeleteNeed404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: DeleteNeed404AllOfTwoErrorCode;
};
export type DeleteNeed404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: DeleteNeed404AllOfTwoError;
};
export type DeleteNeed404 = ApiErrorResponseDto &
  DeleteNeed404AllOf &
  DeleteNeed404AllOfTwo;
export type DeleteNeed500AllOf = {
  error: ApiError;
};
export type DeleteNeed500AllOfTwoErrorCode =
  (typeof DeleteNeed500AllOfTwoErrorCode)[keyof typeof DeleteNeed500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteNeed500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteNeed500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteNeed500AllOfTwoErrorCode;
};
export type DeleteNeed500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteNeed500AllOfTwoError;
};
export type DeleteNeed500 = ApiErrorResponseDto &
  DeleteNeed500AllOf &
  DeleteNeed500AllOfTwo;
export type GoodVibesParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GoodVibesSortBy;
  sortDirection?: GoodVibesSortDirection;
};
export type GoodVibesSortBy =
  (typeof GoodVibesSortBy)[keyof typeof GoodVibesSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoodVibesSortBy = {
  createdAt: 'createdAt'
} as const;
export type GoodVibesSortDirection =
  (typeof GoodVibesSortDirection)[keyof typeof GoodVibesSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoodVibesSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GoodVibes200 = {
  data: GetGoodVibesDataDto;
  meta?: GetGoodVibesMetaDto;
};
export type GoodVibes500AllOf = {
  error: ApiError;
};
export type GoodVibes500AllOfTwoErrorCode =
  (typeof GoodVibes500AllOfTwoErrorCode)[keyof typeof GoodVibes500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoodVibes500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GoodVibes500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GoodVibes500AllOfTwoErrorCode;
};
export type GoodVibes500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GoodVibes500AllOfTwoError;
};
export type GoodVibes500 = ApiErrorResponseDto &
  GoodVibes500AllOf &
  GoodVibes500AllOfTwo;
export type CreateGoodVibe200 = {
  data: GetGoodVibeResponseDto;
};
export type CreateGoodVibe401AllOfError = TokenExpiredError | JsonWebTokenError;
export type CreateGoodVibe401AllOf = {
  error: CreateGoodVibe401AllOfError;
};
export type CreateGoodVibe401AllOfThreeErrorCode =
  (typeof CreateGoodVibe401AllOfThreeErrorCode)[keyof typeof CreateGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CreateGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateGoodVibe401AllOfThreeErrorCode;
};
export type CreateGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateGoodVibe401AllOfThreeError;
};
export type CreateGoodVibe401 = ApiErrorResponseDto &
  CreateGoodVibe401AllOf &
  CreateGoodVibe401AllOfThree;
export type CreateGoodVibe500AllOf = {
  error: ApiError;
};
export type CreateGoodVibe500AllOfTwoErrorCode =
  (typeof CreateGoodVibe500AllOfTwoErrorCode)[keyof typeof CreateGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateGoodVibe500AllOfTwoErrorCode;
};
export type CreateGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateGoodVibe500AllOfTwoError;
};
export type CreateGoodVibe500 = ApiErrorResponseDto &
  CreateGoodVibe500AllOf &
  CreateGoodVibe500AllOfTwo;
export type GetGoodVibe200 = {
  data: GetGoodVibeResponseDto;
};
export type GetGoodVibe500AllOf = {
  error: ApiError;
};
export type GetGoodVibe500AllOfTwoErrorCode =
  (typeof GetGoodVibe500AllOfTwoErrorCode)[keyof typeof GetGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetGoodVibe500AllOfTwoErrorCode;
};
export type GetGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetGoodVibe500AllOfTwoError;
};
export type GetGoodVibe500 = ApiErrorResponseDto &
  GetGoodVibe500AllOf &
  GetGoodVibe500AllOfTwo;
export type UpdateGoodVibe200 = {
  data: GetGoodVibeResponseDto;
};
export type UpdateGoodVibe401AllOfError = TokenExpiredError | JsonWebTokenError;
export type UpdateGoodVibe401AllOf = {
  error: UpdateGoodVibe401AllOfError;
};
export type UpdateGoodVibe401AllOfThreeErrorCode =
  (typeof UpdateGoodVibe401AllOfThreeErrorCode)[keyof typeof UpdateGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type UpdateGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateGoodVibe401AllOfThreeErrorCode;
};
export type UpdateGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateGoodVibe401AllOfThreeError;
};
export type UpdateGoodVibe401 = ApiErrorResponseDto &
  UpdateGoodVibe401AllOf &
  UpdateGoodVibe401AllOfThree;
export type UpdateGoodVibe500AllOf = {
  error: ApiError;
};
export type UpdateGoodVibe500AllOfTwoErrorCode =
  (typeof UpdateGoodVibe500AllOfTwoErrorCode)[keyof typeof UpdateGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateGoodVibe500AllOfTwoErrorCode;
};
export type UpdateGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateGoodVibe500AllOfTwoError;
};
export type UpdateGoodVibe500 = ApiErrorResponseDto &
  UpdateGoodVibe500AllOf &
  UpdateGoodVibe500AllOfTwo;
export type DeleteGoodVibe200 = {
  data: GetGoodVibeResponseDto;
};
export type DeleteGoodVibe401AllOfError = TokenExpiredError | JsonWebTokenError;
export type DeleteGoodVibe401AllOf = {
  error: DeleteGoodVibe401AllOfError;
};
export type DeleteGoodVibe401AllOfThreeErrorCode =
  (typeof DeleteGoodVibe401AllOfThreeErrorCode)[keyof typeof DeleteGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type DeleteGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteGoodVibe401AllOfThreeErrorCode;
};
export type DeleteGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteGoodVibe401AllOfThreeError;
};
export type DeleteGoodVibe401 = ApiErrorResponseDto &
  DeleteGoodVibe401AllOf &
  DeleteGoodVibe401AllOfThree;
export type DeleteGoodVibe500AllOf = {
  error: ApiError;
};
export type DeleteGoodVibe500AllOfTwoErrorCode =
  (typeof DeleteGoodVibe500AllOfTwoErrorCode)[keyof typeof DeleteGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteGoodVibe500AllOfTwoErrorCode;
};
export type DeleteGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteGoodVibe500AllOfTwoError;
};
export type DeleteGoodVibe500 = ApiErrorResponseDto &
  DeleteGoodVibe500AllOf &
  DeleteGoodVibe500AllOfTwo;
export type GetCurrentGoodVibe200 = {
  data: GetCurrentGoodVibeResponseDto;
};
export type GetCurrentGoodVibe500AllOf = {
  error: ApiError;
};
export type GetCurrentGoodVibe500AllOfTwoErrorCode =
  (typeof GetCurrentGoodVibe500AllOfTwoErrorCode)[keyof typeof GetCurrentGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrentGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetCurrentGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetCurrentGoodVibe500AllOfTwoErrorCode;
};
export type GetCurrentGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetCurrentGoodVibe500AllOfTwoError;
};
export type GetCurrentGoodVibe500 = ApiErrorResponseDto &
  GetCurrentGoodVibe500AllOf &
  GetCurrentGoodVibe500AllOfTwo;
export type SetNextDayGoodVibe200 = {
  data: SetNextDayGoodVibeResponseDto;
};
export type SetNextDayGoodVibe401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type SetNextDayGoodVibe401AllOf = {
  error: SetNextDayGoodVibe401AllOfError;
};
export type SetNextDayGoodVibe401AllOfThreeErrorCode =
  (typeof SetNextDayGoodVibe401AllOfThreeErrorCode)[keyof typeof SetNextDayGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetNextDayGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type SetNextDayGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: SetNextDayGoodVibe401AllOfThreeErrorCode;
};
export type SetNextDayGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: SetNextDayGoodVibe401AllOfThreeError;
};
export type SetNextDayGoodVibe401 = ApiErrorResponseDto &
  SetNextDayGoodVibe401AllOf &
  SetNextDayGoodVibe401AllOfThree;
export type SetNextDayGoodVibe500AllOf = {
  error: ApiError;
};
export type SetNextDayGoodVibe500AllOfTwoErrorCode =
  (typeof SetNextDayGoodVibe500AllOfTwoErrorCode)[keyof typeof SetNextDayGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetNextDayGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type SetNextDayGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SetNextDayGoodVibe500AllOfTwoErrorCode;
};
export type SetNextDayGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SetNextDayGoodVibe500AllOfTwoError;
};
export type SetNextDayGoodVibe500 = ApiErrorResponseDto &
  SetNextDayGoodVibe500AllOf &
  SetNextDayGoodVibe500AllOfTwo;
export type CompleteGoodVibe200 = {
  data: CompletedGoodVibeResponseDto;
};
export type CompleteGoodVibe401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type CompleteGoodVibe401AllOf = {
  error: CompleteGoodVibe401AllOfError;
};
export type CompleteGoodVibe401AllOfThreeErrorCode =
  (typeof CompleteGoodVibe401AllOfThreeErrorCode)[keyof typeof CompleteGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CompleteGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CompleteGoodVibe401AllOfThreeErrorCode;
};
export type CompleteGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CompleteGoodVibe401AllOfThreeError;
};
export type CompleteGoodVibe401 = ApiErrorResponseDto &
  CompleteGoodVibe401AllOf &
  CompleteGoodVibe401AllOfThree;
export type CompleteGoodVibe500AllOf = {
  error: ApiError;
};
export type CompleteGoodVibe500AllOfTwoErrorCode =
  (typeof CompleteGoodVibe500AllOfTwoErrorCode)[keyof typeof CompleteGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CompleteGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CompleteGoodVibe500AllOfTwoErrorCode;
};
export type CompleteGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CompleteGoodVibe500AllOfTwoError;
};
export type CompleteGoodVibe500 = ApiErrorResponseDto &
  CompleteGoodVibe500AllOf &
  CompleteGoodVibe500AllOfTwo;
export type ResetCurrentGoodVibe200 = {
  data: ResetCurrentGoodVibeResponseDto;
};
export type ResetCurrentGoodVibe401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type ResetCurrentGoodVibe401AllOf = {
  error: ResetCurrentGoodVibe401AllOfError;
};
export type ResetCurrentGoodVibe401AllOfThreeErrorCode =
  (typeof ResetCurrentGoodVibe401AllOfThreeErrorCode)[keyof typeof ResetCurrentGoodVibe401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetCurrentGoodVibe401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ResetCurrentGoodVibe401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ResetCurrentGoodVibe401AllOfThreeErrorCode;
};
export type ResetCurrentGoodVibe401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ResetCurrentGoodVibe401AllOfThreeError;
};
export type ResetCurrentGoodVibe401 = ApiErrorResponseDto &
  ResetCurrentGoodVibe401AllOf &
  ResetCurrentGoodVibe401AllOfThree;
export type ResetCurrentGoodVibe500AllOf = {
  error: ApiError;
};
export type ResetCurrentGoodVibe500AllOfTwoErrorCode =
  (typeof ResetCurrentGoodVibe500AllOfTwoErrorCode)[keyof typeof ResetCurrentGoodVibe500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetCurrentGoodVibe500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ResetCurrentGoodVibe500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ResetCurrentGoodVibe500AllOfTwoErrorCode;
};
export type ResetCurrentGoodVibe500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ResetCurrentGoodVibe500AllOfTwoError;
};
export type ResetCurrentGoodVibe500 = ApiErrorResponseDto &
  ResetCurrentGoodVibe500AllOf &
  ResetCurrentGoodVibe500AllOfTwo;
export type CompleteDailyGood200 = {
  data: CompletedDailyGoodResponseDto;
};
export type CompleteDailyGood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type CompleteDailyGood401AllOf = {
  error: CompleteDailyGood401AllOfError;
};
export type CompleteDailyGood401AllOfThreeErrorCode =
  (typeof CompleteDailyGood401AllOfThreeErrorCode)[keyof typeof CompleteDailyGood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteDailyGood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CompleteDailyGood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CompleteDailyGood401AllOfThreeErrorCode;
};
export type CompleteDailyGood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CompleteDailyGood401AllOfThreeError;
};
export type CompleteDailyGood401 = ApiErrorResponseDto &
  CompleteDailyGood401AllOf &
  CompleteDailyGood401AllOfThree;
export type CompleteDailyGood500AllOf = {
  error: ApiError;
};
export type CompleteDailyGood500AllOfTwoErrorCode =
  (typeof CompleteDailyGood500AllOfTwoErrorCode)[keyof typeof CompleteDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CompleteDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CompleteDailyGood500AllOfTwoErrorCode;
};
export type CompleteDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CompleteDailyGood500AllOfTwoError;
};
export type CompleteDailyGood500 = ApiErrorResponseDto &
  CompleteDailyGood500AllOf &
  CompleteDailyGood500AllOfTwo;
export type DailyGoodsParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: DailyGoodsSortBy;
  sortDirection?: DailyGoodsSortDirection;
};
export type DailyGoodsSortBy =
  (typeof DailyGoodsSortBy)[keyof typeof DailyGoodsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyGoodsSortBy = {
  createdAt: 'createdAt'
} as const;
export type DailyGoodsSortDirection =
  (typeof DailyGoodsSortDirection)[keyof typeof DailyGoodsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyGoodsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type DailyGoods200 = {
  data: GetDailyGoodsDataDto;
  meta?: GetDailyGoodsMetaDto;
};
export type DailyGoods500AllOf = {
  error: ApiError;
};
export type DailyGoods500AllOfTwoErrorCode =
  (typeof DailyGoods500AllOfTwoErrorCode)[keyof typeof DailyGoods500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyGoods500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DailyGoods500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DailyGoods500AllOfTwoErrorCode;
};
export type DailyGoods500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DailyGoods500AllOfTwoError;
};
export type DailyGoods500 = ApiErrorResponseDto &
  DailyGoods500AllOf &
  DailyGoods500AllOfTwo;
export type CreateDailyGood200 = {
  data: GetDailyGoodResponseDto;
};
export type CreateDailyGood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type CreateDailyGood401AllOf = {
  error: CreateDailyGood401AllOfError;
};
export type CreateDailyGood401AllOfThreeErrorCode =
  (typeof CreateDailyGood401AllOfThreeErrorCode)[keyof typeof CreateDailyGood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDailyGood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CreateDailyGood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateDailyGood401AllOfThreeErrorCode;
};
export type CreateDailyGood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateDailyGood401AllOfThreeError;
};
export type CreateDailyGood401 = ApiErrorResponseDto &
  CreateDailyGood401AllOf &
  CreateDailyGood401AllOfThree;
export type CreateDailyGood500AllOf = {
  error: ApiError;
};
export type CreateDailyGood500AllOfTwoErrorCode =
  (typeof CreateDailyGood500AllOfTwoErrorCode)[keyof typeof CreateDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateDailyGood500AllOfTwoErrorCode;
};
export type CreateDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateDailyGood500AllOfTwoError;
};
export type CreateDailyGood500 = ApiErrorResponseDto &
  CreateDailyGood500AllOf &
  CreateDailyGood500AllOfTwo;
export type GetCurrentDailyGood200 = {
  data: GetDailyGoodResponseDto;
};
export type GetCurrentDailyGood500AllOf = {
  error: ApiError;
};
export type GetCurrentDailyGood500AllOfTwoErrorCode =
  (typeof GetCurrentDailyGood500AllOfTwoErrorCode)[keyof typeof GetCurrentDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrentDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetCurrentDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetCurrentDailyGood500AllOfTwoErrorCode;
};
export type GetCurrentDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetCurrentDailyGood500AllOfTwoError;
};
export type GetCurrentDailyGood500 = ApiErrorResponseDto &
  GetCurrentDailyGood500AllOf &
  GetCurrentDailyGood500AllOfTwo;
export type GetDailyGood200 = {
  data: GetDailyGoodResponseDto;
};
export type GetDailyGood500AllOf = {
  error: ApiError;
};
export type GetDailyGood500AllOfTwoErrorCode =
  (typeof GetDailyGood500AllOfTwoErrorCode)[keyof typeof GetDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetDailyGood500AllOfTwoErrorCode;
};
export type GetDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetDailyGood500AllOfTwoError;
};
export type GetDailyGood500 = ApiErrorResponseDto &
  GetDailyGood500AllOf &
  GetDailyGood500AllOfTwo;
export type UpdateDailyGood200 = {
  data: GetDailyGoodResponseDto;
};
export type UpdateDailyGood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateDailyGood401AllOf = {
  error: UpdateDailyGood401AllOfError;
};
export type UpdateDailyGood401AllOfThreeErrorCode =
  (typeof UpdateDailyGood401AllOfThreeErrorCode)[keyof typeof UpdateDailyGood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDailyGood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type UpdateDailyGood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateDailyGood401AllOfThreeErrorCode;
};
export type UpdateDailyGood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateDailyGood401AllOfThreeError;
};
export type UpdateDailyGood401 = ApiErrorResponseDto &
  UpdateDailyGood401AllOf &
  UpdateDailyGood401AllOfThree;
export type UpdateDailyGood500AllOf = {
  error: ApiError;
};
export type UpdateDailyGood500AllOfTwoErrorCode =
  (typeof UpdateDailyGood500AllOfTwoErrorCode)[keyof typeof UpdateDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateDailyGood500AllOfTwoErrorCode;
};
export type UpdateDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateDailyGood500AllOfTwoError;
};
export type UpdateDailyGood500 = ApiErrorResponseDto &
  UpdateDailyGood500AllOf &
  UpdateDailyGood500AllOfTwo;
export type DeleteDailyGood200 = {
  data: GetDailyGoodResponseDto;
};
export type DeleteDailyGood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type DeleteDailyGood401AllOf = {
  error: DeleteDailyGood401AllOfError;
};
export type DeleteDailyGood401AllOfThreeErrorCode =
  (typeof DeleteDailyGood401AllOfThreeErrorCode)[keyof typeof DeleteDailyGood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteDailyGood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type DeleteDailyGood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteDailyGood401AllOfThreeErrorCode;
};
export type DeleteDailyGood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteDailyGood401AllOfThreeError;
};
export type DeleteDailyGood401 = ApiErrorResponseDto &
  DeleteDailyGood401AllOf &
  DeleteDailyGood401AllOfThree;
export type DeleteDailyGood500AllOf = {
  error: ApiError;
};
export type DeleteDailyGood500AllOfTwoErrorCode =
  (typeof DeleteDailyGood500AllOfTwoErrorCode)[keyof typeof DeleteDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteDailyGood500AllOfTwoErrorCode;
};
export type DeleteDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteDailyGood500AllOfTwoError;
};
export type DeleteDailyGood500 = ApiErrorResponseDto &
  DeleteDailyGood500AllOf &
  DeleteDailyGood500AllOfTwo;
export type ResetCurrentDailyGood200 = {
  data: ResetCurrentDailyGoodResponseDto;
};
export type ResetCurrentDailyGood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type ResetCurrentDailyGood401AllOf = {
  error: ResetCurrentDailyGood401AllOfError;
};
export type ResetCurrentDailyGood401AllOfThreeErrorCode =
  (typeof ResetCurrentDailyGood401AllOfThreeErrorCode)[keyof typeof ResetCurrentDailyGood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetCurrentDailyGood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ResetCurrentDailyGood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ResetCurrentDailyGood401AllOfThreeErrorCode;
};
export type ResetCurrentDailyGood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ResetCurrentDailyGood401AllOfThreeError;
};
export type ResetCurrentDailyGood401 = ApiErrorResponseDto &
  ResetCurrentDailyGood401AllOf &
  ResetCurrentDailyGood401AllOfThree;
export type ResetCurrentDailyGood500AllOf = {
  error: ApiError;
};
export type ResetCurrentDailyGood500AllOfTwoErrorCode =
  (typeof ResetCurrentDailyGood500AllOfTwoErrorCode)[keyof typeof ResetCurrentDailyGood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResetCurrentDailyGood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ResetCurrentDailyGood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ResetCurrentDailyGood500AllOfTwoErrorCode;
};
export type ResetCurrentDailyGood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ResetCurrentDailyGood500AllOfTwoError;
};
export type ResetCurrentDailyGood500 = ApiErrorResponseDto &
  ResetCurrentDailyGood500AllOf &
  ResetCurrentDailyGood500AllOfTwo;
export type RafflesParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: RafflesSortBy;
  sortDirection?: RafflesSortDirection;
};
export type RafflesSortBy = (typeof RafflesSortBy)[keyof typeof RafflesSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RafflesSortBy = {
  title: 'title',
  createdAt: 'createdAt'
} as const;
export type RafflesSortDirection =
  (typeof RafflesSortDirection)[keyof typeof RafflesSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RafflesSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type Raffles200 = {
  data: GetRafflesDataDto;
  meta?: GetRafflesMetaDto;
};
export type Raffles401AllOfError = JsonWebTokenError | TokenExpiredError;
export type Raffles401AllOf = {
  error: Raffles401AllOfError;
};
export type Raffles401AllOfThreeErrorCode =
  (typeof Raffles401AllOfThreeErrorCode)[keyof typeof Raffles401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Raffles401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type Raffles401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Raffles401AllOfThreeErrorCode;
};
export type Raffles401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Raffles401AllOfThreeError;
};
export type Raffles401 = ApiErrorResponseDto &
  Raffles401AllOf &
  Raffles401AllOfThree;
export type Raffles500AllOf = {
  error: ApiError;
};
export type Raffles500AllOfTwoErrorCode =
  (typeof Raffles500AllOfTwoErrorCode)[keyof typeof Raffles500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Raffles500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Raffles500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Raffles500AllOfTwoErrorCode;
};
export type Raffles500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Raffles500AllOfTwoError;
};
export type Raffles500 = ApiErrorResponseDto &
  Raffles500AllOf &
  Raffles500AllOfTwo;
export type CreateRaffle200 = {
  data: GetRaffleResponseDto;
};
export type CreateRaffle401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type CreateRaffle401AllOf = {
  error: CreateRaffle401AllOfError;
};
export type CreateRaffle401AllOfThreeErrorCode =
  (typeof CreateRaffle401AllOfThreeErrorCode)[keyof typeof CreateRaffle401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRaffle401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type CreateRaffle401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateRaffle401AllOfThreeErrorCode;
};
export type CreateRaffle401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateRaffle401AllOfThreeError;
};
export type CreateRaffle401 = ApiErrorResponseDto &
  CreateRaffle401AllOf &
  CreateRaffle401AllOfThree;
export type CreateRaffle500AllOf = {
  error: ApiError;
};
export type CreateRaffle500AllOfTwoErrorCode =
  (typeof CreateRaffle500AllOfTwoErrorCode)[keyof typeof CreateRaffle500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRaffle500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateRaffle500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateRaffle500AllOfTwoErrorCode;
};
export type CreateRaffle500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateRaffle500AllOfTwoError;
};
export type CreateRaffle500 = ApiErrorResponseDto &
  CreateRaffle500AllOf &
  CreateRaffle500AllOfTwo;
export type GetRaffle200 = {
  data: GetRaffleResponseDto;
};
export type GetRaffle401AllOfError = JsonWebTokenError | TokenExpiredError;
export type GetRaffle401AllOf = {
  error: GetRaffle401AllOfError;
};
export type GetRaffle401AllOfThreeErrorCode =
  (typeof GetRaffle401AllOfThreeErrorCode)[keyof typeof GetRaffle401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffle401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetRaffle401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetRaffle401AllOfThreeErrorCode;
};
export type GetRaffle401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetRaffle401AllOfThreeError;
};
export type GetRaffle401 = ApiErrorResponseDto &
  GetRaffle401AllOf &
  GetRaffle401AllOfThree;
export type GetRaffle404AllOf = {
  error: EntityNotFoundError;
};
export type GetRaffle404AllOfTwoErrorCode =
  (typeof GetRaffle404AllOfTwoErrorCode)[keyof typeof GetRaffle404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffle404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetRaffle404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetRaffle404AllOfTwoErrorCode;
};
export type GetRaffle404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetRaffle404AllOfTwoError;
};
export type GetRaffle404 = ApiErrorResponseDto &
  GetRaffle404AllOf &
  GetRaffle404AllOfTwo;
export type GetRaffle500AllOf = {
  error: ApiError;
};
export type GetRaffle500AllOfTwoErrorCode =
  (typeof GetRaffle500AllOfTwoErrorCode)[keyof typeof GetRaffle500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffle500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetRaffle500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetRaffle500AllOfTwoErrorCode;
};
export type GetRaffle500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetRaffle500AllOfTwoError;
};
export type GetRaffle500 = ApiErrorResponseDto &
  GetRaffle500AllOf &
  GetRaffle500AllOfTwo;
export type UpdateRaffle200 = {
  data: GetRaffleResponseDto;
};
export type UpdateRaffle401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateRaffle401AllOf = {
  error: UpdateRaffle401AllOfError;
};
export type UpdateRaffle401AllOfThreeErrorCode =
  (typeof UpdateRaffle401AllOfThreeErrorCode)[keyof typeof UpdateRaffle401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRaffle401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdateRaffle401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateRaffle401AllOfThreeErrorCode;
};
export type UpdateRaffle401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateRaffle401AllOfThreeError;
};
export type UpdateRaffle401 = ApiErrorResponseDto &
  UpdateRaffle401AllOf &
  UpdateRaffle401AllOfThree;
export type UpdateRaffle404AllOf = {
  error: EntityNotFoundError;
};
export type UpdateRaffle404AllOfTwoErrorCode =
  (typeof UpdateRaffle404AllOfTwoErrorCode)[keyof typeof UpdateRaffle404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRaffle404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdateRaffle404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdateRaffle404AllOfTwoErrorCode;
};
export type UpdateRaffle404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdateRaffle404AllOfTwoError;
};
export type UpdateRaffle404 = ApiErrorResponseDto &
  UpdateRaffle404AllOf &
  UpdateRaffle404AllOfTwo;
export type UpdateRaffle500AllOf = {
  error: ApiError;
};
export type UpdateRaffle500AllOfTwoErrorCode =
  (typeof UpdateRaffle500AllOfTwoErrorCode)[keyof typeof UpdateRaffle500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRaffle500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateRaffle500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateRaffle500AllOfTwoErrorCode;
};
export type UpdateRaffle500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateRaffle500AllOfTwoError;
};
export type UpdateRaffle500 = ApiErrorResponseDto &
  UpdateRaffle500AllOf &
  UpdateRaffle500AllOfTwo;
export type DeleteRaffle200 = {
  data: GetRaffleResponseDto;
};
export type DeleteRaffle401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type DeleteRaffle401AllOf = {
  error: DeleteRaffle401AllOfError;
};
export type DeleteRaffle401AllOfThreeErrorCode =
  (typeof DeleteRaffle401AllOfThreeErrorCode)[keyof typeof DeleteRaffle401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteRaffle401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type DeleteRaffle401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteRaffle401AllOfThreeErrorCode;
};
export type DeleteRaffle401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteRaffle401AllOfThreeError;
};
export type DeleteRaffle401 = ApiErrorResponseDto &
  DeleteRaffle401AllOf &
  DeleteRaffle401AllOfThree;
export type DeleteRaffle404AllOf = {
  error: EntityNotFoundError;
};
export type DeleteRaffle404AllOfTwoErrorCode =
  (typeof DeleteRaffle404AllOfTwoErrorCode)[keyof typeof DeleteRaffle404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteRaffle404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type DeleteRaffle404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: DeleteRaffle404AllOfTwoErrorCode;
};
export type DeleteRaffle404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: DeleteRaffle404AllOfTwoError;
};
export type DeleteRaffle404 = ApiErrorResponseDto &
  DeleteRaffle404AllOf &
  DeleteRaffle404AllOfTwo;
export type DeleteRaffle500AllOf = {
  error: ApiError;
};
export type DeleteRaffle500AllOfTwoErrorCode =
  (typeof DeleteRaffle500AllOfTwoErrorCode)[keyof typeof DeleteRaffle500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteRaffle500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteRaffle500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteRaffle500AllOfTwoErrorCode;
};
export type DeleteRaffle500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteRaffle500AllOfTwoError;
};
export type DeleteRaffle500 = ApiErrorResponseDto &
  DeleteRaffle500AllOf &
  DeleteRaffle500AllOfTwo;
export type EnterRaffle200 = {
  data: EnterRaffleResponseDto;
};
export type EnterRaffle400AllOf = {
  error: InsufficientPointsError;
};
export type EnterRaffle400AllOfTwoErrorCode =
  (typeof EnterRaffle400AllOfTwoErrorCode)[keyof typeof EnterRaffle400AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnterRaffle400AllOfTwoErrorCode = {
  InsufficientPointsError: 'InsufficientPointsError'
} as const;
export type EnterRaffle400AllOfTwoError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: EnterRaffle400AllOfTwoErrorCode;
};
export type EnterRaffle400AllOfTwo = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: EnterRaffle400AllOfTwoError;
};
export type EnterRaffle400 = ApiErrorResponseDto &
  EnterRaffle400AllOf &
  EnterRaffle400AllOfTwo;
export type EnterRaffle401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type EnterRaffle401AllOf = {
  error: EnterRaffle401AllOfError;
};
export type EnterRaffle401AllOfThreeErrorCode =
  (typeof EnterRaffle401AllOfThreeErrorCode)[keyof typeof EnterRaffle401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnterRaffle401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type EnterRaffle401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: EnterRaffle401AllOfThreeErrorCode;
};
export type EnterRaffle401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: EnterRaffle401AllOfThreeError;
};
export type EnterRaffle401 = ApiErrorResponseDto &
  EnterRaffle401AllOf &
  EnterRaffle401AllOfThree;
export type EnterRaffle404AllOf = {
  error: EntityNotFoundError;
};
export type EnterRaffle404AllOfTwoErrorCode =
  (typeof EnterRaffle404AllOfTwoErrorCode)[keyof typeof EnterRaffle404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnterRaffle404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type EnterRaffle404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: EnterRaffle404AllOfTwoErrorCode;
};
export type EnterRaffle404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: EnterRaffle404AllOfTwoError;
};
export type EnterRaffle404 = ApiErrorResponseDto &
  EnterRaffle404AllOf &
  EnterRaffle404AllOfTwo;
export type EnterRaffle500AllOf = {
  error: ApiError;
};
export type EnterRaffle500AllOfTwoErrorCode =
  (typeof EnterRaffle500AllOfTwoErrorCode)[keyof typeof EnterRaffle500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnterRaffle500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type EnterRaffle500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: EnterRaffle500AllOfTwoErrorCode;
};
export type EnterRaffle500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: EnterRaffle500AllOfTwoError;
};
export type EnterRaffle500 = ApiErrorResponseDto &
  EnterRaffle500AllOf &
  EnterRaffle500AllOfTwo;
export type GetMyRafflesParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetMyRafflesSortBy;
  sortDirection?: GetMyRafflesSortDirection;
};
export type GetMyRafflesSortBy =
  (typeof GetMyRafflesSortBy)[keyof typeof GetMyRafflesSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyRafflesSortBy = {
  createdAt: 'createdAt'
} as const;
export type GetMyRafflesSortDirection =
  (typeof GetMyRafflesSortDirection)[keyof typeof GetMyRafflesSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyRafflesSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetMyRaffles200 = {
  data: GetMyRafflesDataDto;
  meta?: GetMyRafflesMetaDto;
};
export type GetMyRaffles401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetMyRaffles401AllOf = {
  error: GetMyRaffles401AllOfError;
};
export type GetMyRaffles401AllOfThreeErrorCode =
  (typeof GetMyRaffles401AllOfThreeErrorCode)[keyof typeof GetMyRaffles401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyRaffles401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetMyRaffles401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetMyRaffles401AllOfThreeErrorCode;
};
export type GetMyRaffles401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetMyRaffles401AllOfThreeError;
};
export type GetMyRaffles401 = ApiErrorResponseDto &
  GetMyRaffles401AllOf &
  GetMyRaffles401AllOfThree;
export type GetMyRaffles500AllOf = {
  error: ApiError;
};
export type GetMyRaffles500AllOfTwoErrorCode =
  (typeof GetMyRaffles500AllOfTwoErrorCode)[keyof typeof GetMyRaffles500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyRaffles500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetMyRaffles500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetMyRaffles500AllOfTwoErrorCode;
};
export type GetMyRaffles500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetMyRaffles500AllOfTwoError;
};
export type GetMyRaffles500 = ApiErrorResponseDto &
  GetMyRaffles500AllOf &
  GetMyRaffles500AllOfTwo;
export type GetRaffleParticipantsParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetRaffleParticipantsSortBy;
  sortDirection?: GetRaffleParticipantsSortDirection;
};
export type GetRaffleParticipantsSortBy =
  (typeof GetRaffleParticipantsSortBy)[keyof typeof GetRaffleParticipantsSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffleParticipantsSortBy = {
  createdAt: 'createdAt'
} as const;
export type GetRaffleParticipantsSortDirection =
  (typeof GetRaffleParticipantsSortDirection)[keyof typeof GetRaffleParticipantsSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffleParticipantsSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetRaffleParticipants200 = {
  data: GetRaffleParticipantsDataDto;
  meta?: GetRaffleParticipantsMetaDto;
};
export type GetRaffleParticipants401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetRaffleParticipants401AllOf = {
  error: GetRaffleParticipants401AllOfError;
};
export type GetRaffleParticipants401AllOfThreeErrorCode =
  (typeof GetRaffleParticipants401AllOfThreeErrorCode)[keyof typeof GetRaffleParticipants401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffleParticipants401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetRaffleParticipants401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetRaffleParticipants401AllOfThreeErrorCode;
};
export type GetRaffleParticipants401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetRaffleParticipants401AllOfThreeError;
};
export type GetRaffleParticipants401 = ApiErrorResponseDto &
  GetRaffleParticipants401AllOf &
  GetRaffleParticipants401AllOfThree;
export type GetRaffleParticipants404AllOf = {
  error: EntityNotFoundError;
};
export type GetRaffleParticipants404AllOfTwoErrorCode =
  (typeof GetRaffleParticipants404AllOfTwoErrorCode)[keyof typeof GetRaffleParticipants404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffleParticipants404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetRaffleParticipants404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetRaffleParticipants404AllOfTwoErrorCode;
};
export type GetRaffleParticipants404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetRaffleParticipants404AllOfTwoError;
};
export type GetRaffleParticipants404 = ApiErrorResponseDto &
  GetRaffleParticipants404AllOf &
  GetRaffleParticipants404AllOfTwo;
export type GetRaffleParticipants500AllOf = {
  error: ApiError;
};
export type GetRaffleParticipants500AllOfTwoErrorCode =
  (typeof GetRaffleParticipants500AllOfTwoErrorCode)[keyof typeof GetRaffleParticipants500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRaffleParticipants500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetRaffleParticipants500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetRaffleParticipants500AllOfTwoErrorCode;
};
export type GetRaffleParticipants500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetRaffleParticipants500AllOfTwoError;
};
export type GetRaffleParticipants500 = ApiErrorResponseDto &
  GetRaffleParticipants500AllOf &
  GetRaffleParticipants500AllOfTwo;
export type CloseRaffleAndPickWinner200 = {
  data: CloseRaffleAndPickWinnerResponseDto;
};
export type CloseRaffleAndPickWinner400AllOf = {
  error: InvalidOperationError;
};
export type CloseRaffleAndPickWinner400AllOfTwoErrorCode =
  (typeof CloseRaffleAndPickWinner400AllOfTwoErrorCode)[keyof typeof CloseRaffleAndPickWinner400AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseRaffleAndPickWinner400AllOfTwoErrorCode = {
  InvalidOperationError: 'InvalidOperationError'
} as const;
export type CloseRaffleAndPickWinner400AllOfTwoError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: CloseRaffleAndPickWinner400AllOfTwoErrorCode;
};
export type CloseRaffleAndPickWinner400AllOfTwo = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: CloseRaffleAndPickWinner400AllOfTwoError;
};
export type CloseRaffleAndPickWinner400 = ApiErrorResponseDto &
  CloseRaffleAndPickWinner400AllOf &
  CloseRaffleAndPickWinner400AllOfTwo;
export type CloseRaffleAndPickWinner401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type CloseRaffleAndPickWinner401AllOf = {
  error: CloseRaffleAndPickWinner401AllOfError;
};
export type CloseRaffleAndPickWinner401AllOfThreeErrorCode =
  (typeof CloseRaffleAndPickWinner401AllOfThreeErrorCode)[keyof typeof CloseRaffleAndPickWinner401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseRaffleAndPickWinner401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type CloseRaffleAndPickWinner401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CloseRaffleAndPickWinner401AllOfThreeErrorCode;
};
export type CloseRaffleAndPickWinner401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CloseRaffleAndPickWinner401AllOfThreeError;
};
export type CloseRaffleAndPickWinner401 = ApiErrorResponseDto &
  CloseRaffleAndPickWinner401AllOf &
  CloseRaffleAndPickWinner401AllOfThree;
export type CloseRaffleAndPickWinner500AllOf = {
  error: ApiError;
};
export type CloseRaffleAndPickWinner500AllOfTwoErrorCode =
  (typeof CloseRaffleAndPickWinner500AllOfTwoErrorCode)[keyof typeof CloseRaffleAndPickWinner500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseRaffleAndPickWinner500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CloseRaffleAndPickWinner500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CloseRaffleAndPickWinner500AllOfTwoErrorCode;
};
export type CloseRaffleAndPickWinner500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CloseRaffleAndPickWinner500AllOfTwoError;
};
export type CloseRaffleAndPickWinner500 = ApiErrorResponseDto &
  CloseRaffleAndPickWinner500AllOf &
  CloseRaffleAndPickWinner500AllOfTwo;
export type MerchandisesParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: MerchandisesSortBy;
  sortDirection?: MerchandisesSortDirection;
};
export type MerchandisesSortBy =
  (typeof MerchandisesSortBy)[keyof typeof MerchandisesSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MerchandisesSortBy = {
  title: 'title',
  subtitle: 'subtitle',
  createdAt: 'createdAt'
} as const;
export type MerchandisesSortDirection =
  (typeof MerchandisesSortDirection)[keyof typeof MerchandisesSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MerchandisesSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type Merchandises200 = {
  data: GetMerchandisesDataDto;
  meta?: GetMerchandisesMetaDto;
};
export type Merchandises401AllOfError = JsonWebTokenError | TokenExpiredError;
export type Merchandises401AllOf = {
  error: Merchandises401AllOfError;
};
export type Merchandises401AllOfThreeErrorCode =
  (typeof Merchandises401AllOfThreeErrorCode)[keyof typeof Merchandises401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Merchandises401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type Merchandises401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: Merchandises401AllOfThreeErrorCode;
};
export type Merchandises401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: Merchandises401AllOfThreeError;
};
export type Merchandises401 = ApiErrorResponseDto &
  Merchandises401AllOf &
  Merchandises401AllOfThree;
export type Merchandises500AllOf = {
  error: ApiError;
};
export type Merchandises500AllOfTwoErrorCode =
  (typeof Merchandises500AllOfTwoErrorCode)[keyof typeof Merchandises500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Merchandises500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type Merchandises500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: Merchandises500AllOfTwoErrorCode;
};
export type Merchandises500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: Merchandises500AllOfTwoError;
};
export type Merchandises500 = ApiErrorResponseDto &
  Merchandises500AllOf &
  Merchandises500AllOfTwo;
export type CreateMerchandise200 = {
  data: GetMerchandiseResponseDto;
};
export type CreateMerchandise401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type CreateMerchandise401AllOf = {
  error: CreateMerchandise401AllOfError;
};
export type CreateMerchandise401AllOfThreeErrorCode =
  (typeof CreateMerchandise401AllOfThreeErrorCode)[keyof typeof CreateMerchandise401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMerchandise401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type CreateMerchandise401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateMerchandise401AllOfThreeErrorCode;
};
export type CreateMerchandise401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateMerchandise401AllOfThreeError;
};
export type CreateMerchandise401 = ApiErrorResponseDto &
  CreateMerchandise401AllOf &
  CreateMerchandise401AllOfThree;
export type CreateMerchandise500AllOf = {
  error: ApiError;
};
export type CreateMerchandise500AllOfTwoErrorCode =
  (typeof CreateMerchandise500AllOfTwoErrorCode)[keyof typeof CreateMerchandise500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMerchandise500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateMerchandise500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateMerchandise500AllOfTwoErrorCode;
};
export type CreateMerchandise500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateMerchandise500AllOfTwoError;
};
export type CreateMerchandise500 = ApiErrorResponseDto &
  CreateMerchandise500AllOf &
  CreateMerchandise500AllOfTwo;
export type GetMerchandise200 = {
  data: GetMerchandiseResponseDto;
};
export type GetMerchandise401AllOfError = JsonWebTokenError | TokenExpiredError;
export type GetMerchandise401AllOf = {
  error: GetMerchandise401AllOfError;
};
export type GetMerchandise401AllOfThreeErrorCode =
  (typeof GetMerchandise401AllOfThreeErrorCode)[keyof typeof GetMerchandise401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMerchandise401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetMerchandise401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetMerchandise401AllOfThreeErrorCode;
};
export type GetMerchandise401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetMerchandise401AllOfThreeError;
};
export type GetMerchandise401 = ApiErrorResponseDto &
  GetMerchandise401AllOf &
  GetMerchandise401AllOfThree;
export type GetMerchandise404AllOf = {
  error: EntityNotFoundError;
};
export type GetMerchandise404AllOfTwoErrorCode =
  (typeof GetMerchandise404AllOfTwoErrorCode)[keyof typeof GetMerchandise404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMerchandise404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetMerchandise404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetMerchandise404AllOfTwoErrorCode;
};
export type GetMerchandise404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetMerchandise404AllOfTwoError;
};
export type GetMerchandise404 = ApiErrorResponseDto &
  GetMerchandise404AllOf &
  GetMerchandise404AllOfTwo;
export type GetMerchandise500AllOf = {
  error: ApiError;
};
export type GetMerchandise500AllOfTwoErrorCode =
  (typeof GetMerchandise500AllOfTwoErrorCode)[keyof typeof GetMerchandise500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMerchandise500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetMerchandise500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetMerchandise500AllOfTwoErrorCode;
};
export type GetMerchandise500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetMerchandise500AllOfTwoError;
};
export type GetMerchandise500 = ApiErrorResponseDto &
  GetMerchandise500AllOf &
  GetMerchandise500AllOfTwo;
export type UpdateMerchandise200 = {
  data: GetMerchandiseResponseDto;
};
export type UpdateMerchandise401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateMerchandise401AllOf = {
  error: UpdateMerchandise401AllOfError;
};
export type UpdateMerchandise401AllOfThreeErrorCode =
  (typeof UpdateMerchandise401AllOfThreeErrorCode)[keyof typeof UpdateMerchandise401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMerchandise401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdateMerchandise401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateMerchandise401AllOfThreeErrorCode;
};
export type UpdateMerchandise401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateMerchandise401AllOfThreeError;
};
export type UpdateMerchandise401 = ApiErrorResponseDto &
  UpdateMerchandise401AllOf &
  UpdateMerchandise401AllOfThree;
export type UpdateMerchandise404AllOf = {
  error: EntityNotFoundError;
};
export type UpdateMerchandise404AllOfTwoErrorCode =
  (typeof UpdateMerchandise404AllOfTwoErrorCode)[keyof typeof UpdateMerchandise404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMerchandise404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdateMerchandise404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdateMerchandise404AllOfTwoErrorCode;
};
export type UpdateMerchandise404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdateMerchandise404AllOfTwoError;
};
export type UpdateMerchandise404 = ApiErrorResponseDto &
  UpdateMerchandise404AllOf &
  UpdateMerchandise404AllOfTwo;
export type UpdateMerchandise500AllOf = {
  error: ApiError;
};
export type UpdateMerchandise500AllOfTwoErrorCode =
  (typeof UpdateMerchandise500AllOfTwoErrorCode)[keyof typeof UpdateMerchandise500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMerchandise500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateMerchandise500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateMerchandise500AllOfTwoErrorCode;
};
export type UpdateMerchandise500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateMerchandise500AllOfTwoError;
};
export type UpdateMerchandise500 = ApiErrorResponseDto &
  UpdateMerchandise500AllOf &
  UpdateMerchandise500AllOfTwo;
export type DeleteMerchandise200 = {
  data: GetMerchandiseResponseDto;
};
export type DeleteMerchandise401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type DeleteMerchandise401AllOf = {
  error: DeleteMerchandise401AllOfError;
};
export type DeleteMerchandise401AllOfThreeErrorCode =
  (typeof DeleteMerchandise401AllOfThreeErrorCode)[keyof typeof DeleteMerchandise401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteMerchandise401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type DeleteMerchandise401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteMerchandise401AllOfThreeErrorCode;
};
export type DeleteMerchandise401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteMerchandise401AllOfThreeError;
};
export type DeleteMerchandise401 = ApiErrorResponseDto &
  DeleteMerchandise401AllOf &
  DeleteMerchandise401AllOfThree;
export type DeleteMerchandise404AllOf = {
  error: EntityNotFoundError;
};
export type DeleteMerchandise404AllOfTwoErrorCode =
  (typeof DeleteMerchandise404AllOfTwoErrorCode)[keyof typeof DeleteMerchandise404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteMerchandise404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type DeleteMerchandise404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: DeleteMerchandise404AllOfTwoErrorCode;
};
export type DeleteMerchandise404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: DeleteMerchandise404AllOfTwoError;
};
export type DeleteMerchandise404 = ApiErrorResponseDto &
  DeleteMerchandise404AllOf &
  DeleteMerchandise404AllOfTwo;
export type DeleteMerchandise500AllOf = {
  error: ApiError;
};
export type DeleteMerchandise500AllOfTwoErrorCode =
  (typeof DeleteMerchandise500AllOfTwoErrorCode)[keyof typeof DeleteMerchandise500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteMerchandise500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteMerchandise500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteMerchandise500AllOfTwoErrorCode;
};
export type DeleteMerchandise500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteMerchandise500AllOfTwoError;
};
export type DeleteMerchandise500 = ApiErrorResponseDto &
  DeleteMerchandise500AllOf &
  DeleteMerchandise500AllOfTwo;
export type GetOrdersParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetOrdersSortBy;
  sortDirection?: GetOrdersSortDirection;
};
export type GetOrdersSortBy =
  (typeof GetOrdersSortBy)[keyof typeof GetOrdersSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrdersSortBy = {
  createdAt: 'createdAt'
} as const;
export type GetOrdersSortDirection =
  (typeof GetOrdersSortDirection)[keyof typeof GetOrdersSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrdersSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetOrders200 = {
  data: GetOrdersDataDto;
  meta?: GetOrdersMetaDto;
};
export type GetOrders401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetOrders401AllOf = {
  error: GetOrders401AllOfError;
};
export type GetOrders401AllOfThreeErrorCode =
  (typeof GetOrders401AllOfThreeErrorCode)[keyof typeof GetOrders401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrders401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetOrders401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetOrders401AllOfThreeErrorCode;
};
export type GetOrders401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetOrders401AllOfThreeError;
};
export type GetOrders401 = ApiErrorResponseDto &
  GetOrders401AllOf &
  GetOrders401AllOfThree;
export type GetOrders500AllOf = {
  error: ApiError;
};
export type GetOrders500AllOfTwoErrorCode =
  (typeof GetOrders500AllOfTwoErrorCode)[keyof typeof GetOrders500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrders500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetOrders500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetOrders500AllOfTwoErrorCode;
};
export type GetOrders500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetOrders500AllOfTwoError;
};
export type GetOrders500 = ApiErrorResponseDto &
  GetOrders500AllOf &
  GetOrders500AllOfTwo;
export type GetOrder200 = {
  data: GetOrderResponseDto;
};
export type GetOrder401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetOrder401AllOf = {
  error: GetOrder401AllOfError;
};
export type GetOrder401AllOfThreeErrorCode =
  (typeof GetOrder401AllOfThreeErrorCode)[keyof typeof GetOrder401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrder401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetOrder401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetOrder401AllOfThreeErrorCode;
};
export type GetOrder401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetOrder401AllOfThreeError;
};
export type GetOrder401 = ApiErrorResponseDto &
  GetOrder401AllOf &
  GetOrder401AllOfThree;
export type GetOrder404AllOf = {
  error: EntityNotFoundError;
};
export type GetOrder404AllOfTwoErrorCode =
  (typeof GetOrder404AllOfTwoErrorCode)[keyof typeof GetOrder404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrder404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetOrder404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetOrder404AllOfTwoErrorCode;
};
export type GetOrder404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetOrder404AllOfTwoError;
};
export type GetOrder404 = ApiErrorResponseDto &
  GetOrder404AllOf &
  GetOrder404AllOfTwo;
export type GetOrder500AllOf = {
  error: ApiError;
};
export type GetOrder500AllOfTwoErrorCode =
  (typeof GetOrder500AllOfTwoErrorCode)[keyof typeof GetOrder500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrder500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetOrder500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetOrder500AllOfTwoErrorCode;
};
export type GetOrder500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetOrder500AllOfTwoError;
};
export type GetOrder500 = ApiErrorResponseDto &
  GetOrder500AllOf &
  GetOrder500AllOfTwo;
export type CompleteOrder200 = {
  data: GetOrderResponseDto;
};
export type CompleteOrder401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type CompleteOrder401AllOf = {
  error: CompleteOrder401AllOfError;
};
export type CompleteOrder401AllOfThreeErrorCode =
  (typeof CompleteOrder401AllOfThreeErrorCode)[keyof typeof CompleteOrder401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteOrder401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type CompleteOrder401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CompleteOrder401AllOfThreeErrorCode;
};
export type CompleteOrder401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CompleteOrder401AllOfThreeError;
};
export type CompleteOrder401 = ApiErrorResponseDto &
  CompleteOrder401AllOf &
  CompleteOrder401AllOfThree;
export type CompleteOrder500AllOf = {
  error: ApiError;
};
export type CompleteOrder500AllOfTwoErrorCode =
  (typeof CompleteOrder500AllOfTwoErrorCode)[keyof typeof CompleteOrder500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompleteOrder500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CompleteOrder500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CompleteOrder500AllOfTwoErrorCode;
};
export type CompleteOrder500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CompleteOrder500AllOfTwoError;
};
export type CompleteOrder500 = ApiErrorResponseDto &
  CompleteOrder500AllOf &
  CompleteOrder500AllOfTwo;
export type GetMyOrdersParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetMyOrdersSortBy;
  sortDirection?: GetMyOrdersSortDirection;
};
export type GetMyOrdersSortBy =
  (typeof GetMyOrdersSortBy)[keyof typeof GetMyOrdersSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOrdersSortBy = {
  createdAt: 'createdAt'
} as const;
export type GetMyOrdersSortDirection =
  (typeof GetMyOrdersSortDirection)[keyof typeof GetMyOrdersSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOrdersSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetMyOrders200 = {
  data: GetOrdersDataDto;
  meta?: GetOrdersMetaDto;
};
export type GetMyOrders401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetMyOrders401AllOf = {
  error: GetMyOrders401AllOfError;
};
export type GetMyOrders401AllOfThreeErrorCode =
  (typeof GetMyOrders401AllOfThreeErrorCode)[keyof typeof GetMyOrders401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOrders401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetMyOrders401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetMyOrders401AllOfThreeErrorCode;
};
export type GetMyOrders401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetMyOrders401AllOfThreeError;
};
export type GetMyOrders401 = ApiErrorResponseDto &
  GetMyOrders401AllOf &
  GetMyOrders401AllOfThree;
export type GetMyOrders500AllOf = {
  error: ApiError;
};
export type GetMyOrders500AllOfTwoErrorCode =
  (typeof GetMyOrders500AllOfTwoErrorCode)[keyof typeof GetMyOrders500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOrders500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetMyOrders500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetMyOrders500AllOfTwoErrorCode;
};
export type GetMyOrders500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetMyOrders500AllOfTwoError;
};
export type GetMyOrders500 = ApiErrorResponseDto &
  GetMyOrders500AllOf &
  GetMyOrders500AllOfTwo;
export type GetUserOrdersParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: string;
  sortDirection?: string;
};
export type GetUserOrders200 = {
  data: GetOrdersDataDto;
};
export type GetUserOrders401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetUserOrders401AllOf = {
  error: GetUserOrders401AllOfError;
};
export type GetUserOrders401AllOfThreeErrorCode =
  (typeof GetUserOrders401AllOfThreeErrorCode)[keyof typeof GetUserOrders401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserOrders401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetUserOrders401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetUserOrders401AllOfThreeErrorCode;
};
export type GetUserOrders401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetUserOrders401AllOfThreeError;
};
export type GetUserOrders401 = ApiErrorResponseDto &
  GetUserOrders401AllOf &
  GetUserOrders401AllOfThree;
export type GetUserOrders500AllOf = {
  error: ApiError;
};
export type GetUserOrders500AllOfTwoErrorCode =
  (typeof GetUserOrders500AllOfTwoErrorCode)[keyof typeof GetUserOrders500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserOrders500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetUserOrders500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetUserOrders500AllOfTwoErrorCode;
};
export type GetUserOrders500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetUserOrders500AllOfTwoError;
};
export type GetUserOrders500 = ApiErrorResponseDto &
  GetUserOrders500AllOf &
  GetUserOrders500AllOfTwo;
export type UpdateOrderStatus200 = {
  data: GetOrderResponseDto;
};
export type UpdateOrderStatus401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateOrderStatus401AllOf = {
  error: UpdateOrderStatus401AllOfError;
};
export type UpdateOrderStatus401AllOfThreeErrorCode =
  (typeof UpdateOrderStatus401AllOfThreeErrorCode)[keyof typeof UpdateOrderStatus401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderStatus401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdateOrderStatus401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateOrderStatus401AllOfThreeErrorCode;
};
export type UpdateOrderStatus401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateOrderStatus401AllOfThreeError;
};
export type UpdateOrderStatus401 = ApiErrorResponseDto &
  UpdateOrderStatus401AllOf &
  UpdateOrderStatus401AllOfThree;
export type UpdateOrderStatus404AllOf = {
  error: EntityNotFoundError;
};
export type UpdateOrderStatus404AllOfTwoErrorCode =
  (typeof UpdateOrderStatus404AllOfTwoErrorCode)[keyof typeof UpdateOrderStatus404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderStatus404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdateOrderStatus404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdateOrderStatus404AllOfTwoErrorCode;
};
export type UpdateOrderStatus404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdateOrderStatus404AllOfTwoError;
};
export type UpdateOrderStatus404 = ApiErrorResponseDto &
  UpdateOrderStatus404AllOf &
  UpdateOrderStatus404AllOfTwo;
export type UpdateOrderStatus500AllOf = {
  error: ApiError;
};
export type UpdateOrderStatus500AllOfTwoErrorCode =
  (typeof UpdateOrderStatus500AllOfTwoErrorCode)[keyof typeof UpdateOrderStatus500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderStatus500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateOrderStatus500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateOrderStatus500AllOfTwoErrorCode;
};
export type UpdateOrderStatus500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateOrderStatus500AllOfTwoError;
};
export type UpdateOrderStatus500 = ApiErrorResponseDto &
  UpdateOrderStatus500AllOf &
  UpdateOrderStatus500AllOfTwo;
export type GetChallengesParams = {
  status?: GetChallengesStatus;
};
export type GetChallengesStatus =
  (typeof GetChallengesStatus)[keyof typeof GetChallengesStatus];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallengesStatus = {
  'in-progress': 'in-progress',
  completed: 'completed'
} as const;
export type GetChallenges200 = {
  data: GetChallengesDataDto;
};
export type GetChallenges401AllOfError = TokenExpiredError | JsonWebTokenError;
export type GetChallenges401AllOf = {
  error: GetChallenges401AllOfError;
};
export type GetChallenges401AllOfThreeErrorCode =
  (typeof GetChallenges401AllOfThreeErrorCode)[keyof typeof GetChallenges401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallenges401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type GetChallenges401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetChallenges401AllOfThreeErrorCode;
};
export type GetChallenges401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetChallenges401AllOfThreeError;
};
export type GetChallenges401 = ApiErrorResponseDto &
  GetChallenges401AllOf &
  GetChallenges401AllOfThree;
export type GetChallenges500AllOf = {
  error: ApiError;
};
export type GetChallenges500AllOfTwoErrorCode =
  (typeof GetChallenges500AllOfTwoErrorCode)[keyof typeof GetChallenges500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallenges500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetChallenges500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetChallenges500AllOfTwoErrorCode;
};
export type GetChallenges500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetChallenges500AllOfTwoError;
};
export type GetChallenges500 = ApiErrorResponseDto &
  GetChallenges500AllOf &
  GetChallenges500AllOfTwo;
export type GetNeighborhood200 = {
  data: GetNeighborhoodDataDto;
};
export type GetNeighborhood401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type GetNeighborhood401AllOf = {
  error: GetNeighborhood401AllOfError;
};
export type GetNeighborhood401AllOfThreeErrorCode =
  (typeof GetNeighborhood401AllOfThreeErrorCode)[keyof typeof GetNeighborhood401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNeighborhood401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type GetNeighborhood401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetNeighborhood401AllOfThreeErrorCode;
};
export type GetNeighborhood401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetNeighborhood401AllOfThreeError;
};
export type GetNeighborhood401 = ApiErrorResponseDto &
  GetNeighborhood401AllOf &
  GetNeighborhood401AllOfThree;
export type GetNeighborhood500AllOf = {
  error: ApiError;
};
export type GetNeighborhood500AllOfTwoErrorCode =
  (typeof GetNeighborhood500AllOfTwoErrorCode)[keyof typeof GetNeighborhood500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNeighborhood500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetNeighborhood500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetNeighborhood500AllOfTwoErrorCode;
};
export type GetNeighborhood500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetNeighborhood500AllOfTwoError;
};
export type GetNeighborhood500 = ApiErrorResponseDto &
  GetNeighborhood500AllOf &
  GetNeighborhood500AllOfTwo;
export type GetAdminChallengesParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetAdminChallengesSortBy;
  sortDirection?: GetAdminChallengesSortDirection;
};
export type GetAdminChallengesSortBy =
  (typeof GetAdminChallengesSortBy)[keyof typeof GetAdminChallengesSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminChallengesSortBy = {
  title: 'title',
  createdAt: 'createdAt'
} as const;
export type GetAdminChallengesSortDirection =
  (typeof GetAdminChallengesSortDirection)[keyof typeof GetAdminChallengesSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminChallengesSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetAdminChallenges200 = {
  data: GetAdminChallengesDataDto;
  meta?: GetAdminChallengesMetaDto;
};
export type GetAdminChallenges401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type GetAdminChallenges401AllOf = {
  error: GetAdminChallenges401AllOfError;
};
export type GetAdminChallenges401AllOfThreeErrorCode =
  (typeof GetAdminChallenges401AllOfThreeErrorCode)[keyof typeof GetAdminChallenges401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminChallenges401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetAdminChallenges401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetAdminChallenges401AllOfThreeErrorCode;
};
export type GetAdminChallenges401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetAdminChallenges401AllOfThreeError;
};
export type GetAdminChallenges401 = ApiErrorResponseDto &
  GetAdminChallenges401AllOf &
  GetAdminChallenges401AllOfThree;
export type GetAdminChallenges500AllOf = {
  error: ApiError;
};
export type GetAdminChallenges500AllOfTwoErrorCode =
  (typeof GetAdminChallenges500AllOfTwoErrorCode)[keyof typeof GetAdminChallenges500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminChallenges500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetAdminChallenges500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetAdminChallenges500AllOfTwoErrorCode;
};
export type GetAdminChallenges500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetAdminChallenges500AllOfTwoError;
};
export type GetAdminChallenges500 = ApiErrorResponseDto &
  GetAdminChallenges500AllOf &
  GetAdminChallenges500AllOfTwo;
export type UpdateAdminChallenge200 = {
  data: GetAdminChallengeResponseDto;
};
export type UpdateAdminChallenge401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdateAdminChallenge401AllOf = {
  error: UpdateAdminChallenge401AllOfError;
};
export type UpdateAdminChallenge401AllOfThreeErrorCode =
  (typeof UpdateAdminChallenge401AllOfThreeErrorCode)[keyof typeof UpdateAdminChallenge401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAdminChallenge401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdateAdminChallenge401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdateAdminChallenge401AllOfThreeErrorCode;
};
export type UpdateAdminChallenge401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdateAdminChallenge401AllOfThreeError;
};
export type UpdateAdminChallenge401 = ApiErrorResponseDto &
  UpdateAdminChallenge401AllOf &
  UpdateAdminChallenge401AllOfThree;
export type UpdateAdminChallenge404AllOf = {
  error: EntityNotFoundError;
};
export type UpdateAdminChallenge404AllOfTwoErrorCode =
  (typeof UpdateAdminChallenge404AllOfTwoErrorCode)[keyof typeof UpdateAdminChallenge404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAdminChallenge404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdateAdminChallenge404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdateAdminChallenge404AllOfTwoErrorCode;
};
export type UpdateAdminChallenge404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdateAdminChallenge404AllOfTwoError;
};
export type UpdateAdminChallenge404 = ApiErrorResponseDto &
  UpdateAdminChallenge404AllOf &
  UpdateAdminChallenge404AllOfTwo;
export type UpdateAdminChallenge500AllOf = {
  error: ApiError;
};
export type UpdateAdminChallenge500AllOfTwoErrorCode =
  (typeof UpdateAdminChallenge500AllOfTwoErrorCode)[keyof typeof UpdateAdminChallenge500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAdminChallenge500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdateAdminChallenge500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdateAdminChallenge500AllOfTwoErrorCode;
};
export type UpdateAdminChallenge500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdateAdminChallenge500AllOfTwoError;
};
export type UpdateAdminChallenge500 = ApiErrorResponseDto &
  UpdateAdminChallenge500AllOf &
  UpdateAdminChallenge500AllOfTwo;
export type GetChallengeById200 = {
  data: GetChallengeResponseDto;
};
export type GetChallengeById401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError;
export type GetChallengeById401AllOf = {
  error: GetChallengeById401AllOfError;
};
export type GetChallengeById401AllOfThreeErrorCode =
  (typeof GetChallengeById401AllOfThreeErrorCode)[keyof typeof GetChallengeById401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallengeById401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type GetChallengeById401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetChallengeById401AllOfThreeErrorCode;
};
export type GetChallengeById401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetChallengeById401AllOfThreeError;
};
export type GetChallengeById401 = ApiErrorResponseDto &
  GetChallengeById401AllOf &
  GetChallengeById401AllOfThree;
export type GetChallengeById404AllOf = {
  error: EntityNotFoundError;
};
export type GetChallengeById404AllOfTwoErrorCode =
  (typeof GetChallengeById404AllOfTwoErrorCode)[keyof typeof GetChallengeById404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallengeById404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetChallengeById404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetChallengeById404AllOfTwoErrorCode;
};
export type GetChallengeById404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetChallengeById404AllOfTwoError;
};
export type GetChallengeById404 = ApiErrorResponseDto &
  GetChallengeById404AllOf &
  GetChallengeById404AllOfTwo;
export type GetChallengeById500AllOf = {
  error: ApiError;
};
export type GetChallengeById500AllOfTwoErrorCode =
  (typeof GetChallengeById500AllOfTwoErrorCode)[keyof typeof GetChallengeById500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChallengeById500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetChallengeById500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetChallengeById500AllOfTwoErrorCode;
};
export type GetChallengeById500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetChallengeById500AllOfTwoError;
};
export type GetChallengeById500 = ApiErrorResponseDto &
  GetChallengeById500AllOf &
  GetChallengeById500AllOfTwo;
export type GetAllPointsConfigurations200 = {
  data: GetPointsConfigurationsDataDto;
};
export type GetAllPointsConfigurations401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type GetAllPointsConfigurations401AllOf = {
  error: GetAllPointsConfigurations401AllOfError;
};
export type GetAllPointsConfigurations401AllOfThreeErrorCode =
  (typeof GetAllPointsConfigurations401AllOfThreeErrorCode)[keyof typeof GetAllPointsConfigurations401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllPointsConfigurations401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetAllPointsConfigurations401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetAllPointsConfigurations401AllOfThreeErrorCode;
};
export type GetAllPointsConfigurations401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetAllPointsConfigurations401AllOfThreeError;
};
export type GetAllPointsConfigurations401 = ApiErrorResponseDto &
  GetAllPointsConfigurations401AllOf &
  GetAllPointsConfigurations401AllOfThree;
export type GetAllPointsConfigurations500AllOf = {
  error: ApiError;
};
export type GetAllPointsConfigurations500AllOfTwoErrorCode =
  (typeof GetAllPointsConfigurations500AllOfTwoErrorCode)[keyof typeof GetAllPointsConfigurations500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllPointsConfigurations500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetAllPointsConfigurations500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetAllPointsConfigurations500AllOfTwoErrorCode;
};
export type GetAllPointsConfigurations500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetAllPointsConfigurations500AllOfTwoError;
};
export type GetAllPointsConfigurations500 = ApiErrorResponseDto &
  GetAllPointsConfigurations500AllOf &
  GetAllPointsConfigurations500AllOfTwo;
export type GetPointsConfigurationByObjectType200 = {
  data: PointsConfigurationDto;
};
export type GetPointsConfigurationByObjectType401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError;
export type GetPointsConfigurationByObjectType401AllOf = {
  error: GetPointsConfigurationByObjectType401AllOfError;
};
export type GetPointsConfigurationByObjectType401AllOfThreeErrorCode =
  (typeof GetPointsConfigurationByObjectType401AllOfThreeErrorCode)[keyof typeof GetPointsConfigurationByObjectType401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPointsConfigurationByObjectType401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type GetPointsConfigurationByObjectType401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetPointsConfigurationByObjectType401AllOfThreeErrorCode;
};
export type GetPointsConfigurationByObjectType401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetPointsConfigurationByObjectType401AllOfThreeError;
};
export type GetPointsConfigurationByObjectType401 = ApiErrorResponseDto &
  GetPointsConfigurationByObjectType401AllOf &
  GetPointsConfigurationByObjectType401AllOfThree;
export type GetPointsConfigurationByObjectType404AllOf = {
  error: EntityNotFoundError;
};
export type GetPointsConfigurationByObjectType404AllOfTwoErrorCode =
  (typeof GetPointsConfigurationByObjectType404AllOfTwoErrorCode)[keyof typeof GetPointsConfigurationByObjectType404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPointsConfigurationByObjectType404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type GetPointsConfigurationByObjectType404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: GetPointsConfigurationByObjectType404AllOfTwoErrorCode;
};
export type GetPointsConfigurationByObjectType404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: GetPointsConfigurationByObjectType404AllOfTwoError;
};
export type GetPointsConfigurationByObjectType404 = ApiErrorResponseDto &
  GetPointsConfigurationByObjectType404AllOf &
  GetPointsConfigurationByObjectType404AllOfTwo;
export type GetPointsConfigurationByObjectType500AllOf = {
  error: ApiError;
};
export type GetPointsConfigurationByObjectType500AllOfTwoErrorCode =
  (typeof GetPointsConfigurationByObjectType500AllOfTwoErrorCode)[keyof typeof GetPointsConfigurationByObjectType500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPointsConfigurationByObjectType500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetPointsConfigurationByObjectType500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetPointsConfigurationByObjectType500AllOfTwoErrorCode;
};
export type GetPointsConfigurationByObjectType500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetPointsConfigurationByObjectType500AllOfTwoError;
};
export type GetPointsConfigurationByObjectType500 = ApiErrorResponseDto &
  GetPointsConfigurationByObjectType500AllOf &
  GetPointsConfigurationByObjectType500AllOfTwo;
export type UpdatePointsConfiguration200 = {
  data: PointsConfigurationDto;
};
export type UpdatePointsConfiguration401AllOfError =
  | JsonWebTokenError
  | TokenExpiredError
  | TokenExpiredError
  | JsonWebTokenError;
export type UpdatePointsConfiguration401AllOf = {
  error: UpdatePointsConfiguration401AllOfError;
};
export type UpdatePointsConfiguration401AllOfThreeErrorCode =
  (typeof UpdatePointsConfiguration401AllOfThreeErrorCode)[keyof typeof UpdatePointsConfiguration401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePointsConfiguration401AllOfThreeErrorCode = {
  JsonWebTokenError: 'JsonWebTokenError',
  TokenExpiredError: 'TokenExpiredError'
} as const;
export type UpdatePointsConfiguration401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: UpdatePointsConfiguration401AllOfThreeErrorCode;
};
export type UpdatePointsConfiguration401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: UpdatePointsConfiguration401AllOfThreeError;
};
export type UpdatePointsConfiguration401 = ApiErrorResponseDto &
  UpdatePointsConfiguration401AllOf &
  UpdatePointsConfiguration401AllOfThree;
export type UpdatePointsConfiguration404AllOf = {
  error: EntityNotFoundError;
};
export type UpdatePointsConfiguration404AllOfTwoErrorCode =
  (typeof UpdatePointsConfiguration404AllOfTwoErrorCode)[keyof typeof UpdatePointsConfiguration404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePointsConfiguration404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type UpdatePointsConfiguration404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: UpdatePointsConfiguration404AllOfTwoErrorCode;
};
export type UpdatePointsConfiguration404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: UpdatePointsConfiguration404AllOfTwoError;
};
export type UpdatePointsConfiguration404 = ApiErrorResponseDto &
  UpdatePointsConfiguration404AllOf &
  UpdatePointsConfiguration404AllOfTwo;
export type UpdatePointsConfiguration500AllOf = {
  error: ApiError;
};
export type UpdatePointsConfiguration500AllOfTwoErrorCode =
  (typeof UpdatePointsConfiguration500AllOfTwoErrorCode)[keyof typeof UpdatePointsConfiguration500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePointsConfiguration500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type UpdatePointsConfiguration500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: UpdatePointsConfiguration500AllOfTwoErrorCode;
};
export type UpdatePointsConfiguration500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: UpdatePointsConfiguration500AllOfTwoError;
};
export type UpdatePointsConfiguration500 = ApiErrorResponseDto &
  UpdatePointsConfiguration500AllOf &
  UpdatePointsConfiguration500AllOfTwo;
export type CreateBookmark200 = {
  data: CreateBookmarkResponseDto;
};
export type CreateBookmark401AllOfError = TokenExpiredError | JsonWebTokenError;
export type CreateBookmark401AllOf = {
  error: CreateBookmark401AllOfError;
};
export type CreateBookmark401AllOfThreeErrorCode =
  (typeof CreateBookmark401AllOfThreeErrorCode)[keyof typeof CreateBookmark401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBookmark401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type CreateBookmark401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: CreateBookmark401AllOfThreeErrorCode;
};
export type CreateBookmark401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: CreateBookmark401AllOfThreeError;
};
export type CreateBookmark401 = ApiErrorResponseDto &
  CreateBookmark401AllOf &
  CreateBookmark401AllOfThree;
export type CreateBookmark500AllOf = {
  error: ApiError;
};
export type CreateBookmark500AllOfTwoErrorCode =
  (typeof CreateBookmark500AllOfTwoErrorCode)[keyof typeof CreateBookmark500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBookmark500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type CreateBookmark500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: CreateBookmark500AllOfTwoErrorCode;
};
export type CreateBookmark500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: CreateBookmark500AllOfTwoError;
};
export type CreateBookmark500 = ApiErrorResponseDto &
  CreateBookmark500AllOf &
  CreateBookmark500AllOfTwo;
export type DeleteBookmark200 = {
  data: DeleteBookmarkResponseDto;
};
export type DeleteBookmark401AllOfError = TokenExpiredError | JsonWebTokenError;
export type DeleteBookmark401AllOf = {
  error: DeleteBookmark401AllOfError;
};
export type DeleteBookmark401AllOfThreeErrorCode =
  (typeof DeleteBookmark401AllOfThreeErrorCode)[keyof typeof DeleteBookmark401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBookmark401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type DeleteBookmark401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: DeleteBookmark401AllOfThreeErrorCode;
};
export type DeleteBookmark401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: DeleteBookmark401AllOfThreeError;
};
export type DeleteBookmark401 = ApiErrorResponseDto &
  DeleteBookmark401AllOf &
  DeleteBookmark401AllOfThree;
export type DeleteBookmark500AllOf = {
  error: ApiError;
};
export type DeleteBookmark500AllOfTwoErrorCode =
  (typeof DeleteBookmark500AllOfTwoErrorCode)[keyof typeof DeleteBookmark500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteBookmark500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type DeleteBookmark500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: DeleteBookmark500AllOfTwoErrorCode;
};
export type DeleteBookmark500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: DeleteBookmark500AllOfTwoError;
};
export type DeleteBookmark500 = ApiErrorResponseDto &
  DeleteBookmark500AllOf &
  DeleteBookmark500AllOfTwo;
export type GetBookmarksParams = {
  page?: number;
  perPage?: number;
  q?: string;
  sortBy?: GetBookmarksSortBy;
  sortDirection?: GetBookmarksSortDirection;
};
export type GetBookmarksSortBy =
  (typeof GetBookmarksSortBy)[keyof typeof GetBookmarksSortBy];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookmarksSortBy = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const;
export type GetBookmarksSortDirection =
  (typeof GetBookmarksSortDirection)[keyof typeof GetBookmarksSortDirection];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookmarksSortDirection = {
  asc: 'asc',
  desc: 'desc'
} as const;
export type GetBookmarks200 = {
  data: GetBookmarksResponseDto;
};
export type GetBookmarks401AllOfError = TokenExpiredError | JsonWebTokenError;
export type GetBookmarks401AllOf = {
  error: GetBookmarks401AllOfError;
};
export type GetBookmarks401AllOfThreeErrorCode =
  (typeof GetBookmarks401AllOfThreeErrorCode)[keyof typeof GetBookmarks401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookmarks401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type GetBookmarks401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: GetBookmarks401AllOfThreeErrorCode;
};
export type GetBookmarks401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: GetBookmarks401AllOfThreeError;
};
export type GetBookmarks401 = ApiErrorResponseDto &
  GetBookmarks401AllOf &
  GetBookmarks401AllOfThree;
export type GetBookmarks500AllOf = {
  error: ApiError;
};
export type GetBookmarks500AllOfTwoErrorCode =
  (typeof GetBookmarks500AllOfTwoErrorCode)[keyof typeof GetBookmarks500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookmarks500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type GetBookmarks500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: GetBookmarks500AllOfTwoErrorCode;
};
export type GetBookmarks500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: GetBookmarks500AllOfTwoError;
};
export type GetBookmarks500 = ApiErrorResponseDto &
  GetBookmarks500AllOf &
  GetBookmarks500AllOfTwo;
export type SendNomination200 = {
  data: SendNominationResponseDto;
};
export type SendNomination400AllOf = {
  error: NominationDailyLimitError;
};
export type SendNomination400AllOfTwoErrorCode =
  (typeof SendNomination400AllOfTwoErrorCode)[keyof typeof SendNomination400AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendNomination400AllOfTwoErrorCode = {
  NominationDailyLimitError: 'NominationDailyLimitError'
} as const;
export type SendNomination400AllOfTwoError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: SendNomination400AllOfTwoErrorCode;
};
export type SendNomination400AllOfTwo = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: SendNomination400AllOfTwoError;
};
export type SendNomination400 = ApiErrorResponseDto &
  SendNomination400AllOf &
  SendNomination400AllOfTwo;
export type SendNomination401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type SendNomination401AllOf = {
  error: SendNomination401AllOfError;
};
export type SendNomination401AllOfThreeErrorCode =
  (typeof SendNomination401AllOfThreeErrorCode)[keyof typeof SendNomination401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendNomination401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type SendNomination401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: SendNomination401AllOfThreeErrorCode;
};
export type SendNomination401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: SendNomination401AllOfThreeError;
};
export type SendNomination401 = ApiErrorResponseDto &
  SendNomination401AllOf &
  SendNomination401AllOfThree;
export type SendNomination500AllOf = {
  error: ApiError;
};
export type SendNomination500AllOfTwoErrorCode =
  (typeof SendNomination500AllOfTwoErrorCode)[keyof typeof SendNomination500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendNomination500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type SendNomination500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SendNomination500AllOfTwoErrorCode;
};
export type SendNomination500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SendNomination500AllOfTwoError;
};
export type SendNomination500 = ApiErrorResponseDto &
  SendNomination500AllOf &
  SendNomination500AllOfTwo;
export type SentNominationHash200 = {
  data: SentNominationHashResponseDto;
};
export type SentNominationHash401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type SentNominationHash401AllOf = {
  error: SentNominationHash401AllOfError;
};
export type SentNominationHash401AllOfThreeErrorCode =
  (typeof SentNominationHash401AllOfThreeErrorCode)[keyof typeof SentNominationHash401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SentNominationHash401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type SentNominationHash401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: SentNominationHash401AllOfThreeErrorCode;
};
export type SentNominationHash401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: SentNominationHash401AllOfThreeError;
};
export type SentNominationHash401 = ApiErrorResponseDto &
  SentNominationHash401AllOf &
  SentNominationHash401AllOfThree;
export type SentNominationHash404AllOf = {
  error: EntityNotFoundError;
};
export type SentNominationHash404AllOfTwoErrorCode =
  (typeof SentNominationHash404AllOfTwoErrorCode)[keyof typeof SentNominationHash404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SentNominationHash404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type SentNominationHash404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: SentNominationHash404AllOfTwoErrorCode;
};
export type SentNominationHash404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: SentNominationHash404AllOfTwoError;
};
export type SentNominationHash404 = ApiErrorResponseDto &
  SentNominationHash404AllOf &
  SentNominationHash404AllOfTwo;
export type SentNominationHash500AllOf = {
  error: ApiError;
};
export type SentNominationHash500AllOfTwoErrorCode =
  (typeof SentNominationHash500AllOfTwoErrorCode)[keyof typeof SentNominationHash500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SentNominationHash500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type SentNominationHash500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: SentNominationHash500AllOfTwoErrorCode;
};
export type SentNominationHash500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: SentNominationHash500AllOfTwoError;
};
export type SentNominationHash500 = ApiErrorResponseDto &
  SentNominationHash500AllOf &
  SentNominationHash500AllOfTwo;
export type ClaimNomination200 = {
  data: ClaimNominationResponseDto;
};
export type ClaimNomination400AllOfError =
  | NominationAlreadyClaimedError
  | SelfNominationError;
export type ClaimNomination400AllOf = {
  error: ClaimNomination400AllOfError;
};
export type ClaimNomination400AllOfThreeErrorCode =
  (typeof ClaimNomination400AllOfThreeErrorCode)[keyof typeof ClaimNomination400AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimNomination400AllOfThreeErrorCode = {
  NominationAlreadyClaimedError: 'NominationAlreadyClaimedError',
  SelfNominationError: 'SelfNominationError'
} as const;
export type ClaimNomination400AllOfThreeError = {
  /**
   * @minimum 400
   * @maximum 400
   */
  status: number;
  code: ClaimNomination400AllOfThreeErrorCode;
};
export type ClaimNomination400AllOfThree = {
  /**
   * @minimum 400
   * @maximum 400
   */
  statusCode: number;
  error: ClaimNomination400AllOfThreeError;
};
export type ClaimNomination400 = ApiErrorResponseDto &
  ClaimNomination400AllOf &
  ClaimNomination400AllOfThree;
export type ClaimNomination401AllOfError =
  | TokenExpiredError
  | JsonWebTokenError
  | TokenExpiredError
  | JsonWebTokenError;
export type ClaimNomination401AllOf = {
  error: ClaimNomination401AllOfError;
};
export type ClaimNomination401AllOfThreeErrorCode =
  (typeof ClaimNomination401AllOfThreeErrorCode)[keyof typeof ClaimNomination401AllOfThreeErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimNomination401AllOfThreeErrorCode = {
  TokenExpiredError: 'TokenExpiredError',
  JsonWebTokenError: 'JsonWebTokenError'
} as const;
export type ClaimNomination401AllOfThreeError = {
  /**
   * @minimum 401
   * @maximum 401
   */
  status: number;
  code: ClaimNomination401AllOfThreeErrorCode;
};
export type ClaimNomination401AllOfThree = {
  /**
   * @minimum 401
   * @maximum 401
   */
  statusCode: number;
  error: ClaimNomination401AllOfThreeError;
};
export type ClaimNomination401 = ApiErrorResponseDto &
  ClaimNomination401AllOf &
  ClaimNomination401AllOfThree;
export type ClaimNomination404AllOf = {
  error: EntityNotFoundError;
};
export type ClaimNomination404AllOfTwoErrorCode =
  (typeof ClaimNomination404AllOfTwoErrorCode)[keyof typeof ClaimNomination404AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimNomination404AllOfTwoErrorCode = {
  EntityNotFoundError: 'EntityNotFoundError'
} as const;
export type ClaimNomination404AllOfTwoError = {
  /**
   * @minimum 404
   * @maximum 404
   */
  status: number;
  code: ClaimNomination404AllOfTwoErrorCode;
};
export type ClaimNomination404AllOfTwo = {
  /**
   * @minimum 404
   * @maximum 404
   */
  statusCode: number;
  error: ClaimNomination404AllOfTwoError;
};
export type ClaimNomination404 = ApiErrorResponseDto &
  ClaimNomination404AllOf &
  ClaimNomination404AllOfTwo;
export type ClaimNomination500AllOf = {
  error: ApiError;
};
export type ClaimNomination500AllOfTwoErrorCode =
  (typeof ClaimNomination500AllOfTwoErrorCode)[keyof typeof ClaimNomination500AllOfTwoErrorCode];
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClaimNomination500AllOfTwoErrorCode = {
  UnexpectedError: 'UnexpectedError'
} as const;
export type ClaimNomination500AllOfTwoError = {
  /**
   * @minimum 500
   * @maximum 500
   */
  status: number;
  code: ClaimNomination500AllOfTwoErrorCode;
};
export type ClaimNomination500AllOfTwo = {
  /**
   * @minimum 500
   * @maximum 500
   */
  statusCode: number;
  error: ClaimNomination500AllOfTwoError;
};
export type ClaimNomination500 = ApiErrorResponseDto &
  ClaimNomination500AllOf &
  ClaimNomination500AllOfTwo;
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getData = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetData200>(
    { url: `/hi`, method: 'GET', signal },
    options
  );
};
export const getGetDataQueryKey = () => {
  return [`/hi`] as const;
};
export const getGetDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getData>>,
  TError = ErrorType<GetData500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getData>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetDataQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getData>>> = ({
    signal
  }) => getData(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getData>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getData>>
>;
export type GetDataQueryError = ErrorType<GetData500>;
export function useGetData<
  TData = Awaited<ReturnType<typeof getData>>,
  TError = ErrorType<GetData500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getData>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetDataQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const getApi = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetApi200>(
    { url: `/api`, method: 'GET', signal },
    options
  );
};
export const getGetApiQueryKey = () => {
  return [`/api`] as const;
};
export const getGetApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi>>,
  TError = ErrorType<GetApi500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getApi>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetApiQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApi>>> = ({
    signal
  }) => getApi(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetApiQueryResult = NonNullable<Awaited<ReturnType<typeof getApi>>>;
export type GetApiQueryError = ErrorType<GetApi500>;
export function useGetApi<
  TData = Awaited<ReturnType<typeof getApi>>,
  TError = ErrorType<GetApi500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getApi>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetApiQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const getHealthCheck = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/health-check`, method: 'GET', signal },
    options
  );
};
export const getGetHealthCheckQueryKey = () => {
  return [`/health-check`] as const;
};
export const getGetHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthCheck>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHealthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetHealthCheckQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealthCheck>>> = ({
    signal
  }) => getHealthCheck(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthCheck>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetHealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthCheck>>
>;
export type GetHealthCheckQueryError = ErrorType<unknown>;
export function useGetHealthCheck<
  TData = Awaited<ReturnType<typeof getHealthCheck>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHealthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetHealthCheckQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const headHealthCheck = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/health-check`, method: 'HEAD', signal },
    options
  );
};
export const getHeadHealthCheckMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof headHealthCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof headHealthCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['headHealthCheck'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof headHealthCheck>>,
    void
  > = () => {
    return headHealthCheck(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type HeadHealthCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof headHealthCheck>>
>;
export type HeadHealthCheckMutationError = ErrorType<unknown>;
export const useHeadHealthCheck = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof headHealthCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof headHealthCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getHeadHealthCheckMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Create a pre-signed URL for file upload with specified namespace
 */
export const createPreSignedUrl = (
  createPreSignedUrlDto: CreatePreSignedUrlDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreatePreSignedUrl200>(
    {
      url: `/uploads/create-presigned-url`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPreSignedUrlDto,
      signal
    },
    options
  );
};
export const getCreatePreSignedUrlMutationOptions = <
  TError = ErrorType<CreatePreSignedUrl401 | CreatePreSignedUrl500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPreSignedUrl>>,
    TError,
    {
      data: CreatePreSignedUrlDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPreSignedUrl>>,
  TError,
  {
    data: CreatePreSignedUrlDto;
  },
  TContext
> => {
  const mutationKey = ['createPreSignedUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPreSignedUrl>>,
    {
      data: CreatePreSignedUrlDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createPreSignedUrl(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreatePreSignedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPreSignedUrl>>
>;
export type CreatePreSignedUrlMutationBody = CreatePreSignedUrlDto;
export type CreatePreSignedUrlMutationError = ErrorType<
  CreatePreSignedUrl401 | CreatePreSignedUrl500
>;
export const useCreatePreSignedUrl = <
  TError = ErrorType<CreatePreSignedUrl401 | CreatePreSignedUrl500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPreSignedUrl>>,
    TError,
    {
      data: CreatePreSignedUrlDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPreSignedUrl>>,
  TError,
  {
    data: CreatePreSignedUrlDto;
  },
  TContext
> => {
  const mutationOptions = getCreatePreSignedUrlMutationOptions(options);
  return useMutation(mutationOptions);
};
export const refreshToken = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RefreshToken200>(
    { url: `/auth/refresh`, method: 'POST', signal },
    options
  );
};
export const getRefreshTokenMutationOptions = <
  TError = ErrorType<RefreshToken401 | RefreshToken500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['refreshToken'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    void
  > = () => {
    return refreshToken(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type RefreshTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshToken>>
>;
export type RefreshTokenMutationError = ErrorType<
  RefreshToken401 | RefreshToken500
>;
export const useRefreshToken = <
  TError = ErrorType<RefreshToken401 | RefreshToken500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRefreshTokenMutationOptions(options);
  return useMutation(mutationOptions);
};
export const signUp = (
  authSignupDto: AuthSignupDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SignUp200>(
    {
      url: `/auth/signup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authSignupDto,
      signal
    },
    options
  );
};
export const getSignUpMutationOptions = <
  TError = ErrorType<SignUp400 | SignUp410 | SignUp500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    {
      data: AuthSignupDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  {
    data: AuthSignupDto;
  },
  TContext
> => {
  const mutationKey = ['signUp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUp>>,
    {
      data: AuthSignupDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return signUp(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SignUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof signUp>>
>;
export type SignUpMutationBody = AuthSignupDto;
export type SignUpMutationError = ErrorType<SignUp400 | SignUp410 | SignUp500>;
export const useSignUp = <
  TError = ErrorType<SignUp400 | SignUp410 | SignUp500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    {
      data: AuthSignupDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  {
    data: AuthSignupDto;
  },
  TContext
> => {
  const mutationOptions = getSignUpMutationOptions(options);
  return useMutation(mutationOptions);
};
export const confirmSignUp = (
  authSignupConfirmationDto: AuthSignupConfirmationDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConfirmSignUp200>(
    {
      url: `/auth/confirm-signup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: authSignupConfirmationDto,
      signal
    },
    options
  );
};
export const getConfirmSignUpMutationOptions = <
  TError = ErrorType<ConfirmSignUp400 | ConfirmSignUp410 | ConfirmSignUp500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSignUp>>,
    TError,
    {
      data: AuthSignupConfirmationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSignUp>>,
  TError,
  {
    data: AuthSignupConfirmationDto;
  },
  TContext
> => {
  const mutationKey = ['confirmSignUp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSignUp>>,
    {
      data: AuthSignupConfirmationDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return confirmSignUp(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ConfirmSignUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmSignUp>>
>;
export type ConfirmSignUpMutationBody = AuthSignupConfirmationDto;
export type ConfirmSignUpMutationError = ErrorType<
  ConfirmSignUp400 | ConfirmSignUp410 | ConfirmSignUp500
>;
export const useConfirmSignUp = <
  TError = ErrorType<ConfirmSignUp400 | ConfirmSignUp410 | ConfirmSignUp500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSignUp>>,
    TError,
    {
      data: AuthSignupConfirmationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmSignUp>>,
  TError,
  {
    data: AuthSignupConfirmationDto;
  },
  TContext
> => {
  const mutationOptions = getConfirmSignUpMutationOptions(options);
  return useMutation(mutationOptions);
};
export const sendOTP = (
  oTPSendRequestDto: OTPSendRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SendOTP200>(
    {
      url: `/auth/send-otp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: oTPSendRequestDto,
      signal
    },
    options
  );
};
export const getSendOTPMutationOptions = <
  TError = ErrorType<SendOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOTP>>,
    TError,
    {
      data: OTPSendRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOTP>>,
  TError,
  {
    data: OTPSendRequestDto;
  },
  TContext
> => {
  const mutationKey = ['sendOTP'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOTP>>,
    {
      data: OTPSendRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return sendOTP(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SendOTPMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendOTP>>
>;
export type SendOTPMutationBody = OTPSendRequestDto;
export type SendOTPMutationError = ErrorType<SendOTP500>;
export const useSendOTP = <
  TError = ErrorType<SendOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOTP>>,
    TError,
    {
      data: OTPSendRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendOTP>>,
  TError,
  {
    data: OTPSendRequestDto;
  },
  TContext
> => {
  const mutationOptions = getSendOTPMutationOptions(options);
  return useMutation(mutationOptions);
};
export const adminOTP = (
  oTPSendRequestDto: OTPSendRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AdminOTP200>(
    {
      url: `/auth/admin-otp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: oTPSendRequestDto,
      signal
    },
    options
  );
};
export const getAdminOTPMutationOptions = <
  TError = ErrorType<AdminOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminOTP>>,
    TError,
    {
      data: OTPSendRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminOTP>>,
  TError,
  {
    data: OTPSendRequestDto;
  },
  TContext
> => {
  const mutationKey = ['adminOTP'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminOTP>>,
    {
      data: OTPSendRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return adminOTP(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AdminOTPMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminOTP>>
>;
export type AdminOTPMutationBody = OTPSendRequestDto;
export type AdminOTPMutationError = ErrorType<AdminOTP500>;
export const useAdminOTP = <
  TError = ErrorType<AdminOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminOTP>>,
    TError,
    {
      data: OTPSendRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminOTP>>,
  TError,
  {
    data: OTPSendRequestDto;
  },
  TContext
> => {
  const mutationOptions = getAdminOTPMutationOptions(options);
  return useMutation(mutationOptions);
};
export const verifyOTP = (
  oTPVerifyRequestDto: OTPVerifyRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<VerifyOTP200>(
    {
      url: `/auth/verify-otp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: oTPVerifyRequestDto,
      signal
    },
    options
  );
};
export const getVerifyOTPMutationOptions = <
  TError = ErrorType<VerifyOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyOTP>>,
    TError,
    {
      data: OTPVerifyRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyOTP>>,
  TError,
  {
    data: OTPVerifyRequestDto;
  },
  TContext
> => {
  const mutationKey = ['verifyOTP'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyOTP>>,
    {
      data: OTPVerifyRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return verifyOTP(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type VerifyOTPMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyOTP>>
>;
export type VerifyOTPMutationBody = OTPVerifyRequestDto;
export type VerifyOTPMutationError = ErrorType<VerifyOTP500>;
export const useVerifyOTP = <
  TError = ErrorType<VerifyOTP500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyOTP>>,
    TError,
    {
      data: OTPVerifyRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyOTP>>,
  TError,
  {
    data: OTPVerifyRequestDto;
  },
  TContext
> => {
  const mutationOptions = getVerifyOTPMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Allows a SUPERADMIN to grant the ADMIN role to another user.
 */
export const grantAdmin = (
  grantAdminRoleDto: GrantAdminRoleDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GrantAdmin200>(
    {
      url: `/auth/grant-admin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: grantAdminRoleDto,
      signal
    },
    options
  );
};
export const getGrantAdminMutationOptions = <
  TError = ErrorType<GrantAdmin401 | GrantAdmin500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAdmin>>,
    TError,
    {
      data: GrantAdminRoleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantAdmin>>,
  TError,
  {
    data: GrantAdminRoleDto;
  },
  TContext
> => {
  const mutationKey = ['grantAdmin'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantAdmin>>,
    {
      data: GrantAdminRoleDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return grantAdmin(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type GrantAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantAdmin>>
>;
export type GrantAdminMutationBody = GrantAdminRoleDto;
export type GrantAdminMutationError = ErrorType<GrantAdmin401 | GrantAdmin500>;
export const useGrantAdmin = <
  TError = ErrorType<GrantAdmin401 | GrantAdmin500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantAdmin>>,
    TError,
    {
      data: GrantAdminRoleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantAdmin>>,
  TError,
  {
    data: GrantAdminRoleDto;
  },
  TContext
> => {
  const mutationOptions = getGrantAdminMutationOptions(options);
  return useMutation(mutationOptions);
};
export const forAnyone = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ForAnyone200>(
    { url: `/rbac/for-anyone`, method: 'GET', signal },
    options
  );
};
export const getForAnyoneQueryKey = () => {
  return [`/rbac/for-anyone`] as const;
};
export const getForAnyoneQueryOptions = <
  TData = Awaited<ReturnType<typeof forAnyone>>,
  TError = ErrorType<ForAnyone401 | ForAnyone500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forAnyone>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getForAnyoneQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof forAnyone>>> = ({
    signal
  }) => forAnyone(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof forAnyone>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type ForAnyoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof forAnyone>>
>;
export type ForAnyoneQueryError = ErrorType<ForAnyone401 | ForAnyone500>;
export function useForAnyone<
  TData = Awaited<ReturnType<typeof forAnyone>>,
  TError = ErrorType<ForAnyone401 | ForAnyone500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forAnyone>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getForAnyoneQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const forUser = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ForUser200>(
    { url: `/rbac/for-user-only`, method: 'GET', signal },
    options
  );
};
export const getForUserQueryKey = () => {
  return [`/rbac/for-user-only`] as const;
};
export const getForUserQueryOptions = <
  TData = Awaited<ReturnType<typeof forUser>>,
  TError = ErrorType<ForUser401 | ForUser500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forUser>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getForUserQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof forUser>>> = ({
    signal
  }) => forUser(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof forUser>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type ForUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof forUser>>
>;
export type ForUserQueryError = ErrorType<ForUser401 | ForUser500>;
export function useForUser<
  TData = Awaited<ReturnType<typeof forUser>>,
  TError = ErrorType<ForUser401 | ForUser500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forUser>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getForUserQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const forAdmin = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ForAdmin200>(
    { url: `/rbac/for-admin`, method: 'GET', signal },
    options
  );
};
export const getForAdminQueryKey = () => {
  return [`/rbac/for-admin`] as const;
};
export const getForAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof forAdmin>>,
  TError = ErrorType<ForAdmin401 | ForAdmin500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forAdmin>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getForAdminQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof forAdmin>>> = ({
    signal
  }) => forAdmin(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof forAdmin>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type ForAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof forAdmin>>
>;
export type ForAdminQueryError = ErrorType<ForAdmin401 | ForAdmin500>;
export function useForAdmin<
  TData = Awaited<ReturnType<typeof forAdmin>>,
  TError = ErrorType<ForAdmin401 | ForAdmin500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof forAdmin>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getForAdminQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const forSuperAdmin = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ForSuperAdmin200>(
    { url: `/rbac/for-superadmin`, method: 'GET', signal },
    options
  );
};
export const getForSuperAdminQueryKey = () => {
  return [`/rbac/for-superadmin`] as const;
};
export const getForSuperAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof forSuperAdmin>>,
  TError = ErrorType<ForSuperAdmin401 | ForSuperAdmin500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof forSuperAdmin>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getForSuperAdminQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof forSuperAdmin>>> = ({
    signal
  }) => forSuperAdmin(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof forSuperAdmin>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type ForSuperAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof forSuperAdmin>>
>;
export type ForSuperAdminQueryError = ErrorType<
  ForSuperAdmin401 | ForSuperAdmin500
>;
export function useForSuperAdmin<
  TData = Awaited<ReturnType<typeof forSuperAdmin>>,
  TError = ErrorType<ForSuperAdmin401 | ForSuperAdmin500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof forSuperAdmin>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getForSuperAdminQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Resets points
 */
export const resetPoints = (
  pointsResetRequestDto: PointsResetRequestDto,
  params?: ResetPointsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ResetPoints200>(
    {
      url: `/points/reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsResetRequestDto,
      params,
      signal
    },
    options
  );
};
export const getResetPointsMutationOptions = <
  TError = ErrorType<ResetPoints401 | ResetPoints404 | ResetPoints500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPoints>>,
    TError,
    {
      data: PointsResetRequestDto;
      params?: ResetPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPoints>>,
  TError,
  {
    data: PointsResetRequestDto;
    params?: ResetPointsParams;
  },
  TContext
> => {
  const mutationKey = ['resetPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPoints>>,
    {
      data: PointsResetRequestDto;
      params?: ResetPointsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return resetPoints(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ResetPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPoints>>
>;
export type ResetPointsMutationBody = PointsResetRequestDto;
export type ResetPointsMutationError = ErrorType<
  ResetPoints401 | ResetPoints404 | ResetPoints500
>;
export const useResetPoints = <
  TError = ErrorType<ResetPoints401 | ResetPoints404 | ResetPoints500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPoints>>,
    TError,
    {
      data: PointsResetRequestDto;
      params?: ResetPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPoints>>,
  TError,
  {
    data: PointsResetRequestDto;
    params?: ResetPointsParams;
  },
  TContext
> => {
  const mutationOptions = getResetPointsMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Alter points for a given user (Admin only)
 */
export const alterPoints = (
  alterPointsRequestDto: AlterPointsRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AlterPoints200>(
    {
      url: `/points/alter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alterPointsRequestDto,
      signal
    },
    options
  );
};
export const getAlterPointsMutationOptions = <
  TError = ErrorType<AlterPoints401 | AlterPoints404 | AlterPoints500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof alterPoints>>,
    TError,
    {
      data: AlterPointsRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof alterPoints>>,
  TError,
  {
    data: AlterPointsRequestDto;
  },
  TContext
> => {
  const mutationKey = ['alterPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof alterPoints>>,
    {
      data: AlterPointsRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return alterPoints(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AlterPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof alterPoints>>
>;
export type AlterPointsMutationBody = AlterPointsRequestDto;
export type AlterPointsMutationError = ErrorType<
  AlterPoints401 | AlterPoints404 | AlterPoints500
>;
export const useAlterPoints = <
  TError = ErrorType<AlterPoints401 | AlterPoints404 | AlterPoints500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof alterPoints>>,
    TError,
    {
      data: AlterPointsRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof alterPoints>>,
  TError,
  {
    data: AlterPointsRequestDto;
  },
  TContext
> => {
  const mutationOptions = getAlterPointsMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for donation
 */
export const awardNeedPoints = (
  pointsAwardNeedRequestDto: PointsAwardNeedRequestDto,
  params?: AwardNeedPointsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardNeedPoints200>(
    {
      url: `/points/award/need`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardNeedRequestDto,
      params,
      signal
    },
    options
  );
};
export const getAwardNeedPointsMutationOptions = <
  TError = ErrorType<
    AwardNeedPoints401 | AwardNeedPoints404 | AwardNeedPoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardNeedPoints>>,
    TError,
    {
      data: PointsAwardNeedRequestDto;
      params?: AwardNeedPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardNeedPoints>>,
  TError,
  {
    data: PointsAwardNeedRequestDto;
    params?: AwardNeedPointsParams;
  },
  TContext
> => {
  const mutationKey = ['awardNeedPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardNeedPoints>>,
    {
      data: PointsAwardNeedRequestDto;
      params?: AwardNeedPointsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardNeedPoints(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardNeedPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardNeedPoints>>
>;
export type AwardNeedPointsMutationBody = PointsAwardNeedRequestDto;
export type AwardNeedPointsMutationError = ErrorType<
  AwardNeedPoints401 | AwardNeedPoints404 | AwardNeedPoints500
>;
export const useAwardNeedPoints = <
  TError = ErrorType<
    AwardNeedPoints401 | AwardNeedPoints404 | AwardNeedPoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardNeedPoints>>,
    TError,
    {
      data: PointsAwardNeedRequestDto;
      params?: AwardNeedPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardNeedPoints>>,
  TError,
  {
    data: PointsAwardNeedRequestDto;
    params?: AwardNeedPointsParams;
  },
  TContext
> => {
  const mutationOptions = getAwardNeedPointsMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for good vibe
 */
export const awardGoodVibePoints = (
  pointsAwardRequestDto: PointsAwardRequestDto,
  params?: AwardGoodVibePointsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardGoodVibePoints200>(
    {
      url: `/points/award/good-vibe`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardRequestDto,
      params,
      signal
    },
    options
  );
};
export const getAwardGoodVibePointsMutationOptions = <
  TError = ErrorType<
    AwardGoodVibePoints401 | AwardGoodVibePoints404 | AwardGoodVibePoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardGoodVibePoints>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardGoodVibePointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardGoodVibePoints>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardGoodVibePointsParams;
  },
  TContext
> => {
  const mutationKey = ['awardGoodVibePoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardGoodVibePoints>>,
    {
      data: PointsAwardRequestDto;
      params?: AwardGoodVibePointsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardGoodVibePoints(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardGoodVibePointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardGoodVibePoints>>
>;
export type AwardGoodVibePointsMutationBody = PointsAwardRequestDto;
export type AwardGoodVibePointsMutationError = ErrorType<
  AwardGoodVibePoints401 | AwardGoodVibePoints404 | AwardGoodVibePoints500
>;
export const useAwardGoodVibePoints = <
  TError = ErrorType<
    AwardGoodVibePoints401 | AwardGoodVibePoints404 | AwardGoodVibePoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardGoodVibePoints>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardGoodVibePointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardGoodVibePoints>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardGoodVibePointsParams;
  },
  TContext
> => {
  const mutationOptions = getAwardGoodVibePointsMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for nomination
 */
export const awardNominationSent = (
  pointsAwardRequestDto: PointsAwardRequestDto,
  params?: AwardNominationSentParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardNominationSent200>(
    {
      url: `/points/award/nomination`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardRequestDto,
      params,
      signal
    },
    options
  );
};
export const getAwardNominationSentMutationOptions = <
  TError = ErrorType<
    AwardNominationSent401 | AwardNominationSent404 | AwardNominationSent500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardNominationSent>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardNominationSentParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardNominationSent>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardNominationSentParams;
  },
  TContext
> => {
  const mutationKey = ['awardNominationSent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardNominationSent>>,
    {
      data: PointsAwardRequestDto;
      params?: AwardNominationSentParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardNominationSent(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardNominationSentMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardNominationSent>>
>;
export type AwardNominationSentMutationBody = PointsAwardRequestDto;
export type AwardNominationSentMutationError = ErrorType<
  AwardNominationSent401 | AwardNominationSent404 | AwardNominationSent500
>;
export const useAwardNominationSent = <
  TError = ErrorType<
    AwardNominationSent401 | AwardNominationSent404 | AwardNominationSent500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardNominationSent>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardNominationSentParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardNominationSent>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardNominationSentParams;
  },
  TContext
> => {
  const mutationOptions = getAwardNominationSentMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for event registration
 */
export const awardEventRegistration = (
  pointsAwardRequestDto: PointsAwardRequestDto,
  params?: AwardEventRegistrationParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardEventRegistration200>(
    {
      url: `/points/award/event/register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardRequestDto,
      params,
      signal
    },
    options
  );
};
export const getAwardEventRegistrationMutationOptions = <
  TError = ErrorType<
    | AwardEventRegistration401
    | AwardEventRegistration404
    | AwardEventRegistration500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardEventRegistration>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventRegistrationParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardEventRegistration>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardEventRegistrationParams;
  },
  TContext
> => {
  const mutationKey = ['awardEventRegistration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardEventRegistration>>,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventRegistrationParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardEventRegistration(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardEventRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardEventRegistration>>
>;
export type AwardEventRegistrationMutationBody = PointsAwardRequestDto;
export type AwardEventRegistrationMutationError = ErrorType<
  | AwardEventRegistration401
  | AwardEventRegistration404
  | AwardEventRegistration500
>;
export const useAwardEventRegistration = <
  TError = ErrorType<
    | AwardEventRegistration401
    | AwardEventRegistration404
    | AwardEventRegistration500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardEventRegistration>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventRegistrationParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardEventRegistration>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardEventRegistrationParams;
  },
  TContext
> => {
  const mutationOptions = getAwardEventRegistrationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for event attendance
 */
export const awardEventAttendance = (
  pointsAwardRequestDto: PointsAwardRequestDto,
  params?: AwardEventAttendanceParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardEventAttendance200>(
    {
      url: `/points/award/event/attend`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardRequestDto,
      params,
      signal
    },
    options
  );
};
export const getAwardEventAttendanceMutationOptions = <
  TError = ErrorType<
    AwardEventAttendance401 | AwardEventAttendance404 | AwardEventAttendance500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardEventAttendance>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventAttendanceParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardEventAttendance>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardEventAttendanceParams;
  },
  TContext
> => {
  const mutationKey = ['awardEventAttendance'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardEventAttendance>>,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventAttendanceParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardEventAttendance(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardEventAttendanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardEventAttendance>>
>;
export type AwardEventAttendanceMutationBody = PointsAwardRequestDto;
export type AwardEventAttendanceMutationError = ErrorType<
  AwardEventAttendance401 | AwardEventAttendance404 | AwardEventAttendance500
>;
export const useAwardEventAttendance = <
  TError = ErrorType<
    AwardEventAttendance401 | AwardEventAttendance404 | AwardEventAttendance500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardEventAttendance>>,
    TError,
    {
      data: PointsAwardRequestDto;
      params?: AwardEventAttendanceParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardEventAttendance>>,
  TError,
  {
    data: PointsAwardRequestDto;
    params?: AwardEventAttendanceParams;
  },
  TContext
> => {
  const mutationOptions = getAwardEventAttendanceMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Award points for streak completion by creating historical activities
 */
export const awardStreakPoints = (
  pointsAwardStreakDto: PointsAwardStreakDto,
  params?: AwardStreakPointsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AwardStreakPoints200>(
    {
      url: `/points/award/streak`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: pointsAwardStreakDto,
      params,
      signal
    },
    options
  );
};
export const getAwardStreakPointsMutationOptions = <
  TError = ErrorType<
    AwardStreakPoints401 | AwardStreakPoints404 | AwardStreakPoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardStreakPoints>>,
    TError,
    {
      data: PointsAwardStreakDto;
      params?: AwardStreakPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof awardStreakPoints>>,
  TError,
  {
    data: PointsAwardStreakDto;
    params?: AwardStreakPointsParams;
  },
  TContext
> => {
  const mutationKey = ['awardStreakPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardStreakPoints>>,
    {
      data: PointsAwardStreakDto;
      params?: AwardStreakPointsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};
    return awardStreakPoints(data, params, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AwardStreakPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardStreakPoints>>
>;
export type AwardStreakPointsMutationBody = PointsAwardStreakDto;
export type AwardStreakPointsMutationError = ErrorType<
  AwardStreakPoints401 | AwardStreakPoints404 | AwardStreakPoints500
>;
export const useAwardStreakPoints = <
  TError = ErrorType<
    AwardStreakPoints401 | AwardStreakPoints404 | AwardStreakPoints500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof awardStreakPoints>>,
    TError,
    {
      data: PointsAwardStreakDto;
      params?: AwardStreakPointsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof awardStreakPoints>>,
  TError,
  {
    data: PointsAwardStreakDto;
    params?: AwardStreakPointsParams;
  },
  TContext
> => {
  const mutationOptions = getAwardStreakPointsMutationOptions(options);
  return useMutation(mutationOptions);
};
export const me = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Me200>({ url: `/me`, method: 'GET', signal }, options);
};
export const getMeQueryKey = () => {
  return [`/me`] as const;
};
export const getMeQueryOptions = <
  TData = Awaited<ReturnType<typeof me>>,
  TError = ErrorType<Me401 | Me500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMeQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) =>
    me(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof me>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>;
export type MeQueryError = ErrorType<Me401 | Me500>;
export function useMe<
  TData = Awaited<ReturnType<typeof me>>,
  TError = ErrorType<Me401 | Me500>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getMeQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update user profile information
 */
export const updateMe = (
  updateMeDto: UpdateMeDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateMe200>(
    {
      url: `/me`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeDto
    },
    options
  );
};
export const getUpdateMeMutationOptions = <
  TError = ErrorType<UpdateMe401 | UpdateMe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    {
      data: UpdateMeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  {
    data: UpdateMeDto;
  },
  TContext
> => {
  const mutationKey = ['updateMe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMe>>,
    {
      data: UpdateMeDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return updateMe(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMe>>
>;
export type UpdateMeMutationBody = UpdateMeDto;
export type UpdateMeMutationError = ErrorType<UpdateMe401 | UpdateMe500>;
export const useUpdateMe = <
  TError = ErrorType<UpdateMe401 | UpdateMe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    {
      data: UpdateMeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  {
    data: UpdateMeDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateMeMutationOptions(options);
  return useMutation(mutationOptions);
};
export const share = (
  shareContentRequestDto: ShareContentRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Share200>(
    {
      url: `/share`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shareContentRequestDto,
      signal
    },
    options
  );
};
export const getShareMutationOptions = <
  TError = ErrorType<Share401 | Share500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof share>>,
    TError,
    {
      data: ShareContentRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof share>>,
  TError,
  {
    data: ShareContentRequestDto;
  },
  TContext
> => {
  const mutationKey = ['share'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof share>>,
    {
      data: ShareContentRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return share(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof share>>
>;
export type ShareMutationBody = ShareContentRequestDto;
export type ShareMutationError = ErrorType<Share401 | Share500>;
export const useShare = <
  TError = ErrorType<Share401 | Share500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof share>>,
    TError,
    {
      data: ShareContentRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof share>>,
  TError,
  {
    data: ShareContentRequestDto;
  },
  TContext
> => {
  const mutationOptions = getShareMutationOptions(options);
  return useMutation(mutationOptions);
};
export const donations = (
  params?: DonationsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Donations200>(
    { url: `/donations`, method: 'GET', params, signal },
    options
  );
};
export const getDonationsQueryKey = (params?: DonationsParams) => {
  return [`/donations`, ...(params ? [params] : [])] as const;
};
export const getDonationsInfiniteQueryOptions = <
  TData = Awaited<ReturnType<typeof donations>>,
  TError = ErrorType<Donations401 | Donations500>
>(
  params?: DonationsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof donations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDonationsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof donations>>> = ({
    signal,
    pageParam
  }) =>
    donations(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions,
      signal
    );
  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof donations>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type DonationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof donations>>
>;
export type DonationsInfiniteQueryError = ErrorType<
  Donations401 | Donations500
>;
export function useDonationsInfinite<
  TData = Awaited<ReturnType<typeof donations>>,
  TError = ErrorType<Donations401 | Donations500>
>(
  params?: DonationsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof donations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getDonationsInfiniteQueryOptions(params, options);
  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
export const getDonationsQueryOptions = <
  TData = Awaited<ReturnType<typeof donations>>,
  TError = ErrorType<Donations401 | Donations500>
>(
  params?: DonationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof donations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDonationsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof donations>>> = ({
    signal
  }) => donations(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof donations>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type DonationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof donations>>
>;
export type DonationsQueryError = ErrorType<Donations401 | Donations500>;
export function useDonations<
  TData = Awaited<ReturnType<typeof donations>>,
  TError = ErrorType<Donations401 | Donations500>
>(
  params?: DonationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof donations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getDonationsQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve paginated list of registered users (Admin only)
 */
export const getUsers = (
  params?: GetUsersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetUsers200>(
    { url: `/users`, method: 'GET', params, signal },
    options
  );
};
export const getGetUsersQueryKey = (params?: GetUsersParams) => {
  return [`/users`, ...(params ? [params] : [])] as const;
};
export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<GetUsers401 | GetUsers500>
>(
  params?: GetUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal
  }) => getUsers(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsers>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = ErrorType<GetUsers401 | GetUsers500>;
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<GetUsers401 | GetUsers500>
>(
  params?: GetUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetUsersQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve paginated list of events from Brushfire
 */
export const getEvents = (
  params?: GetEventsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetEvents200>(
    { url: `/events`, method: 'GET', params, signal },
    options
  );
};
export const getGetEventsQueryKey = (params?: GetEventsParams) => {
  return [`/events`, ...(params ? [params] : [])] as const;
};
export const getGetEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvents>>,
  TError = ErrorType<GetEvents500>
>(
  params?: GetEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetEventsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({
    signal
  }) => getEvents(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvents>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvents>>
>;
export type GetEventsQueryError = ErrorType<GetEvents500>;
export function useGetEvents<
  TData = Awaited<ReturnType<typeof getEvents>>,
  TError = ErrorType<GetEvents500>
>(
  params?: GetEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetEventsQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve a single event by ID from Brushfire
 */
export const getEventById = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetEventById200>(
    { url: `/events/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetEventByIdQueryKey = (id: string) => {
  return [`/events/${id}`] as const;
};
export const getGetEventByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = ErrorType<GetEventById500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventById>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetEventByIdQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventById>>> = ({
    signal
  }) => getEventById(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventById>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetEventByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventById>>
>;
export type GetEventByIdQueryError = ErrorType<GetEventById500>;
export function useGetEventById<
  TData = Awaited<ReturnType<typeof getEventById>>,
  TError = ErrorType<GetEventById500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEventById>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetEventByIdQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Register an Event
 */
export const registerEvent = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<RegisterEvent200>(
    { url: `/events/${id}/register`, method: 'POST', signal },
    options
  );
};
export const getRegisterEventMutationOptions = <
  TError = ErrorType<RegisterEvent401 | RegisterEvent500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerEvent>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerEvent>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['registerEvent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerEvent>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return registerEvent(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type RegisterEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerEvent>>
>;
export type RegisterEventMutationError = ErrorType<
  RegisterEvent401 | RegisterEvent500
>;
export const useRegisterEvent = <
  TError = ErrorType<RegisterEvent401 | RegisterEvent500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerEvent>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerEvent>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getRegisterEventMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Attend Event
 */
export const attendEvent = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AttendEvent200>(
    { url: `/events/${id}/attend`, method: 'POST', signal },
    options
  );
};
export const getAttendEventMutationOptions = <
  TError = ErrorType<AttendEvent401 | AttendEvent500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attendEvent>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attendEvent>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['attendEvent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attendEvent>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return attendEvent(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type AttendEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof attendEvent>>
>;
export type AttendEventMutationError = ErrorType<
  AttendEvent401 | AttendEvent500
>;
export const useAttendEvent = <
  TError = ErrorType<AttendEvent401 | AttendEvent500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attendEvent>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof attendEvent>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getAttendEventMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve all supported locations with their event counts
 */
export const getLocations = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetLocations200>(
    { url: `/events/locations`, method: 'GET', signal },
    options
  );
};
export const getGetLocationsQueryKey = () => {
  return [`/events/locations`] as const;
};
export const getGetLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLocations>>,
  TError = ErrorType<GetLocations500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLocations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetLocationsQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({
    signal
  }) => getLocations(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLocations>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLocations>>
>;
export type GetLocationsQueryError = ErrorType<GetLocations500>;
export function useGetLocations<
  TData = Awaited<ReturnType<typeof getLocations>>,
  TError = ErrorType<GetLocations500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLocations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetLocationsQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Process attendance webhook from Brushfire API
 */
export const brushfireAttendanceWebhook = (
  brushfireWebhookDto: BrushfireWebhookDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BrushfireAttendanceWebhook200>(
    {
      url: `/events/webhooks/brushfire/attendance`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: brushfireWebhookDto,
      signal
    },
    options
  );
};
export const getBrushfireAttendanceWebhookMutationOptions = <
  TError = ErrorType<BrushfireAttendanceWebhook500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brushfireAttendanceWebhook>>,
    TError,
    {
      data: BrushfireWebhookDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brushfireAttendanceWebhook>>,
  TError,
  {
    data: BrushfireWebhookDto;
  },
  TContext
> => {
  const mutationKey = ['brushfireAttendanceWebhook'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brushfireAttendanceWebhook>>,
    {
      data: BrushfireWebhookDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return brushfireAttendanceWebhook(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type BrushfireAttendanceWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof brushfireAttendanceWebhook>>
>;
export type BrushfireAttendanceWebhookMutationBody = BrushfireWebhookDto;
export type BrushfireAttendanceWebhookMutationError =
  ErrorType<BrushfireAttendanceWebhook500>;
export const useBrushfireAttendanceWebhook = <
  TError = ErrorType<BrushfireAttendanceWebhook500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brushfireAttendanceWebhook>>,
    TError,
    {
      data: BrushfireWebhookDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof brushfireAttendanceWebhook>>,
  TError,
  {
    data: BrushfireWebhookDto;
  },
  TContext
> => {
  const mutationOptions = getBrushfireAttendanceWebhookMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Process event created webhook from Brushfire API
 */
export const brushfireEventCreatedWebhook = (
  eventCreatedWebhookDto: EventCreatedWebhookDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<BrushfireEventCreatedWebhook200>(
    {
      url: `/events/webhooks/brushfire/event-created`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: eventCreatedWebhookDto,
      signal
    },
    options
  );
};
export const getBrushfireEventCreatedWebhookMutationOptions = <
  TError = ErrorType<BrushfireEventCreatedWebhook500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>,
    TError,
    {
      data: EventCreatedWebhookDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>,
  TError,
  {
    data: EventCreatedWebhookDto;
  },
  TContext
> => {
  const mutationKey = ['brushfireEventCreatedWebhook'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>,
    {
      data: EventCreatedWebhookDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return brushfireEventCreatedWebhook(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type BrushfireEventCreatedWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>
>;
export type BrushfireEventCreatedWebhookMutationBody = EventCreatedWebhookDto;
export type BrushfireEventCreatedWebhookMutationError =
  ErrorType<BrushfireEventCreatedWebhook500>;
export const useBrushfireEventCreatedWebhook = <
  TError = ErrorType<BrushfireEventCreatedWebhook500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>,
    TError,
    {
      data: EventCreatedWebhookDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof brushfireEventCreatedWebhook>>,
  TError,
  {
    data: EventCreatedWebhookDto;
  },
  TContext
> => {
  const mutationOptions =
    getBrushfireEventCreatedWebhookMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Hard delete user by phone number (non-prod only)
 */
export const removeUser = (
  removeUserDto: RemoveUserDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<RemoveUser200>(
    {
      url: `/operations/remove-user`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: removeUserDto
    },
    options
  );
};
export const getRemoveUserMutationOptions = <
  TError = ErrorType<RemoveUser404 | RemoveUser500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeUser>>,
    TError,
    {
      data: RemoveUserDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeUser>>,
  TError,
  {
    data: RemoveUserDto;
  },
  TContext
> => {
  const mutationKey = ['removeUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeUser>>,
    {
      data: RemoveUserDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return removeUser(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type RemoveUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeUser>>
>;
export type RemoveUserMutationBody = RemoveUserDto;
export type RemoveUserMutationError = ErrorType<RemoveUser404 | RemoveUser500>;
export const useRemoveUser = <
  TError = ErrorType<RemoveUser404 | RemoveUser500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeUser>>,
    TError,
    {
      data: RemoveUserDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeUser>>,
  TError,
  {
    data: RemoveUserDto;
  },
  TContext
> => {
  const mutationOptions = getRemoveUserMutationOptions(options);
  return useMutation(mutationOptions);
};
export const sendPushMessage = (
  sendEventAttendeeRequestDto: SendEventAttendeeRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SendPushMessage200>(
    {
      url: `/operations/send-message`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendEventAttendeeRequestDto,
      signal
    },
    options
  );
};
export const getSendPushMessageMutationOptions = <
  TError = ErrorType<SendPushMessage500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPushMessage>>,
    TError,
    {
      data: SendEventAttendeeRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendPushMessage>>,
  TError,
  {
    data: SendEventAttendeeRequestDto;
  },
  TContext
> => {
  const mutationKey = ['sendPushMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendPushMessage>>,
    {
      data: SendEventAttendeeRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return sendPushMessage(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SendPushMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendPushMessage>>
>;
export type SendPushMessageMutationBody = SendEventAttendeeRequestDto;
export type SendPushMessageMutationError = ErrorType<SendPushMessage500>;
export const useSendPushMessage = <
  TError = ErrorType<SendPushMessage500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPushMessage>>,
    TError,
    {
      data: SendEventAttendeeRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendPushMessage>>,
  TError,
  {
    data: SendEventAttendeeRequestDto;
  },
  TContext
> => {
  const mutationOptions = getSendPushMessageMutationOptions(options);
  return useMutation(mutationOptions);
};
export const confirmMobilePayment = (
  paymentsMobileConfirmPaymentIntentRequest: PaymentsMobileConfirmPaymentIntentRequest,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConfirmMobilePayment200>(
    {
      url: `/payments/mobile/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: paymentsMobileConfirmPaymentIntentRequest,
      signal
    },
    options
  );
};
export const getConfirmMobilePaymentMutationOptions = <
  TError = ErrorType<ConfirmMobilePayment401 | ConfirmMobilePayment500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmMobilePayment>>,
    TError,
    {
      data: PaymentsMobileConfirmPaymentIntentRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmMobilePayment>>,
  TError,
  {
    data: PaymentsMobileConfirmPaymentIntentRequest;
  },
  TContext
> => {
  const mutationKey = ['confirmMobilePayment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmMobilePayment>>,
    {
      data: PaymentsMobileConfirmPaymentIntentRequest;
    }
  > = (props) => {
    const { data } = props ?? {};
    return confirmMobilePayment(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ConfirmMobilePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmMobilePayment>>
>;
export type ConfirmMobilePaymentMutationBody =
  PaymentsMobileConfirmPaymentIntentRequest;
export type ConfirmMobilePaymentMutationError = ErrorType<
  ConfirmMobilePayment401 | ConfirmMobilePayment500
>;
export const useConfirmMobilePayment = <
  TError = ErrorType<ConfirmMobilePayment401 | ConfirmMobilePayment500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmMobilePayment>>,
    TError,
    {
      data: PaymentsMobileConfirmPaymentIntentRequest;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmMobilePayment>>,
  TError,
  {
    data: PaymentsMobileConfirmPaymentIntentRequest;
  },
  TContext
> => {
  const mutationOptions = getConfirmMobilePaymentMutationOptions(options);
  return useMutation(mutationOptions);
};
export const paymentSheet = (
  paymentsMobilePaymentSheetRequestDto: PaymentsMobilePaymentSheetRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<PaymentSheet200>(
    {
      url: `/payments/mobile/payment-sheet`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: paymentsMobilePaymentSheetRequestDto,
      signal
    },
    options
  );
};
export const getPaymentSheetMutationOptions = <
  TError = ErrorType<PaymentSheet401 | PaymentSheet500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentSheet>>,
    TError,
    {
      data: PaymentsMobilePaymentSheetRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentSheet>>,
  TError,
  {
    data: PaymentsMobilePaymentSheetRequestDto;
  },
  TContext
> => {
  const mutationKey = ['paymentSheet'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentSheet>>,
    {
      data: PaymentsMobilePaymentSheetRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return paymentSheet(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type PaymentSheetMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentSheet>>
>;
export type PaymentSheetMutationBody = PaymentsMobilePaymentSheetRequestDto;
export type PaymentSheetMutationError = ErrorType<
  PaymentSheet401 | PaymentSheet500
>;
export const usePaymentSheet = <
  TError = ErrorType<PaymentSheet401 | PaymentSheet500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentSheet>>,
    TError,
    {
      data: PaymentsMobilePaymentSheetRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentSheet>>,
  TError,
  {
    data: PaymentsMobilePaymentSheetRequestDto;
  },
  TContext
> => {
  const mutationOptions = getPaymentSheetMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of organizations (Admin only)
 */
export const organizations = (
  params?: OrganizationsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Organizations200>(
    { url: `/organizations`, method: 'GET', params, signal },
    options
  );
};
export const getOrganizationsQueryKey = (params?: OrganizationsParams) => {
  return [`/organizations`, ...(params ? [params] : [])] as const;
};
export const getOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof organizations>>,
  TError = ErrorType<Organizations401 | Organizations500>
>(
  params?: OrganizationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organizations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof organizations>>> = ({
    signal
  }) => organizations(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizations>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type OrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizations>>
>;
export type OrganizationsQueryError = ErrorType<
  Organizations401 | Organizations500
>;
export function useOrganizations<
  TData = Awaited<ReturnType<typeof organizations>>,
  TError = ErrorType<Organizations401 | Organizations500>
>(
  params?: OrganizationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organizations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getOrganizationsQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new organization (Admin only)
 */
export const createOrganization = (
  createOrganizationDto: CreateOrganizationDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateOrganization200>(
    {
      url: `/organizations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createOrganizationDto,
      signal
    },
    options
  );
};
export const getCreateOrganizationMutationOptions = <
  TError = ErrorType<CreateOrganization401 | CreateOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    {
      data: CreateOrganizationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  {
    data: CreateOrganizationDto;
  },
  TContext
> => {
  const mutationKey = ['createOrganization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganization>>,
    {
      data: CreateOrganizationDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createOrganization(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = CreateOrganizationDto;
export type CreateOrganizationMutationError = ErrorType<
  CreateOrganization401 | CreateOrganization500
>;
export const useCreateOrganization = <
  TError = ErrorType<CreateOrganization401 | CreateOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    {
      data: CreateOrganizationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  {
    data: CreateOrganizationDto;
  },
  TContext
> => {
  const mutationOptions = getCreateOrganizationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve organization by ID (Admin only)
 */
export const organization = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Organization200>(
    { url: `/organizations/${id}`, method: 'GET', signal },
    options
  );
};
export const getOrganizationQueryKey = (id: string) => {
  return [`/organizations/${id}`] as const;
};
export const getOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof organization>>,
  TError = ErrorType<Organization401 | Organization500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organization>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getOrganizationQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof organization>>> = ({
    signal
  }) => organization(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof organization>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type OrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof organization>>
>;
export type OrganizationQueryError = ErrorType<
  Organization401 | Organization500
>;
export function useOrganization<
  TData = Awaited<ReturnType<typeof organization>>,
  TError = ErrorType<Organization401 | Organization500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof organization>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getOrganizationQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update organization by ID (Admin only)
 */
export const updateOrganization = (
  id: string,
  updateOrganizationDto: UpdateOrganizationDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateOrganization200>(
    {
      url: `/organizations/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateOrganizationDto
    },
    options
  );
};
export const getUpdateOrganizationMutationOptions = <
  TError = ErrorType<UpdateOrganization401 | UpdateOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    {
      id: string;
      data: UpdateOrganizationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  {
    id: string;
    data: UpdateOrganizationDto;
  },
  TContext
> => {
  const mutationKey = ['updateOrganization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganization>>,
    {
      id: string;
      data: UpdateOrganizationDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateOrganization(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = UpdateOrganizationDto;
export type UpdateOrganizationMutationError = ErrorType<
  UpdateOrganization401 | UpdateOrganization500
>;
export const useUpdateOrganization = <
  TError = ErrorType<UpdateOrganization401 | UpdateOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    {
      id: string;
      data: UpdateOrganizationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  {
    id: string;
    data: UpdateOrganizationDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete organization by ID (Admin only)
 */
export const deleteOrganization = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteOrganization200>(
    { url: `/organizations/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteOrganizationMutationOptions = <
  TError = ErrorType<DeleteOrganization401 | DeleteOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganization>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteOrganization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganization>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteOrganization(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganization>>
>;
export type DeleteOrganizationMutationError = ErrorType<
  DeleteOrganization401 | DeleteOrganization500
>;
export const useDeleteOrganization = <
  TError = ErrorType<DeleteOrganization401 | DeleteOrganization500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganization>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteOrganizationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of needs
 */
export const needs = (
  params?: NeedsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Needs200>(
    { url: `/needs`, method: 'GET', params, signal },
    options
  );
};
export const getNeedsQueryKey = (params?: NeedsParams) => {
  return [`/needs`, ...(params ? [params] : [])] as const;
};
export const getNeedsQueryOptions = <
  TData = Awaited<ReturnType<typeof needs>>,
  TError = ErrorType<Needs401 | Needs500>
>(
  params?: NeedsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof needs>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getNeedsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof needs>>> = ({
    signal
  }) => needs(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof needs>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type NeedsQueryResult = NonNullable<Awaited<ReturnType<typeof needs>>>;
export type NeedsQueryError = ErrorType<Needs401 | Needs500>;
export function useNeeds<
  TData = Awaited<ReturnType<typeof needs>>,
  TError = ErrorType<Needs401 | Needs500>
>(
  params?: NeedsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof needs>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getNeedsQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new need
 */
export const createNeed = (
  createNeedDto: CreateNeedDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateNeed200>(
    {
      url: `/needs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createNeedDto,
      signal
    },
    options
  );
};
export const getCreateNeedMutationOptions = <
  TError = ErrorType<CreateNeed401 | CreateNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNeed>>,
    TError,
    {
      data: CreateNeedDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNeed>>,
  TError,
  {
    data: CreateNeedDto;
  },
  TContext
> => {
  const mutationKey = ['createNeed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNeed>>,
    {
      data: CreateNeedDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createNeed(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNeed>>
>;
export type CreateNeedMutationBody = CreateNeedDto;
export type CreateNeedMutationError = ErrorType<CreateNeed401 | CreateNeed500>;
export const useCreateNeed = <
  TError = ErrorType<CreateNeed401 | CreateNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNeed>>,
    TError,
    {
      data: CreateNeedDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNeed>>,
  TError,
  {
    data: CreateNeedDto;
  },
  TContext
> => {
  const mutationOptions = getCreateNeedMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve a need by ID
 */
export const getNeed = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetNeed200>(
    { url: `/needs/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetNeedQueryKey = (id: string) => {
  return [`/needs/${id}`] as const;
};
export const getGetNeedQueryOptions = <
  TData = Awaited<ReturnType<typeof getNeed>>,
  TError = ErrorType<GetNeed401 | GetNeed404 | GetNeed500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNeed>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetNeedQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNeed>>> = ({
    signal
  }) => getNeed(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getNeed>>, TError, TData> & {
    queryKey: QueryKey;
  };
};
export type GetNeedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNeed>>
>;
export type GetNeedQueryError = ErrorType<GetNeed401 | GetNeed404 | GetNeed500>;
export function useGetNeed<
  TData = Awaited<ReturnType<typeof getNeed>>,
  TError = ErrorType<GetNeed401 | GetNeed404 | GetNeed500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNeed>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetNeedQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an existing need by ID
 */
export const updateNeed = (
  id: string,
  updateNeedDto: UpdateNeedDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateNeed200>(
    {
      url: `/needs/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateNeedDto
    },
    options
  );
};
export const getUpdateNeedMutationOptions = <
  TError = ErrorType<UpdateNeed401 | UpdateNeed404 | UpdateNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNeed>>,
    TError,
    {
      id: string;
      data: UpdateNeedDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNeed>>,
  TError,
  {
    id: string;
    data: UpdateNeedDto;
  },
  TContext
> => {
  const mutationKey = ['updateNeed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNeed>>,
    {
      id: string;
      data: UpdateNeedDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateNeed(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNeed>>
>;
export type UpdateNeedMutationBody = UpdateNeedDto;
export type UpdateNeedMutationError = ErrorType<
  UpdateNeed401 | UpdateNeed404 | UpdateNeed500
>;
export const useUpdateNeed = <
  TError = ErrorType<UpdateNeed401 | UpdateNeed404 | UpdateNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNeed>>,
    TError,
    {
      id: string;
      data: UpdateNeedDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNeed>>,
  TError,
  {
    id: string;
    data: UpdateNeedDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateNeedMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete a need by ID
 */
export const deleteNeed = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteNeed200>(
    { url: `/needs/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteNeedMutationOptions = <
  TError = ErrorType<DeleteNeed401 | DeleteNeed404 | DeleteNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNeed>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNeed>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteNeed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNeed>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteNeed(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteNeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNeed>>
>;
export type DeleteNeedMutationError = ErrorType<
  DeleteNeed401 | DeleteNeed404 | DeleteNeed500
>;
export const useDeleteNeed = <
  TError = ErrorType<DeleteNeed401 | DeleteNeed404 | DeleteNeed500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNeed>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNeed>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteNeedMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of goodVibes
 */
export const goodVibes = (
  params?: GoodVibesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GoodVibes200>(
    { url: `/good-vibes`, method: 'GET', params, signal },
    options
  );
};
export const getGoodVibesQueryKey = (params?: GoodVibesParams) => {
  return [`/good-vibes`, ...(params ? [params] : [])] as const;
};
export const getGoodVibesQueryOptions = <
  TData = Awaited<ReturnType<typeof goodVibes>>,
  TError = ErrorType<GoodVibes500>
>(
  params?: GoodVibesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof goodVibes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGoodVibesQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof goodVibes>>> = ({
    signal
  }) => goodVibes(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof goodVibes>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GoodVibesQueryResult = NonNullable<
  Awaited<ReturnType<typeof goodVibes>>
>;
export type GoodVibesQueryError = ErrorType<GoodVibes500>;
export function useGoodVibes<
  TData = Awaited<ReturnType<typeof goodVibes>>,
  TError = ErrorType<GoodVibes500>
>(
  params?: GoodVibesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof goodVibes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGoodVibesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new goodVibes
 */
export const createGoodVibe = (
  createGoodVibeDto: CreateGoodVibeDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateGoodVibe200>(
    {
      url: `/good-vibes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createGoodVibeDto,
      signal
    },
    options
  );
};
export const getCreateGoodVibeMutationOptions = <
  TError = ErrorType<CreateGoodVibe401 | CreateGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoodVibe>>,
    TError,
    {
      data: CreateGoodVibeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoodVibe>>,
  TError,
  {
    data: CreateGoodVibeDto;
  },
  TContext
> => {
  const mutationKey = ['createGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoodVibe>>,
    {
      data: CreateGoodVibeDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createGoodVibe(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoodVibe>>
>;
export type CreateGoodVibeMutationBody = CreateGoodVibeDto;
export type CreateGoodVibeMutationError = ErrorType<
  CreateGoodVibe401 | CreateGoodVibe500
>;
export const useCreateGoodVibe = <
  TError = ErrorType<CreateGoodVibe401 | CreateGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoodVibe>>,
    TError,
    {
      data: CreateGoodVibeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoodVibe>>,
  TError,
  {
    data: CreateGoodVibeDto;
  },
  TContext
> => {
  const mutationOptions = getCreateGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve a goodVibes by ID
 */
export const getGoodVibe = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetGoodVibe200>(
    { url: `/good-vibes/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetGoodVibeQueryKey = (id: string) => {
  return [`/good-vibes/${id}`] as const;
};
export const getGetGoodVibeQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoodVibe>>,
  TError = ErrorType<GetGoodVibe500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGoodVibe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetGoodVibeQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoodVibe>>> = ({
    signal
  }) => getGoodVibe(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoodVibe>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetGoodVibeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoodVibe>>
>;
export type GetGoodVibeQueryError = ErrorType<GetGoodVibe500>;
export function useGetGoodVibe<
  TData = Awaited<ReturnType<typeof getGoodVibe>>,
  TError = ErrorType<GetGoodVibe500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGoodVibe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetGoodVibeQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an existing goodVibes by ID
 */
export const updateGoodVibe = (
  id: string,
  updateGoodVibeDto: UpdateGoodVibeDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateGoodVibe200>(
    {
      url: `/good-vibes/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateGoodVibeDto
    },
    options
  );
};
export const getUpdateGoodVibeMutationOptions = <
  TError = ErrorType<UpdateGoodVibe401 | UpdateGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoodVibe>>,
    TError,
    {
      id: string;
      data: UpdateGoodVibeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoodVibe>>,
  TError,
  {
    id: string;
    data: UpdateGoodVibeDto;
  },
  TContext
> => {
  const mutationKey = ['updateGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoodVibe>>,
    {
      id: string;
      data: UpdateGoodVibeDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateGoodVibe(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGoodVibe>>
>;
export type UpdateGoodVibeMutationBody = UpdateGoodVibeDto;
export type UpdateGoodVibeMutationError = ErrorType<
  UpdateGoodVibe401 | UpdateGoodVibe500
>;
export const useUpdateGoodVibe = <
  TError = ErrorType<UpdateGoodVibe401 | UpdateGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoodVibe>>,
    TError,
    {
      id: string;
      data: UpdateGoodVibeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGoodVibe>>,
  TError,
  {
    id: string;
    data: UpdateGoodVibeDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete a goodVibes by ID
 */
export const deleteGoodVibe = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteGoodVibe200>(
    { url: `/good-vibes/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteGoodVibeMutationOptions = <
  TError = ErrorType<DeleteGoodVibe401 | DeleteGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoodVibe>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoodVibe>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGoodVibe>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteGoodVibe(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGoodVibe>>
>;
export type DeleteGoodVibeMutationError = ErrorType<
  DeleteGoodVibe401 | DeleteGoodVibe500
>;
export const useDeleteGoodVibe = <
  TError = ErrorType<DeleteGoodVibe401 | DeleteGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoodVibe>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoodVibe>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get the current Good Vibe for today
 */
export const getCurrentGoodVibe = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetCurrentGoodVibe200>(
    { url: `/good-vibes/current`, method: 'GET', signal },
    options
  );
};
export const getGetCurrentGoodVibeQueryKey = () => {
  return [`/good-vibes/current`] as const;
};
export const getGetCurrentGoodVibeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentGoodVibe>>,
  TError = ErrorType<GetCurrentGoodVibe500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentGoodVibe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetCurrentGoodVibeQueryKey();
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentGoodVibe>>
  > = ({ signal }) => getCurrentGoodVibe(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentGoodVibe>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetCurrentGoodVibeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentGoodVibe>>
>;
export type GetCurrentGoodVibeQueryError = ErrorType<GetCurrentGoodVibe500>;
export function useGetCurrentGoodVibe<
  TData = Awaited<ReturnType<typeof getCurrentGoodVibe>>,
  TError = ErrorType<GetCurrentGoodVibe500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentGoodVibe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetCurrentGoodVibeQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Set a Good Vibe for a specific date
 */
export const setNextDayGoodVibe = (
  id: string,
  setNextDateGoodVibeRequestDto: SetNextDateGoodVibeRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SetNextDayGoodVibe200>(
    {
      url: `/good-vibes/${id}/setDate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setNextDateGoodVibeRequestDto,
      signal
    },
    options
  );
};
export const getSetNextDayGoodVibeMutationOptions = <
  TError = ErrorType<SetNextDayGoodVibe401 | SetNextDayGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setNextDayGoodVibe>>,
    TError,
    {
      id: string;
      data: SetNextDateGoodVibeRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setNextDayGoodVibe>>,
  TError,
  {
    id: string;
    data: SetNextDateGoodVibeRequestDto;
  },
  TContext
> => {
  const mutationKey = ['setNextDayGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setNextDayGoodVibe>>,
    {
      id: string;
      data: SetNextDateGoodVibeRequestDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return setNextDayGoodVibe(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SetNextDayGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof setNextDayGoodVibe>>
>;
export type SetNextDayGoodVibeMutationBody = SetNextDateGoodVibeRequestDto;
export type SetNextDayGoodVibeMutationError = ErrorType<
  SetNextDayGoodVibe401 | SetNextDayGoodVibe500
>;
export const useSetNextDayGoodVibe = <
  TError = ErrorType<SetNextDayGoodVibe401 | SetNextDayGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setNextDayGoodVibe>>,
    TError,
    {
      id: string;
      data: SetNextDateGoodVibeRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setNextDayGoodVibe>>,
  TError,
  {
    id: string;
    data: SetNextDateGoodVibeRequestDto;
  },
  TContext
> => {
  const mutationOptions = getSetNextDayGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Complete a Good Vibe
 */
export const completeGoodVibe = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CompleteGoodVibe200>(
    { url: `/good-vibes/${id}/complete`, method: 'POST', signal },
    options
  );
};
export const getCompleteGoodVibeMutationOptions = <
  TError = ErrorType<CompleteGoodVibe401 | CompleteGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeGoodVibe>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeGoodVibe>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['completeGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeGoodVibe>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return completeGoodVibe(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CompleteGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeGoodVibe>>
>;
export type CompleteGoodVibeMutationError = ErrorType<
  CompleteGoodVibe401 | CompleteGoodVibe500
>;
export const useCompleteGoodVibe = <
  TError = ErrorType<CompleteGoodVibe401 | CompleteGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeGoodVibe>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeGoodVibe>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getCompleteGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * [Operational] Reset the current Good Vibe for today
 */
export const resetCurrentGoodVibe = (
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ResetCurrentGoodVibe200>(
    { url: `/good-vibes/current/reset`, method: 'DELETE' },
    options
  );
};
export const getResetCurrentGoodVibeMutationOptions = <
  TError = ErrorType<ResetCurrentGoodVibe401 | ResetCurrentGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCurrentGoodVibe>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCurrentGoodVibe>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['resetCurrentGoodVibe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCurrentGoodVibe>>,
    void
  > = () => {
    return resetCurrentGoodVibe(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ResetCurrentGoodVibeMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetCurrentGoodVibe>>
>;
export type ResetCurrentGoodVibeMutationError = ErrorType<
  ResetCurrentGoodVibe401 | ResetCurrentGoodVibe500
>;
export const useResetCurrentGoodVibe = <
  TError = ErrorType<ResetCurrentGoodVibe401 | ResetCurrentGoodVibe500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCurrentGoodVibe>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCurrentGoodVibe>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getResetCurrentGoodVibeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Complete a Daily Good
 */
export const completeDailyGood = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CompleteDailyGood200>(
    { url: `/daily-goods/${id}/complete`, method: 'POST', signal },
    options
  );
};
export const getCompleteDailyGoodMutationOptions = <
  TError = ErrorType<CompleteDailyGood401 | CompleteDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeDailyGood>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeDailyGood>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['completeDailyGood'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeDailyGood>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return completeDailyGood(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CompleteDailyGoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeDailyGood>>
>;
export type CompleteDailyGoodMutationError = ErrorType<
  CompleteDailyGood401 | CompleteDailyGood500
>;
export const useCompleteDailyGood = <
  TError = ErrorType<CompleteDailyGood401 | CompleteDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeDailyGood>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeDailyGood>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getCompleteDailyGoodMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of DailyGoods
 */
export const dailyGoods = (
  params?: DailyGoodsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<DailyGoods200>(
    { url: `/daily-goods`, method: 'GET', params, signal },
    options
  );
};
export const getDailyGoodsQueryKey = (params?: DailyGoodsParams) => {
  return [`/daily-goods`, ...(params ? [params] : [])] as const;
};
export const getDailyGoodsQueryOptions = <
  TData = Awaited<ReturnType<typeof dailyGoods>>,
  TError = ErrorType<DailyGoods500>
>(
  params?: DailyGoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof dailyGoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getDailyGoodsQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof dailyGoods>>> = ({
    signal
  }) => dailyGoods(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dailyGoods>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type DailyGoodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dailyGoods>>
>;
export type DailyGoodsQueryError = ErrorType<DailyGoods500>;
export function useDailyGoods<
  TData = Awaited<ReturnType<typeof dailyGoods>>,
  TError = ErrorType<DailyGoods500>
>(
  params?: DailyGoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof dailyGoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getDailyGoodsQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new DailyGoods
 */
export const createDailyGood = (
  createDailyGoodDto: CreateDailyGoodDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateDailyGood200>(
    {
      url: `/daily-goods`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDailyGoodDto,
      signal
    },
    options
  );
};
export const getCreateDailyGoodMutationOptions = <
  TError = ErrorType<CreateDailyGood401 | CreateDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyGood>>,
    TError,
    {
      data: CreateDailyGoodDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDailyGood>>,
  TError,
  {
    data: CreateDailyGoodDto;
  },
  TContext
> => {
  const mutationKey = ['createDailyGood'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDailyGood>>,
    {
      data: CreateDailyGoodDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createDailyGood(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateDailyGoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDailyGood>>
>;
export type CreateDailyGoodMutationBody = CreateDailyGoodDto;
export type CreateDailyGoodMutationError = ErrorType<
  CreateDailyGood401 | CreateDailyGood500
>;
export const useCreateDailyGood = <
  TError = ErrorType<CreateDailyGood401 | CreateDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDailyGood>>,
    TError,
    {
      data: CreateDailyGoodDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDailyGood>>,
  TError,
  {
    data: CreateDailyGoodDto;
  },
  TContext
> => {
  const mutationOptions = getCreateDailyGoodMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get the current Daily Good for today
 */
export const getCurrentDailyGood = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetCurrentDailyGood200>(
    { url: `/daily-goods/current`, method: 'GET', signal },
    options
  );
};
export const getGetCurrentDailyGoodQueryKey = () => {
  return [`/daily-goods/current`] as const;
};
export const getGetCurrentDailyGoodQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentDailyGood>>,
  TError = ErrorType<GetCurrentDailyGood500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDailyGood>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetCurrentDailyGoodQueryKey();
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentDailyGood>>
  > = ({ signal }) => getCurrentDailyGood(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDailyGood>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetCurrentDailyGoodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentDailyGood>>
>;
export type GetCurrentDailyGoodQueryError = ErrorType<GetCurrentDailyGood500>;
export function useGetCurrentDailyGood<
  TData = Awaited<ReturnType<typeof getCurrentDailyGood>>,
  TError = ErrorType<GetCurrentDailyGood500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDailyGood>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetCurrentDailyGoodQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve a DailyGoods by ID
 */
export const getDailyGood = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetDailyGood200>(
    { url: `/daily-goods/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetDailyGoodQueryKey = (id: string) => {
  return [`/daily-goods/${id}`] as const;
};
export const getGetDailyGoodQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyGood>>,
  TError = ErrorType<GetDailyGood500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyGood>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetDailyGoodQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyGood>>> = ({
    signal
  }) => getDailyGood(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyGood>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetDailyGoodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyGood>>
>;
export type GetDailyGoodQueryError = ErrorType<GetDailyGood500>;
export function useGetDailyGood<
  TData = Awaited<ReturnType<typeof getDailyGood>>,
  TError = ErrorType<GetDailyGood500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailyGood>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetDailyGoodQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an existing DailyGoods by ID
 */
export const updateDailyGood = (
  id: string,
  updateDailyGoodDto: UpdateDailyGoodDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateDailyGood200>(
    {
      url: `/daily-goods/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateDailyGoodDto
    },
    options
  );
};
export const getUpdateDailyGoodMutationOptions = <
  TError = ErrorType<UpdateDailyGood401 | UpdateDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDailyGood>>,
    TError,
    {
      id: string;
      data: UpdateDailyGoodDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDailyGood>>,
  TError,
  {
    id: string;
    data: UpdateDailyGoodDto;
  },
  TContext
> => {
  const mutationKey = ['updateDailyGood'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDailyGood>>,
    {
      id: string;
      data: UpdateDailyGoodDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateDailyGood(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateDailyGoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDailyGood>>
>;
export type UpdateDailyGoodMutationBody = UpdateDailyGoodDto;
export type UpdateDailyGoodMutationError = ErrorType<
  UpdateDailyGood401 | UpdateDailyGood500
>;
export const useUpdateDailyGood = <
  TError = ErrorType<UpdateDailyGood401 | UpdateDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDailyGood>>,
    TError,
    {
      id: string;
      data: UpdateDailyGoodDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDailyGood>>,
  TError,
  {
    id: string;
    data: UpdateDailyGoodDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateDailyGoodMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete a DailyGoods by ID
 */
export const deleteDailyGood = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteDailyGood200>(
    { url: `/daily-goods/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteDailyGoodMutationOptions = <
  TError = ErrorType<DeleteDailyGood401 | DeleteDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyGood>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDailyGood>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteDailyGood'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDailyGood>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteDailyGood(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteDailyGoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDailyGood>>
>;
export type DeleteDailyGoodMutationError = ErrorType<
  DeleteDailyGood401 | DeleteDailyGood500
>;
export const useDeleteDailyGood = <
  TError = ErrorType<DeleteDailyGood401 | DeleteDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDailyGood>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDailyGood>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteDailyGoodMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * [Operational] Reset the current Daily Good for today
 */
export const resetCurrentDailyGood = (
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<ResetCurrentDailyGood200>(
    { url: `/daily-goods/current/reset`, method: 'DELETE' },
    options
  );
};
export const getResetCurrentDailyGoodMutationOptions = <
  TError = ErrorType<ResetCurrentDailyGood401 | ResetCurrentDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCurrentDailyGood>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCurrentDailyGood>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['resetCurrentDailyGood'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCurrentDailyGood>>,
    void
  > = () => {
    return resetCurrentDailyGood(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ResetCurrentDailyGoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetCurrentDailyGood>>
>;
export type ResetCurrentDailyGoodMutationError = ErrorType<
  ResetCurrentDailyGood401 | ResetCurrentDailyGood500
>;
export const useResetCurrentDailyGood = <
  TError = ErrorType<ResetCurrentDailyGood401 | ResetCurrentDailyGood500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCurrentDailyGood>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCurrentDailyGood>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getResetCurrentDailyGoodMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of raffles
 */
export const raffles = (
  params?: RafflesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Raffles200>(
    { url: `/raffles`, method: 'GET', params, signal },
    options
  );
};
export const getRafflesQueryKey = (params?: RafflesParams) => {
  return [`/raffles`, ...(params ? [params] : [])] as const;
};
export const getRafflesQueryOptions = <
  TData = Awaited<ReturnType<typeof raffles>>,
  TError = ErrorType<Raffles401 | Raffles500>
>(
  params?: RafflesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof raffles>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getRafflesQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof raffles>>> = ({
    signal
  }) => raffles(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof raffles>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type RafflesQueryResult = NonNullable<
  Awaited<ReturnType<typeof raffles>>
>;
export type RafflesQueryError = ErrorType<Raffles401 | Raffles500>;
export function useRaffles<
  TData = Awaited<ReturnType<typeof raffles>>,
  TError = ErrorType<Raffles401 | Raffles500>
>(
  params?: RafflesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof raffles>>, TError, TData>;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getRafflesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new raffle
 */
export const createRaffle = (
  createRaffleDto: CreateRaffleDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateRaffle200>(
    {
      url: `/raffles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRaffleDto,
      signal
    },
    options
  );
};
export const getCreateRaffleMutationOptions = <
  TError = ErrorType<CreateRaffle401 | CreateRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRaffle>>,
    TError,
    {
      data: CreateRaffleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRaffle>>,
  TError,
  {
    data: CreateRaffleDto;
  },
  TContext
> => {
  const mutationKey = ['createRaffle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRaffle>>,
    {
      data: CreateRaffleDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createRaffle(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateRaffleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRaffle>>
>;
export type CreateRaffleMutationBody = CreateRaffleDto;
export type CreateRaffleMutationError = ErrorType<
  CreateRaffle401 | CreateRaffle500
>;
export const useCreateRaffle = <
  TError = ErrorType<CreateRaffle401 | CreateRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRaffle>>,
    TError,
    {
      data: CreateRaffleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRaffle>>,
  TError,
  {
    data: CreateRaffleDto;
  },
  TContext
> => {
  const mutationOptions = getCreateRaffleMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve a raffle by ID
 */
export const getRaffle = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetRaffle200>(
    { url: `/raffles/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetRaffleQueryKey = (id: string) => {
  return [`/raffles/${id}`] as const;
};
export const getGetRaffleQueryOptions = <
  TData = Awaited<ReturnType<typeof getRaffle>>,
  TError = ErrorType<GetRaffle401 | GetRaffle404 | GetRaffle500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRaffle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetRaffleQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRaffle>>> = ({
    signal
  }) => getRaffle(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getRaffle>>, TError, TData> & {
    queryKey: QueryKey;
  };
};
export type GetRaffleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRaffle>>
>;
export type GetRaffleQueryError = ErrorType<
  GetRaffle401 | GetRaffle404 | GetRaffle500
>;
export function useGetRaffle<
  TData = Awaited<ReturnType<typeof getRaffle>>,
  TError = ErrorType<GetRaffle401 | GetRaffle404 | GetRaffle500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRaffle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetRaffleQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an existing raffle by ID
 */
export const updateRaffle = (
  id: string,
  updateRaffleDto: UpdateRaffleDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateRaffle200>(
    {
      url: `/raffles/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateRaffleDto
    },
    options
  );
};
export const getUpdateRaffleMutationOptions = <
  TError = ErrorType<UpdateRaffle401 | UpdateRaffle404 | UpdateRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRaffle>>,
    TError,
    {
      id: string;
      data: UpdateRaffleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRaffle>>,
  TError,
  {
    id: string;
    data: UpdateRaffleDto;
  },
  TContext
> => {
  const mutationKey = ['updateRaffle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRaffle>>,
    {
      id: string;
      data: UpdateRaffleDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateRaffle(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateRaffleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRaffle>>
>;
export type UpdateRaffleMutationBody = UpdateRaffleDto;
export type UpdateRaffleMutationError = ErrorType<
  UpdateRaffle401 | UpdateRaffle404 | UpdateRaffle500
>;
export const useUpdateRaffle = <
  TError = ErrorType<UpdateRaffle401 | UpdateRaffle404 | UpdateRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRaffle>>,
    TError,
    {
      id: string;
      data: UpdateRaffleDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRaffle>>,
  TError,
  {
    id: string;
    data: UpdateRaffleDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateRaffleMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete a raffle by ID
 */
export const deleteRaffle = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteRaffle200>(
    { url: `/raffles/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteRaffleMutationOptions = <
  TError = ErrorType<DeleteRaffle401 | DeleteRaffle404 | DeleteRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRaffle>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRaffle>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteRaffle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRaffle>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteRaffle(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteRaffleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRaffle>>
>;
export type DeleteRaffleMutationError = ErrorType<
  DeleteRaffle401 | DeleteRaffle404 | DeleteRaffle500
>;
export const useDeleteRaffle = <
  TError = ErrorType<DeleteRaffle401 | DeleteRaffle404 | DeleteRaffle500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRaffle>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRaffle>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteRaffleMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Enter a raffle
 */
export const enterRaffle = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<EnterRaffle200>(
    { url: `/raffles/${id}/enter`, method: 'POST', signal },
    options
  );
};
export const getEnterRaffleMutationOptions = <
  TError = ErrorType<
    EnterRaffle400 | EnterRaffle401 | EnterRaffle404 | EnterRaffle500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enterRaffle>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enterRaffle>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['enterRaffle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enterRaffle>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return enterRaffle(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type EnterRaffleMutationResult = NonNullable<
  Awaited<ReturnType<typeof enterRaffle>>
>;
export type EnterRaffleMutationError = ErrorType<
  EnterRaffle400 | EnterRaffle401 | EnterRaffle404 | EnterRaffle500
>;
export const useEnterRaffle = <
  TError = ErrorType<
    EnterRaffle400 | EnterRaffle401 | EnterRaffle404 | EnterRaffle500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enterRaffle>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enterRaffle>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getEnterRaffleMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get raffles that the current user has entered
 */
export const getMyRaffles = (
  params?: GetMyRafflesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetMyRaffles200>(
    { url: `/raffles/my-raffles`, method: 'GET', params, signal },
    options
  );
};
export const getGetMyRafflesQueryKey = (params?: GetMyRafflesParams) => {
  return [`/raffles/my-raffles`, ...(params ? [params] : [])] as const;
};
export const getGetMyRafflesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyRaffles>>,
  TError = ErrorType<GetMyRaffles401 | GetMyRaffles500>
>(
  params?: GetMyRafflesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyRaffles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMyRafflesQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRaffles>>> = ({
    signal
  }) => getMyRaffles(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyRaffles>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetMyRafflesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyRaffles>>
>;
export type GetMyRafflesQueryError = ErrorType<
  GetMyRaffles401 | GetMyRaffles500
>;
export function useGetMyRaffles<
  TData = Awaited<ReturnType<typeof getMyRaffles>>,
  TError = ErrorType<GetMyRaffles401 | GetMyRaffles500>
>(
  params?: GetMyRafflesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyRaffles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetMyRafflesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Get all participants of a raffle (Admin only)
 */
export const getRaffleParticipants = (
  id: string,
  params?: GetRaffleParticipantsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetRaffleParticipants200>(
    { url: `/raffles/${id}/participants`, method: 'GET', params, signal },
    options
  );
};
export const getGetRaffleParticipantsQueryKey = (
  id: string,
  params?: GetRaffleParticipantsParams
) => {
  return [`/raffles/${id}/participants`, ...(params ? [params] : [])] as const;
};
export const getGetRaffleParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRaffleParticipants>>,
  TError = ErrorType<
    | GetRaffleParticipants401
    | GetRaffleParticipants404
    | GetRaffleParticipants500
  >
>(
  id: string,
  params?: GetRaffleParticipantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRaffleParticipants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey =
    queryOptions?.queryKey ?? getGetRaffleParticipantsQueryKey(id, params);
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRaffleParticipants>>
  > = ({ signal }) => getRaffleParticipants(id, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRaffleParticipants>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetRaffleParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRaffleParticipants>>
>;
export type GetRaffleParticipantsQueryError = ErrorType<
  GetRaffleParticipants401 | GetRaffleParticipants404 | GetRaffleParticipants500
>;
export function useGetRaffleParticipants<
  TData = Awaited<ReturnType<typeof getRaffleParticipants>>,
  TError = ErrorType<
    | GetRaffleParticipants401
    | GetRaffleParticipants404
    | GetRaffleParticipants500
  >
>(
  id: string,
  params?: GetRaffleParticipantsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRaffleParticipants>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetRaffleParticipantsQueryOptions(
    id,
    params,
    options
  );
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Close raffle and pick winner
 */
export const closeRaffleAndPickWinner = (
  id: string,
  closeRaffleAndPickWinnerRequestDto: CloseRaffleAndPickWinnerRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CloseRaffleAndPickWinner200>(
    {
      url: `/raffles/${id}/close`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: closeRaffleAndPickWinnerRequestDto,
      signal
    },
    options
  );
};
export const getCloseRaffleAndPickWinnerMutationOptions = <
  TError = ErrorType<
    | CloseRaffleAndPickWinner400
    | CloseRaffleAndPickWinner401
    | CloseRaffleAndPickWinner500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeRaffleAndPickWinner>>,
    TError,
    {
      id: string;
      data: CloseRaffleAndPickWinnerRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeRaffleAndPickWinner>>,
  TError,
  {
    id: string;
    data: CloseRaffleAndPickWinnerRequestDto;
  },
  TContext
> => {
  const mutationKey = ['closeRaffleAndPickWinner'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeRaffleAndPickWinner>>,
    {
      id: string;
      data: CloseRaffleAndPickWinnerRequestDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return closeRaffleAndPickWinner(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CloseRaffleAndPickWinnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeRaffleAndPickWinner>>
>;
export type CloseRaffleAndPickWinnerMutationBody =
  CloseRaffleAndPickWinnerRequestDto;
export type CloseRaffleAndPickWinnerMutationError = ErrorType<
  | CloseRaffleAndPickWinner400
  | CloseRaffleAndPickWinner401
  | CloseRaffleAndPickWinner500
>;
export const useCloseRaffleAndPickWinner = <
  TError = ErrorType<
    | CloseRaffleAndPickWinner400
    | CloseRaffleAndPickWinner401
    | CloseRaffleAndPickWinner500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeRaffleAndPickWinner>>,
    TError,
    {
      id: string;
      data: CloseRaffleAndPickWinnerRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeRaffleAndPickWinner>>,
  TError,
  {
    id: string;
    data: CloseRaffleAndPickWinnerRequestDto;
  },
  TContext
> => {
  const mutationOptions = getCloseRaffleAndPickWinnerMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of merchandises
 */
export const merchandises = (
  params?: MerchandisesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<Merchandises200>(
    { url: `/merchandises`, method: 'GET', params, signal },
    options
  );
};
export const getMerchandisesQueryKey = (params?: MerchandisesParams) => {
  return [`/merchandises`, ...(params ? [params] : [])] as const;
};
export const getMerchandisesQueryOptions = <
  TData = Awaited<ReturnType<typeof merchandises>>,
  TError = ErrorType<Merchandises401 | Merchandises500>
>(
  params?: MerchandisesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchandises>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMerchandisesQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof merchandises>>> = ({
    signal
  }) => merchandises(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof merchandises>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type MerchandisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof merchandises>>
>;
export type MerchandisesQueryError = ErrorType<
  Merchandises401 | Merchandises500
>;
export function useMerchandises<
  TData = Awaited<ReturnType<typeof merchandises>>,
  TError = ErrorType<Merchandises401 | Merchandises500>
>(
  params?: MerchandisesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof merchandises>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getMerchandisesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Create a new merchandise
 */
export const createMerchandise = (
  createMerchandiseDto: CreateMerchandiseDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CreateMerchandise200>(
    {
      url: `/merchandises`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMerchandiseDto,
      signal
    },
    options
  );
};
export const getCreateMerchandiseMutationOptions = <
  TError = ErrorType<CreateMerchandise401 | CreateMerchandise500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMerchandise>>,
    TError,
    {
      data: CreateMerchandiseDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMerchandise>>,
  TError,
  {
    data: CreateMerchandiseDto;
  },
  TContext
> => {
  const mutationKey = ['createMerchandise'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMerchandise>>,
    {
      data: CreateMerchandiseDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return createMerchandise(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateMerchandiseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMerchandise>>
>;
export type CreateMerchandiseMutationBody = CreateMerchandiseDto;
export type CreateMerchandiseMutationError = ErrorType<
  CreateMerchandise401 | CreateMerchandise500
>;
export const useCreateMerchandise = <
  TError = ErrorType<CreateMerchandise401 | CreateMerchandise500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMerchandise>>,
    TError,
    {
      data: CreateMerchandiseDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMerchandise>>,
  TError,
  {
    data: CreateMerchandiseDto;
  },
  TContext
> => {
  const mutationOptions = getCreateMerchandiseMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve a merchandise by ID
 */
export const getMerchandise = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetMerchandise200>(
    { url: `/merchandises/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetMerchandiseQueryKey = (id: string) => {
  return [`/merchandises/${id}`] as const;
};
export const getGetMerchandiseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMerchandise>>,
  TError = ErrorType<GetMerchandise401 | GetMerchandise404 | GetMerchandise500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMerchandise>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMerchandiseQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMerchandise>>> = ({
    signal
  }) => getMerchandise(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMerchandise>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetMerchandiseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMerchandise>>
>;
export type GetMerchandiseQueryError = ErrorType<
  GetMerchandise401 | GetMerchandise404 | GetMerchandise500
>;
export function useGetMerchandise<
  TData = Awaited<ReturnType<typeof getMerchandise>>,
  TError = ErrorType<GetMerchandise401 | GetMerchandise404 | GetMerchandise500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMerchandise>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetMerchandiseQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an existing merchandise by ID
 */
export const updateMerchandise = (
  id: string,
  updateMerchandiseDto: UpdateMerchandiseDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateMerchandise200>(
    {
      url: `/merchandises/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMerchandiseDto
    },
    options
  );
};
export const getUpdateMerchandiseMutationOptions = <
  TError = ErrorType<
    UpdateMerchandise401 | UpdateMerchandise404 | UpdateMerchandise500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMerchandise>>,
    TError,
    {
      id: string;
      data: UpdateMerchandiseDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMerchandise>>,
  TError,
  {
    id: string;
    data: UpdateMerchandiseDto;
  },
  TContext
> => {
  const mutationKey = ['updateMerchandise'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMerchandise>>,
    {
      id: string;
      data: UpdateMerchandiseDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateMerchandise(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateMerchandiseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMerchandise>>
>;
export type UpdateMerchandiseMutationBody = UpdateMerchandiseDto;
export type UpdateMerchandiseMutationError = ErrorType<
  UpdateMerchandise401 | UpdateMerchandise404 | UpdateMerchandise500
>;
export const useUpdateMerchandise = <
  TError = ErrorType<
    UpdateMerchandise401 | UpdateMerchandise404 | UpdateMerchandise500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMerchandise>>,
    TError,
    {
      id: string;
      data: UpdateMerchandiseDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMerchandise>>,
  TError,
  {
    id: string;
    data: UpdateMerchandiseDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateMerchandiseMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete a merchandise by ID
 */
export const deleteMerchandise = (
  id: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteMerchandise200>(
    { url: `/merchandises/${id}`, method: 'DELETE' },
    options
  );
};
export const getDeleteMerchandiseMutationOptions = <
  TError = ErrorType<
    DeleteMerchandise401 | DeleteMerchandise404 | DeleteMerchandise500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMerchandise>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMerchandise>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationKey = ['deleteMerchandise'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMerchandise>>,
    {
      id: string;
    }
  > = (props) => {
    const { id } = props ?? {};
    return deleteMerchandise(id, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteMerchandiseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMerchandise>>
>;
export type DeleteMerchandiseMutationError = ErrorType<
  DeleteMerchandise401 | DeleteMerchandise404 | DeleteMerchandise500
>;
export const useDeleteMerchandise = <
  TError = ErrorType<
    DeleteMerchandise401 | DeleteMerchandise404 | DeleteMerchandise500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMerchandise>>,
    TError,
    {
      id: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMerchandise>>,
  TError,
  {
    id: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteMerchandiseMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve paginated list of orders (Admin only)
 */
export const getOrders = (
  params?: GetOrdersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetOrders200>(
    { url: `/orders`, method: 'GET', params, signal },
    options
  );
};
export const getGetOrdersQueryKey = (params?: GetOrdersParams) => {
  return [`/orders`, ...(params ? [params] : [])] as const;
};
export const getGetOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<GetOrders401 | GetOrders500>
>(
  params?: GetOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({
    signal
  }) => getOrders(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrders>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrders>>
>;
export type GetOrdersQueryError = ErrorType<GetOrders401 | GetOrders500>;
export function useGetOrders<
  TData = Awaited<ReturnType<typeof getOrders>>,
  TError = ErrorType<GetOrders401 | GetOrders500>
>(
  params?: GetOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetOrdersQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve an order by ID
 */
export const getOrder = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetOrder200>(
    { url: `/orders/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetOrderQueryKey = (id: string) => {
  return [`/orders/${id}`] as const;
};
export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<GetOrder401 | GetOrder404 | GetOrder500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(id);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal
  }) => getOrder(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: QueryKey;
  };
};
export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = ErrorType<
  GetOrder401 | GetOrder404 | GetOrder500
>;
export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<GetOrder401 | GetOrder404 | GetOrder500>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetOrderQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Complete an order by redeeming points for merchandise
 */
export const completeOrder = (
  completeOrderDto: CompleteOrderDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CompleteOrder200>(
    {
      url: `/orders/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: completeOrderDto,
      signal
    },
    options
  );
};
export const getCompleteOrderMutationOptions = <
  TError = ErrorType<CompleteOrder401 | CompleteOrder500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOrder>>,
    TError,
    {
      data: CompleteOrderDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeOrder>>,
  TError,
  {
    data: CompleteOrderDto;
  },
  TContext
> => {
  const mutationKey = ['completeOrder'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeOrder>>,
    {
      data: CompleteOrderDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return completeOrder(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CompleteOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeOrder>>
>;
export type CompleteOrderMutationBody = CompleteOrderDto;
export type CompleteOrderMutationError = ErrorType<
  CompleteOrder401 | CompleteOrder500
>;
export const useCompleteOrder = <
  TError = ErrorType<CompleteOrder401 | CompleteOrder500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOrder>>,
    TError,
    {
      data: CompleteOrderDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeOrder>>,
  TError,
  {
    data: CompleteOrderDto;
  },
  TContext
> => {
  const mutationOptions = getCompleteOrderMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Retrieve current user's orders with optional filtering by status, pagination, and sorting
 */
export const getMyOrders = (
  params?: GetMyOrdersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetMyOrders200>(
    { url: `/orders/my-orders`, method: 'GET', params, signal },
    options
  );
};
export const getGetMyOrdersQueryKey = (params?: GetMyOrdersParams) => {
  return [`/orders/my-orders`, ...(params ? [params] : [])] as const;
};
export const getGetMyOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyOrders>>,
  TError = ErrorType<GetMyOrders401 | GetMyOrders500>
>(
  params?: GetMyOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMyOrdersQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOrders>>> = ({
    signal
  }) => getMyOrders(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyOrders>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetMyOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyOrders>>
>;
export type GetMyOrdersQueryError = ErrorType<GetMyOrders401 | GetMyOrders500>;
export function useGetMyOrders<
  TData = Awaited<ReturnType<typeof getMyOrders>>,
  TError = ErrorType<GetMyOrders401 | GetMyOrders500>
>(
  params?: GetMyOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetMyOrdersQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve orders for a specific user (Admin only)
 */
export const getUserOrders = (
  userId: string,
  params?: GetUserOrdersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetUserOrders200>(
    { url: `/orders/user/${userId}`, method: 'GET', params, signal },
    options
  );
};
export const getGetUserOrdersQueryKey = (
  userId: string,
  params?: GetUserOrdersParams
) => {
  return [`/orders/user/${userId}`, ...(params ? [params] : [])] as const;
};
export const getGetUserOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserOrders>>,
  TError = ErrorType<GetUserOrders401 | GetUserOrders500>
>(
  userId: string,
  params?: GetUserOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUserOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey =
    queryOptions?.queryKey ?? getGetUserOrdersQueryKey(userId, params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserOrders>>> = ({
    signal
  }) => getUserOrders(userId, params, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserOrders>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetUserOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserOrders>>
>;
export type GetUserOrdersQueryError = ErrorType<
  GetUserOrders401 | GetUserOrders500
>;
export function useGetUserOrders<
  TData = Awaited<ReturnType<typeof getUserOrders>>,
  TError = ErrorType<GetUserOrders401 | GetUserOrders500>
>(
  userId: string,
  params?: GetUserOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUserOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetUserOrdersQueryOptions(userId, params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update an order status (Admin only)
 */
export const updateOrderStatus = (
  id: string,
  updateOrderStatusDto: UpdateOrderStatusDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateOrderStatus200>(
    {
      url: `/orders/${id}/status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateOrderStatusDto
    },
    options
  );
};
export const getUpdateOrderStatusMutationOptions = <
  TError = ErrorType<
    UpdateOrderStatus401 | UpdateOrderStatus404 | UpdateOrderStatus500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    {
      id: string;
      data: UpdateOrderStatusDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  {
    id: string;
    data: UpdateOrderStatusDto;
  },
  TContext
> => {
  const mutationKey = ['updateOrderStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    {
      id: string;
      data: UpdateOrderStatusDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateOrderStatus(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateOrderStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrderStatus>>
>;
export type UpdateOrderStatusMutationBody = UpdateOrderStatusDto;
export type UpdateOrderStatusMutationError = ErrorType<
  UpdateOrderStatus401 | UpdateOrderStatus404 | UpdateOrderStatus500
>;
export const useUpdateOrderStatus = <
  TError = ErrorType<
    UpdateOrderStatus401 | UpdateOrderStatus404 | UpdateOrderStatus500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    {
      id: string;
      data: UpdateOrderStatusDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  {
    id: string;
    data: UpdateOrderStatusDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateOrderStatusMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get challenges
 */
export const getChallenges = (
  params?: GetChallengesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetChallenges200>(
    { url: `/challenges`, method: 'GET', params, signal },
    options
  );
};
export const getGetChallengesQueryKey = (params?: GetChallengesParams) => {
  return [`/challenges`, ...(params ? [params] : [])] as const;
};
export const getGetChallengesQueryOptions = <
  TData = Awaited<ReturnType<typeof getChallenges>>,
  TError = ErrorType<GetChallenges401 | GetChallenges500>
>(
  params?: GetChallengesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetChallengesQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChallenges>>> = ({
    signal
  }) => getChallenges(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChallenges>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetChallengesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChallenges>>
>;
export type GetChallengesQueryError = ErrorType<
  GetChallenges401 | GetChallenges500
>;
export function useGetChallenges<
  TData = Awaited<ReturnType<typeof getChallenges>>,
  TError = ErrorType<GetChallenges401 | GetChallenges500>
>(
  params?: GetChallengesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetChallengesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Get neighborhood structures with associated challenges and completion status
 */
export const getNeighborhood = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetNeighborhood200>(
    { url: `/challenges/neighborhood`, method: 'GET', signal },
    options
  );
};
export const getGetNeighborhoodQueryKey = () => {
  return [`/challenges/neighborhood`] as const;
};
export const getGetNeighborhoodQueryOptions = <
  TData = Awaited<ReturnType<typeof getNeighborhood>>,
  TError = ErrorType<GetNeighborhood401 | GetNeighborhood500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNeighborhood>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetNeighborhoodQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNeighborhood>>> = ({
    signal
  }) => getNeighborhood(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNeighborhood>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetNeighborhoodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNeighborhood>>
>;
export type GetNeighborhoodQueryError = ErrorType<
  GetNeighborhood401 | GetNeighborhood500
>;
export function useGetNeighborhood<
  TData = Awaited<ReturnType<typeof getNeighborhood>>,
  TError = ErrorType<GetNeighborhood401 | GetNeighborhood500>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNeighborhood>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetNeighborhoodQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Get paginated list of challenges for admin management
 */
export const getAdminChallenges = (
  params?: GetAdminChallengesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetAdminChallenges200>(
    { url: `/challenges/admin/challenges`, method: 'GET', params, signal },
    options
  );
};
export const getGetAdminChallengesQueryKey = (
  params?: GetAdminChallengesParams
) => {
  return [`/challenges/admin/challenges`, ...(params ? [params] : [])] as const;
};
export const getGetAdminChallengesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminChallenges>>,
  TError = ErrorType<GetAdminChallenges401 | GetAdminChallenges500>
>(
  params?: GetAdminChallengesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey =
    queryOptions?.queryKey ?? getGetAdminChallengesQueryKey(params);
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminChallenges>>
  > = ({ signal }) => getAdminChallenges(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminChallenges>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetAdminChallengesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminChallenges>>
>;
export type GetAdminChallengesQueryError = ErrorType<
  GetAdminChallenges401 | GetAdminChallenges500
>;
export function useGetAdminChallenges<
  TData = Awaited<ReturnType<typeof getAdminChallenges>>,
  TError = ErrorType<GetAdminChallenges401 | GetAdminChallenges500>
>(
  params?: GetAdminChallengesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetAdminChallengesQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update challenge fields (image, title, tagline, description) - Admin only
 */
export const updateAdminChallenge = (
  id: string,
  updateAdminChallengeDto: UpdateAdminChallengeDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdateAdminChallenge200>(
    {
      url: `/challenges/admin/challenges/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAdminChallengeDto
    },
    options
  );
};
export const getUpdateAdminChallengeMutationOptions = <
  TError = ErrorType<
    UpdateAdminChallenge401 | UpdateAdminChallenge404 | UpdateAdminChallenge500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminChallenge>>,
    TError,
    {
      id: string;
      data: UpdateAdminChallengeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminChallenge>>,
  TError,
  {
    id: string;
    data: UpdateAdminChallengeDto;
  },
  TContext
> => {
  const mutationKey = ['updateAdminChallenge'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminChallenge>>,
    {
      id: string;
      data: UpdateAdminChallengeDto;
    }
  > = (props) => {
    const { id, data } = props ?? {};
    return updateAdminChallenge(id, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdateAdminChallengeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminChallenge>>
>;
export type UpdateAdminChallengeMutationBody = UpdateAdminChallengeDto;
export type UpdateAdminChallengeMutationError = ErrorType<
  UpdateAdminChallenge401 | UpdateAdminChallenge404 | UpdateAdminChallenge500
>;
export const useUpdateAdminChallenge = <
  TError = ErrorType<
    UpdateAdminChallenge401 | UpdateAdminChallenge404 | UpdateAdminChallenge500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminChallenge>>,
    TError,
    {
      id: string;
      data: UpdateAdminChallengeDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminChallenge>>,
  TError,
  {
    id: string;
    data: UpdateAdminChallengeDto;
  },
  TContext
> => {
  const mutationOptions = getUpdateAdminChallengeMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get challenge by ID with progress information
 */
export const getChallengeById = (
  id: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetChallengeById200>(
    { url: `/challenges/${id}`, method: 'GET', signal },
    options
  );
};
export const getGetChallengeByIdQueryKey = (id: string) => {
  return [`/challenges/${id}`] as const;
};
export const getGetChallengeByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getChallengeById>>,
  TError = ErrorType<
    GetChallengeById401 | GetChallengeById404 | GetChallengeById500
  >
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallengeById>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetChallengeByIdQueryKey(id);
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChallengeById>>
  > = ({ signal }) => getChallengeById(id, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChallengeById>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetChallengeByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChallengeById>>
>;
export type GetChallengeByIdQueryError = ErrorType<
  GetChallengeById401 | GetChallengeById404 | GetChallengeById500
>;
export function useGetChallengeById<
  TData = Awaited<ReturnType<typeof getChallengeById>>,
  TError = ErrorType<
    GetChallengeById401 | GetChallengeById404 | GetChallengeById500
  >
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChallengeById>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetChallengeByIdQueryOptions(id, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve all points configurations
 */
export const getAllPointsConfigurations = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetAllPointsConfigurations200>(
    { url: `/points-configuration`, method: 'GET', signal },
    options
  );
};
export const getGetAllPointsConfigurationsQueryKey = () => {
  return [`/points-configuration`] as const;
};
export const getGetAllPointsConfigurationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPointsConfigurations>>,
  TError = ErrorType<
    GetAllPointsConfigurations401 | GetAllPointsConfigurations500
  >
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllPointsConfigurations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey =
    queryOptions?.queryKey ?? getGetAllPointsConfigurationsQueryKey();
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPointsConfigurations>>
  > = ({ signal }) => getAllPointsConfigurations(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPointsConfigurations>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetAllPointsConfigurationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPointsConfigurations>>
>;
export type GetAllPointsConfigurationsQueryError = ErrorType<
  GetAllPointsConfigurations401 | GetAllPointsConfigurations500
>;
export function useGetAllPointsConfigurations<
  TData = Awaited<ReturnType<typeof getAllPointsConfigurations>>,
  TError = ErrorType<
    GetAllPointsConfigurations401 | GetAllPointsConfigurations500
  >
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllPointsConfigurations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetAllPointsConfigurationsQueryOptions(options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Retrieve points configuration for a specific object type
 */
export const getPointsConfigurationByObjectType = (
  objectType:
    | 'NOMINATION'
    | 'PROFILE'
    | 'NEED'
    | 'EVENT'
    | 'DAILY_GOOD'
    | 'GOOD_VIBE'
    | 'CHALLENGE'
    | 'RAFFLE'
    | 'CHALLENGE_GROUP'
    | 'STREAK'
    | 'STRUCTURE'
    | 'SHARE'
    | 'MERCHANDISE'
    | 'NONE',
  verb:
    | 'NONE'
    | 'SENT'
    | 'UPDATED'
    | 'DONATION_MADE'
    | 'REGISTERED'
    | 'COMPLETED'
    | 'SHARED'
    | 'STREAK'
    | 'ENTERED'
    | 'STARTED'
    | 'ATTENDED'
    | 'WON'
    | 'RECEIVED'
    | 'ADJUSTMENT',
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetPointsConfigurationByObjectType200>(
    {
      url: `/points-configuration/${objectType}/${verb}`,
      method: 'GET',
      signal
    },
    options
  );
};
export const getGetPointsConfigurationByObjectTypeQueryKey = (
  objectType:
    | 'NOMINATION'
    | 'PROFILE'
    | 'NEED'
    | 'EVENT'
    | 'DAILY_GOOD'
    | 'GOOD_VIBE'
    | 'CHALLENGE'
    | 'RAFFLE'
    | 'CHALLENGE_GROUP'
    | 'STREAK'
    | 'STRUCTURE'
    | 'SHARE'
    | 'MERCHANDISE'
    | 'NONE',
  verb:
    | 'NONE'
    | 'SENT'
    | 'UPDATED'
    | 'DONATION_MADE'
    | 'REGISTERED'
    | 'COMPLETED'
    | 'SHARED'
    | 'STREAK'
    | 'ENTERED'
    | 'STARTED'
    | 'ATTENDED'
    | 'WON'
    | 'RECEIVED'
    | 'ADJUSTMENT'
) => {
  return [`/points-configuration/${objectType}/${verb}`] as const;
};
export const getGetPointsConfigurationByObjectTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>,
  TError = ErrorType<
    | GetPointsConfigurationByObjectType401
    | GetPointsConfigurationByObjectType404
    | GetPointsConfigurationByObjectType500
  >
>(
  objectType:
    | 'NOMINATION'
    | 'PROFILE'
    | 'NEED'
    | 'EVENT'
    | 'DAILY_GOOD'
    | 'GOOD_VIBE'
    | 'CHALLENGE'
    | 'RAFFLE'
    | 'CHALLENGE_GROUP'
    | 'STREAK'
    | 'STRUCTURE'
    | 'SHARE'
    | 'MERCHANDISE'
    | 'NONE',
  verb:
    | 'NONE'
    | 'SENT'
    | 'UPDATED'
    | 'DONATION_MADE'
    | 'REGISTERED'
    | 'COMPLETED'
    | 'SHARED'
    | 'STREAK'
    | 'ENTERED'
    | 'STARTED'
    | 'ATTENDED'
    | 'WON'
    | 'RECEIVED'
    | 'ADJUSTMENT',
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey =
    queryOptions?.queryKey ??
    getGetPointsConfigurationByObjectTypeQueryKey(objectType, verb);
  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>
  > = ({ signal }) =>
    getPointsConfigurationByObjectType(
      objectType,
      verb,
      requestOptions,
      signal
    );
  return {
    queryKey,
    queryFn,
    enabled: !!(objectType && verb),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetPointsConfigurationByObjectTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>
>;
export type GetPointsConfigurationByObjectTypeQueryError = ErrorType<
  | GetPointsConfigurationByObjectType401
  | GetPointsConfigurationByObjectType404
  | GetPointsConfigurationByObjectType500
>;
export function useGetPointsConfigurationByObjectType<
  TData = Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>,
  TError = ErrorType<
    | GetPointsConfigurationByObjectType401
    | GetPointsConfigurationByObjectType404
    | GetPointsConfigurationByObjectType500
  >
>(
  objectType:
    | 'NOMINATION'
    | 'PROFILE'
    | 'NEED'
    | 'EVENT'
    | 'DAILY_GOOD'
    | 'GOOD_VIBE'
    | 'CHALLENGE'
    | 'RAFFLE'
    | 'CHALLENGE_GROUP'
    | 'STREAK'
    | 'STRUCTURE'
    | 'SHARE'
    | 'MERCHANDISE'
    | 'NONE',
  verb:
    | 'NONE'
    | 'SENT'
    | 'UPDATED'
    | 'DONATION_MADE'
    | 'REGISTERED'
    | 'COMPLETED'
    | 'SHARED'
    | 'STREAK'
    | 'ENTERED'
    | 'STARTED'
    | 'ATTENDED'
    | 'WON'
    | 'RECEIVED'
    | 'ADJUSTMENT',
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPointsConfigurationByObjectType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetPointsConfigurationByObjectTypeQueryOptions(
    objectType,
    verb,
    options
  );
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Update points configuration for a specific object type (Admin only)
 */
export const updatePointsConfiguration = (
  objectType:
    | 'NOMINATION'
    | 'PROFILE'
    | 'NEED'
    | 'EVENT'
    | 'DAILY_GOOD'
    | 'GOOD_VIBE'
    | 'CHALLENGE'
    | 'RAFFLE'
    | 'CHALLENGE_GROUP'
    | 'STREAK'
    | 'STRUCTURE'
    | 'SHARE'
    | 'MERCHANDISE'
    | 'NONE',
  verb:
    | 'NONE'
    | 'SENT'
    | 'UPDATED'
    | 'DONATION_MADE'
    | 'REGISTERED'
    | 'COMPLETED'
    | 'SHARED'
    | 'STREAK'
    | 'ENTERED'
    | 'STARTED'
    | 'ATTENDED'
    | 'WON'
    | 'RECEIVED'
    | 'ADJUSTMENT',
  updatePointsConfigurationDto: UpdatePointsConfigurationDto,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<UpdatePointsConfiguration200>(
    {
      url: `/points-configuration/${objectType}/${verb}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updatePointsConfigurationDto
    },
    options
  );
};
export const getUpdatePointsConfigurationMutationOptions = <
  TError = ErrorType<
    | UpdatePointsConfiguration401
    | UpdatePointsConfiguration404
    | UpdatePointsConfiguration500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePointsConfiguration>>,
    TError,
    {
      objectType:
        | 'NOMINATION'
        | 'PROFILE'
        | 'NEED'
        | 'EVENT'
        | 'DAILY_GOOD'
        | 'GOOD_VIBE'
        | 'CHALLENGE'
        | 'RAFFLE'
        | 'CHALLENGE_GROUP'
        | 'STREAK'
        | 'STRUCTURE'
        | 'SHARE'
        | 'MERCHANDISE'
        | 'NONE';
      verb:
        | 'NONE'
        | 'SENT'
        | 'UPDATED'
        | 'DONATION_MADE'
        | 'REGISTERED'
        | 'COMPLETED'
        | 'SHARED'
        | 'STREAK'
        | 'ENTERED'
        | 'STARTED'
        | 'ATTENDED'
        | 'WON'
        | 'RECEIVED'
        | 'ADJUSTMENT';
      data: UpdatePointsConfigurationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePointsConfiguration>>,
  TError,
  {
    objectType:
      | 'NOMINATION'
      | 'PROFILE'
      | 'NEED'
      | 'EVENT'
      | 'DAILY_GOOD'
      | 'GOOD_VIBE'
      | 'CHALLENGE'
      | 'RAFFLE'
      | 'CHALLENGE_GROUP'
      | 'STREAK'
      | 'STRUCTURE'
      | 'SHARE'
      | 'MERCHANDISE'
      | 'NONE';
    verb:
      | 'NONE'
      | 'SENT'
      | 'UPDATED'
      | 'DONATION_MADE'
      | 'REGISTERED'
      | 'COMPLETED'
      | 'SHARED'
      | 'STREAK'
      | 'ENTERED'
      | 'STARTED'
      | 'ATTENDED'
      | 'WON'
      | 'RECEIVED'
      | 'ADJUSTMENT';
    data: UpdatePointsConfigurationDto;
  },
  TContext
> => {
  const mutationKey = ['updatePointsConfiguration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePointsConfiguration>>,
    {
      objectType:
        | 'NOMINATION'
        | 'PROFILE'
        | 'NEED'
        | 'EVENT'
        | 'DAILY_GOOD'
        | 'GOOD_VIBE'
        | 'CHALLENGE'
        | 'RAFFLE'
        | 'CHALLENGE_GROUP'
        | 'STREAK'
        | 'STRUCTURE'
        | 'SHARE'
        | 'MERCHANDISE'
        | 'NONE';
      verb:
        | 'NONE'
        | 'SENT'
        | 'UPDATED'
        | 'DONATION_MADE'
        | 'REGISTERED'
        | 'COMPLETED'
        | 'SHARED'
        | 'STREAK'
        | 'ENTERED'
        | 'STARTED'
        | 'ATTENDED'
        | 'WON'
        | 'RECEIVED'
        | 'ADJUSTMENT';
      data: UpdatePointsConfigurationDto;
    }
  > = (props) => {
    const { objectType, verb, data } = props ?? {};
    return updatePointsConfiguration(objectType, verb, data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type UpdatePointsConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePointsConfiguration>>
>;
export type UpdatePointsConfigurationMutationBody =
  UpdatePointsConfigurationDto;
export type UpdatePointsConfigurationMutationError = ErrorType<
  | UpdatePointsConfiguration401
  | UpdatePointsConfiguration404
  | UpdatePointsConfiguration500
>;
export const useUpdatePointsConfiguration = <
  TError = ErrorType<
    | UpdatePointsConfiguration401
    | UpdatePointsConfiguration404
    | UpdatePointsConfiguration500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePointsConfiguration>>,
    TError,
    {
      objectType:
        | 'NOMINATION'
        | 'PROFILE'
        | 'NEED'
        | 'EVENT'
        | 'DAILY_GOOD'
        | 'GOOD_VIBE'
        | 'CHALLENGE'
        | 'RAFFLE'
        | 'CHALLENGE_GROUP'
        | 'STREAK'
        | 'STRUCTURE'
        | 'SHARE'
        | 'MERCHANDISE'
        | 'NONE';
      verb:
        | 'NONE'
        | 'SENT'
        | 'UPDATED'
        | 'DONATION_MADE'
        | 'REGISTERED'
        | 'COMPLETED'
        | 'SHARED'
        | 'STREAK'
        | 'ENTERED'
        | 'STARTED'
        | 'ATTENDED'
        | 'WON'
        | 'RECEIVED'
        | 'ADJUSTMENT';
      data: UpdatePointsConfigurationDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePointsConfiguration>>,
  TError,
  {
    objectType:
      | 'NOMINATION'
      | 'PROFILE'
      | 'NEED'
      | 'EVENT'
      | 'DAILY_GOOD'
      | 'GOOD_VIBE'
      | 'CHALLENGE'
      | 'RAFFLE'
      | 'CHALLENGE_GROUP'
      | 'STREAK'
      | 'STRUCTURE'
      | 'SHARE'
      | 'MERCHANDISE'
      | 'NONE';
    verb:
      | 'NONE'
      | 'SENT'
      | 'UPDATED'
      | 'DONATION_MADE'
      | 'REGISTERED'
      | 'COMPLETED'
      | 'SHARED'
      | 'STREAK'
      | 'ENTERED'
      | 'STARTED'
      | 'ATTENDED'
      | 'WON'
      | 'RECEIVED'
      | 'ADJUSTMENT';
    data: UpdatePointsConfigurationDto;
  },
  TContext
> => {
  const mutationOptions = getUpdatePointsConfigurationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Bookmark/favorite content
 */
export const createBookmark = (
  objectType: string,
  objectId: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<CreateBookmark200>(
    { url: `/bookmarks/${objectType}/${objectId}`, method: 'PUT' },
    options
  );
};
export const getCreateBookmarkMutationOptions = <
  TError = ErrorType<CreateBookmark401 | CreateBookmark500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBookmark>>,
    TError,
    {
      objectType: string;
      objectId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBookmark>>,
  TError,
  {
    objectType: string;
    objectId: string;
  },
  TContext
> => {
  const mutationKey = ['createBookmark'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBookmark>>,
    {
      objectType: string;
      objectId: string;
    }
  > = (props) => {
    const { objectType, objectId } = props ?? {};
    return createBookmark(objectType, objectId, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type CreateBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBookmark>>
>;
export type CreateBookmarkMutationError = ErrorType<
  CreateBookmark401 | CreateBookmark500
>;
export const useCreateBookmark = <
  TError = ErrorType<CreateBookmark401 | CreateBookmark500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBookmark>>,
    TError,
    {
      objectType: string;
      objectId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBookmark>>,
  TError,
  {
    objectType: string;
    objectId: string;
  },
  TContext
> => {
  const mutationOptions = getCreateBookmarkMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Remove bookmark/favorite from content
 */
export const deleteBookmark = (
  objectType: string,
  objectId: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<DeleteBookmark200>(
    { url: `/bookmarks/${objectType}/${objectId}`, method: 'DELETE' },
    options
  );
};
export const getDeleteBookmarkMutationOptions = <
  TError = ErrorType<DeleteBookmark401 | DeleteBookmark500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBookmark>>,
    TError,
    {
      objectType: string;
      objectId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBookmark>>,
  TError,
  {
    objectType: string;
    objectId: string;
  },
  TContext
> => {
  const mutationKey = ['deleteBookmark'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBookmark>>,
    {
      objectType: string;
      objectId: string;
    }
  > = (props) => {
    const { objectType, objectId } = props ?? {};
    return deleteBookmark(objectType, objectId, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type DeleteBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBookmark>>
>;
export type DeleteBookmarkMutationError = ErrorType<
  DeleteBookmark401 | DeleteBookmark500
>;
export const useDeleteBookmark = <
  TError = ErrorType<DeleteBookmark401 | DeleteBookmark500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBookmark>>,
    TError,
    {
      objectType: string;
      objectId: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBookmark>>,
  TError,
  {
    objectType: string;
    objectId: string;
  },
  TContext
> => {
  const mutationOptions = getDeleteBookmarkMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get user's bookmarked content with pagination and filtering
 */
export const getBookmarks = (
  params?: GetBookmarksParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GetBookmarks200>(
    { url: `/bookmarks`, method: 'GET', params, signal },
    options
  );
};
export const getGetBookmarksQueryKey = (params?: GetBookmarksParams) => {
  return [`/bookmarks`, ...(params ? [params] : [])] as const;
};
export const getGetBookmarksQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookmarks>>,
  TError = ErrorType<GetBookmarks401 | GetBookmarks500>
>(
  params?: GetBookmarksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookmarks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetBookmarksQueryKey(params);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookmarks>>> = ({
    signal
  }) => getBookmarks(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookmarks>>,
    TError,
    TData
  > & {
    queryKey: QueryKey;
  };
};
export type GetBookmarksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookmarks>>
>;
export type GetBookmarksQueryError = ErrorType<
  GetBookmarks401 | GetBookmarks500
>;
export function useGetBookmarks<
  TData = Awaited<ReturnType<typeof getBookmarks>>,
  TError = ErrorType<GetBookmarks401 | GetBookmarks500>
>(
  params?: GetBookmarksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookmarks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customAxios>;
  }
): UseQueryResult<TData, TError> & {
  queryKey: QueryKey;
} {
  const queryOptions = getGetBookmarksQueryOptions(params, options);
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Send a nomination and earn points
 */
export const sendNomination = (
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SendNomination200>(
    { url: `/nominations/send`, method: 'POST', signal },
    options
  );
};
export const getSendNominationMutationOptions = <
  TError = ErrorType<SendNomination400 | SendNomination401 | SendNomination500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendNomination>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendNomination>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['sendNomination'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendNomination>>,
    void
  > = () => {
    return sendNomination(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SendNominationMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendNomination>>
>;
export type SendNominationMutationError = ErrorType<
  SendNomination400 | SendNomination401 | SendNomination500
>;
export const useSendNomination = <
  TError = ErrorType<SendNomination400 | SendNomination401 | SendNomination500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendNomination>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendNomination>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSendNominationMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Attempts to claim nomination
 */
export const sentNominationHash = (
  nominationHash: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<SentNominationHash200>(
    { url: `/nominations/sent/${nominationHash}`, method: 'POST', signal },
    options
  );
};
export const getSentNominationHashMutationOptions = <
  TError = ErrorType<
    SentNominationHash401 | SentNominationHash404 | SentNominationHash500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sentNominationHash>>,
    TError,
    {
      nominationHash: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sentNominationHash>>,
  TError,
  {
    nominationHash: string;
  },
  TContext
> => {
  const mutationKey = ['sentNominationHash'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sentNominationHash>>,
    {
      nominationHash: string;
    }
  > = (props) => {
    const { nominationHash } = props ?? {};
    return sentNominationHash(nominationHash, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type SentNominationHashMutationResult = NonNullable<
  Awaited<ReturnType<typeof sentNominationHash>>
>;
export type SentNominationHashMutationError = ErrorType<
  SentNominationHash401 | SentNominationHash404 | SentNominationHash500
>;
export const useSentNominationHash = <
  TError = ErrorType<
    SentNominationHash401 | SentNominationHash404 | SentNominationHash500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sentNominationHash>>,
    TError,
    {
      nominationHash: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sentNominationHash>>,
  TError,
  {
    nominationHash: string;
  },
  TContext
> => {
  const mutationOptions = getSentNominationHashMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Claim points for being nominated
 */
export const claimNomination = (
  claimNominationRequestDto: ClaimNominationRequestDto,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClaimNomination200>(
    {
      url: `/nominations/claim`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: claimNominationRequestDto,
      signal
    },
    options
  );
};
export const getClaimNominationMutationOptions = <
  TError = ErrorType<
    | ClaimNomination400
    | ClaimNomination401
    | ClaimNomination404
    | ClaimNomination500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimNomination>>,
    TError,
    {
      data: ClaimNominationRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimNomination>>,
  TError,
  {
    data: ClaimNominationRequestDto;
  },
  TContext
> => {
  const mutationKey = ['claimNomination'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimNomination>>,
    {
      data: ClaimNominationRequestDto;
    }
  > = (props) => {
    const { data } = props ?? {};
    return claimNomination(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
export type ClaimNominationMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimNomination>>
>;
export type ClaimNominationMutationBody = ClaimNominationRequestDto;
export type ClaimNominationMutationError = ErrorType<
  | ClaimNomination400
  | ClaimNomination401
  | ClaimNomination404
  | ClaimNomination500
>;
export const useClaimNomination = <
  TError = ErrorType<
    | ClaimNomination400
    | ClaimNomination401
    | ClaimNomination404
    | ClaimNomination500
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimNomination>>,
    TError,
    {
      data: ClaimNominationRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationResult<
  Awaited<ReturnType<typeof claimNomination>>,
  TError,
  {
    data: ClaimNominationRequestDto;
  },
  TContext
> => {
  const mutationOptions = getClaimNominationMutationOptions(options);
  return useMutation(mutationOptions);
};
